export const pl = {
  admin: {
    title: "IRES Admin",
    noAvailableSections: "Nie udostępniono ci tutaj żadnych funkcji.",
      renoReview: {
        title: "Szybki przegląd RENO",
        filters: "Filtry",
        deviceTypes: "Typy urządzeń",
        startAtSerial: "Od urządzenia",
        allDeviceTypes: "Wszystkie",
        anyDevice: "Wszystkie",
        anyClient: "Wszyscy",
        noClients: "Nie znaleziono klientów",
        monthsSuffix: "mies.",
        ageOrActive: "Okres / status",
        maxAgeMonths: "Tylko suszenia z ostatnich",
        fromDate: "Od daty",
        activeOnly: "Tylko trwające suszenia",
        noAgeLimit: "Bez ograniczeń",
        matchingDryings: "Pasujące suszenia",
        countCapped: "ponad {0}",
        countApprox: "ok. {0}",
        countNone: "brak",
        countLoading: "wczytywanie …",
        alreadyReviewed: "Już przejrzane",
        ratingModeAll: "Wszystkie",
        ratingModeUnrated: "Tylko jeszcze nieocenione",
        ratingModeOnly: "Tylko ocenione przeze mnie",
        hideSeen: "Ukryj przeglądnięte przeze mnie",
        startReview: "Rozpocznij przegląd",
        noMatches: "Żadne suszenie nie pasuje do tych filtrów.",
        loading: "Ładowanie …",
        device: "Urządzenie",
        drying: "Suszenie",
        client: "Klient",
        program: "Program",
        dryingPosition: "Suszenie {0} z {1} dla tego urządzenia",
        chainStart: "Początek",
        chainEnd: "Koniec",
        previous: "Wstecz",
        next: "Dalej",
        atFirst: "Jesteś przy pierwszym suszeniu.",
        atLast: "Przejrzałeś wszystkie suszenia.",
        backToFilters: "Zmień filtry",
        startAtSerialHint: "Brak wyników od urządzenia „{0}”. Sprawdź numer seryjny.",
        loadFailed: "Nie udało się załadować suszenia.",
        hidden: {
          title: "Ukryte suszenia",
          none: "Nie ukryłeś żadnych suszeń.",
          hiddenAt: "Ukryto",
          restore: "Pokaż ponownie",
          restored: "Suszenie wróciło do Twojego przeglądu.",
          restoreFailed: "Nie udało się ponownie pokazać suszenia.",
          loadMore: "Wczytaj więcej",
        },
        rating: {
          suppress: "Nie pokazuj ponownie",
          previously: "Twoja ostatnia ocena: {0}.",
          suppressFailed: "Nie udało się ukryć suszenia.",
          saveFailed: "Nie udało się zapisać Twojej oceny.",
        },
        note: {
          commentPlaceholder: "Komentarz (opcjonalnie)",
          chainSuspect: "Sprawdź łańcuch",
          onlyChainSuspect: "Sprawdź łańcuch",
          onlyWithComment: "Komentarz",
          saveFailed: "Nie udało się zapisać Twojego komentarza.",
        },
        marks: {
          filterLabel: "Moje oznaczenia",
          onlySuppressed: "Ukryte",
        },
      },
    categories: {
      clients: "Klienci",
      production: "Produkcja",
      mira: "Mira",
    },
    sections: {
      clients: {
        title: "Klienci",
        description: "Przeszukuj wszystkich klientów i filtruj ich według typu, umowy i statusu.",
      },
      externalSystems: {
        title: "Systemy zewnętrzne",
        description: "Wszystkie systemy ERP i partnerskie z właścicielem, powiązanymi klientami i statusem.",
      },
      deviceReports: {
        title: "Raporty testowe",
        description: "Zobacz produkcyjne raporty testowe urządzenia.",
      },
      pdfTemplates: {
        title: "Szablony PDF",
        description: "Wspólne szablony PDF, które mandanci mogą przejąć. Szablony mandanta znajdziesz w jego widoku szczegółów.",
      },
      infoConfig: {
        title: "Opisy",
        description: "Wszystkie wersje formularzy projektu, ich cele i sprawdzone publikowanie nowych wersji.",
      },
      miraInsurers: {
        title: "Ubezpieczyciele",
        description: "Ubezpieczyciele, do których Mira przypisuje projekty, wraz z ich zapisami.",
      },
      miraInsurerReview: {
        title: "Niezidentyfikowani ubezpieczyciele",
        description: "Nazwy ubezpieczycieli, których Mira nie mogła przypisać, pogrupowane do przypisania.",
      },
      miraCompanies: {
        title: "Firmy",
        description: "Którzy klienci liczą się w porównaniu rynkowym Miry jako jedna firma.",
      },
      miraExceptions: {
        title: "Wyjątki Miry",
        description: "Zakończenia i zgody wpisane z opóźnieniem, które Mira pomija w czasach trwania.",
      },
    },
    externalSystems: {
      search: "Szukaj systemów zewnętrznych",
      none: "Brak systemów zewnętrznych.",
      moreClients: "{0} i {1} innych",
      filters: {
        ALL: "Wszystkie",
      },
    },
    miraCompanies: {
      title: "Firmy",
      search: "Szukaj firmy lub klienta",
      create: "Nowa firma",
      hint: "Firma z kilkoma klientami liczy się w porównaniu rynkowym Miry raz, z jedną wartością dla wszystkich jej klientów. Grupa (klient główny) liczy się raz sama z siebie; klient bez firmy liczy się osobno.",
      loadFailed: "Nie udało się wczytać firm.",
      none: "Brak firm",
      saved: "Firma zapisana",
      retiredChip: "Wycofana",
      effectNote: "Dotyczy porównania rynkowego wszystkich klientów od następnego nocnego przebiegu Miry.",
      lastChange: "ostatnia zmiana {0}, {1}",
      clientCount: "Klienci: {0}",
      moreClients: "{0} i {1} więcej",
      takenBy: "należy już do firmy {0}",
      masterNote: "Klient główny: obejmuje klientów swojej grupy",
      inGroup: "dochodzi razem z klientem głównym",
      isViewingClient: "pokazuje firmę w Mirze",
      viewerTakenBy: "pokazuje już firmę {0}",
      viewingClientLine: "Widok w Mirze: {0}",
      groupChip: "Grupa",
      groupMembers: "Objęci przez klienta głównego: {0}",
      filters: {
        ACTIVE: "Aktywne",
        RETIRED: "Wycofane",
        ALL: "Wszystkie",
      },
      fields: {
        name: "Nazwa",
        clients: "Klienci",
        retired: "Wycofana",
        viewingClient: "Widok w Mirze",
      },
      hints: {
        clients: "Co najmniej dwóch albo sam klient główny. Klient główny obejmuje klientów swojej grupy; każda grupa jest już sama firmą.",
        retired: "Wycofana firma już się nie liczy; jej klienci liczą się wtedy znowu osobno.",
        viewingClient: "Klient, który pokazuje firmę w Mirze jak grupę. Nie liczy się do jej klientów.",
      },
      fieldErrors: {
        required: "Pole obowiązkowe",
        clients: "Co najmniej dwóch klientów lub jeden klient główny",
      },
      dialog: {
        viewTitle: "Firma",
        editTitle: "Edytuj firmę",
        createTitle: "Nowa firma",
      },
      errors: {
        NO_COMPANY: "Ta firma już nie istnieje.",
        NO_CLIENT: "Jeden z klientów już nie istnieje.",
        CHANGED_MEANWHILE: "Firma została w międzyczasie zmieniona. Lista zostanie wczytana ponownie.",
        INVALID_NAME: "Nazwa jest wymagana.",
        INVALID_ACCOUNTS: "Wybierz co najmniej dwóch klientów lub jednego klienta głównego.",
        CONFLICT: "{0} należy już do innej firmy.",
        INVALID_VIEWER: "Klient dla widoku już nie istnieje.",
        VIEWER_IS_ACCOUNT: "Klient dla widoku nie może należeć do klientów firmy.",
        VIEWER_IS_GROUP: "Klient główny z własną grupą nie może pokazywać firmy.",
        VIEWER_TAKEN: "Ten klient pokazuje już firmę {0}.",
        FAILED: "Zapis nie powiódł się.",
      },
    },
    miraExceptions: {
      title: "Wyjątki Miry",
      search: "Szukaj klienta lub powodu",
      create: "Nowy wyjątek",
      hint: "Gdy klient wpisał zdarzenie po fakcie (zgody wpisane później hurtowo, stare projekty zamknięte naraz), Mira pomija te projekty w czasach trwania opartych na tym zdarzeniu i podaje ich liczbę na kafelku. Liczniki pozostają bez zmian.",
      loadFailed: "Nie udało się wczytać wyjątków.",
      none: "Brak wyjątków",
      saved: "Wyjątek zapisany",
      retiredChip: "Wycofany",
      effectNote: "Dotyczy wskaźników tego klienta (i jego grupy lub firmy) od następnego nocnego przebiegu Miry.",
      lastChange: "ostatnia zmiana {0}, {1}",
      filters: {
        ACTIVE: "Aktywne",
        RETIRED: "Wycofane",
        ALL: "Wszystkie",
      },
      columns: {
        range: "Okres",
      },
      fields: {
        client: "Klient",
        event: "Wpisane z opóźnieniem",
        from: "Od",
        to: "Do",
        reason: "Powód",
        retired: "Wycofany",
      },
      events: {
        PROJECT_END: "Zakończenie projektu",
        OFFER_ANSWER: "Zgoda (odpowiedź ubezpieczyciela)",
      },
      eventFigures: {
        PROJECT_END: "Pomija projekty zakończone w okresie po co najmniej 30 dniach bez zapisanej pracy w średnim czasie projektu i czasie do zakończenia projektu, razem ze zgodą wpisaną przy zakończeniu.",
        OFFER_ANSWER: "Pomija zgody wpisane w okresie przy zakończeniu projektu (osuszanych lub długo nieaktywnych) w czasie zgody, od oceny szkody do zgody i od zgody do rozpoczęcia osuszania / odbudowy.",
      },
      hints: {
        reason: "Widoczne tylko w IRES Admin Client.",
        retired: "Wycofany wyjątek przestaje obowiązywać; projekty znowu się liczą.",
      },
      fieldErrors: {
        required: "Pole obowiązkowe",
        range: "Koniec jest przed początkiem.",
      },
      dialog: {
        viewTitle: "Wyjątek Miry",
        editTitle: "Edytuj wyjątek Miry",
        createTitle: "Nowy wyjątek Miry",
      },
      suggestions: {
        title: "Propozycje Miry",
        hint: "Dni, w których klient wpisał z opóźnieniem wiele zakończeń lub zgód, znalezione w nocnym przebiegu Miry. Przejmij tworzy z propozycji wyjątek, Odrzuć ukrywa propozycję.",
        entriesTitle: "Wyjątki",
        takeOver: "Przejmij",
        dismissAction: "Odrzuć",
        dismissed: "Propozycja odrzucona",
        groupCount: "Propozycje: {0} | Propozycje: {0}",
        columns: {
          late: "Z opóźnieniem / razem",
          mean: "Średnia z → bez",
          median: "Mediana z → bez",
        },
        eventsShort: {
          PROJECT_END: "Zakończenie projektu",
          OFFER_ANSWER: "Zgoda",
        },
        change: "{0} → {1} dni",
        figure: {
          PROJECT_END: "Czas trwania projektu {0}: średnio {1} dni, bez tych zakończeń {2} dni (mediana {3} → {4})",
          OFFER_ANSWER: "Czas zatwierdzenia {0}: średnio {1} dni, bez tych zgód {2} dni (mediana {3} → {4})",
        },
        dismiss: {
          title: "Odrzuć propozycję",
          action: "Odrzuć",
          reason: "Powód",
        },
        errors: {
          NO_SUGGESTION: "Ta propozycja już nie istnieje. Lista zostanie wczytana ponownie.",
          CHANGED_MEANWHILE: "Propozycja została w międzyczasie zmieniona. Lista zostanie wczytana ponownie.",
          INVALID_REASON: "Podaj powód.",
          FAILED: "Odrzucenie nie powiodło się.",
        },
      },
      errors: {
        NO_EXCEPTION: "Ten wyjątek już nie istnieje.",
        NO_CLIENT: "Ten klient nie istnieje.",
        CHANGED_MEANWHILE: "Wyjątek został w międzyczasie zmieniony. Lista zostanie wczytana ponownie.",
        INVALID_EVENT: "Wybierz, co wpisano z opóźnieniem.",
        INVALID_RANGE: "Okres jest nieprawidłowy.",
        INVALID_REASON: "Podaj powód.",
        FAILED: "Zapis nie powiódł się.",
      },
    },
    miraInsurers: {
      title: "Ubezpieczyciele",
      search: "Szukaj ubezpieczyciela",
      create: "Nowy ubezpieczyciel",
      loadFailed: "Nie udało się wczytać ubezpieczycieli.",
      none: "Brak ubezpieczycieli",
      saved: "Ubezpieczyciel zapisany",
      retiredChip: "Wycofany",
      effectNote: "Dotyczy wskaźników ubezpieczycieli wszystkich klientów od następnego nocnego przebiegu Miry.",
      mdisKey: "Klucz MDIS: {0}",
      lastChange: "ostatnio zmieniono {0}, {1}",
      filters: {
        ACTIVE: "Aktywni",
        RETIRED: "Wycofani",
        ALL: "Wszyscy",
      },
      columns: {
        origin: "Pochodzenie",
        spellings: "Zapisy",
      },
      origins: {
        MDIS: "Z listy ubezpieczycieli MDIS",
        IRES: "Dodany przez IRES",
      },
      originsShort: {
        MDIS: "MDIS",
        IRES: "IRES",
      },
      fields: {
        key: "Klucz",
        shortName: "Nazwa skrócona",
        name: "Nazwa",
        spellings: "Inne zapisy",
        words: "Słowa rozpoznające",
        retired: "Wycofany",
      },
      hints: {
        key: "Od 2 do 12 wielkich liter lub cyfr. Możesz go zmienić w każdej chwili; liczby Miry pozostają bez zmian.",
        spellings: "Jeden w wierszu. Wielkość liter, umlauty i interpunkcja nie mają znaczenia.",
        words: "Jedno w wierszu, co najmniej trzy znaki: rozpoznaje ubezpieczyciela wszędzie, gdzie słowo występuje w nazwie.",
        retired: "Wycofany ubezpieczyciel niczego już nie rozpoznaje; jego projekty liczą się wtedy jako niezidentyfikowane.",
      },
      fieldErrors: {
        key: "Od 2 do 12 wielkich liter lub cyfr",
        required: "Pole wymagane",
      },
      dialog: {
        viewTitle: "Ubezpieczyciel",
        editTitle: "Edytuj ubezpieczyciela",
        createTitle: "Nowy ubezpieczyciel",
      },
      errors: {
        KEY_TAKEN: "Ten klucz już istnieje.",
        NO_INSURER: "Ten ubezpieczyciel nie istnieje lub jest wycofany.",
        CHANGED_MEANWHILE: "Ubezpieczyciel został w międzyczasie zmieniony. Lista zostanie wczytana ponownie.",
        INVALID_KEY: "Klucz jest nieprawidłowy.",
        INVALID_NAME: "Nazwa skrócona i nazwa są wymagane.",
        INVALID_SPELLINGS: "Zapisy są nieprawidłowe.",
        INVALID_TEXTS: "Wybierz co najmniej jeden zapis.",
        INVALID_MERGE: "Ubezpieczyciel nie może zostać scalony sam ze sobą.",
        CONFLICT: "„{0}” należałby do kilku ubezpieczycieli ({1}).",
        CONFLICT_NOT_INSURER: "„{0}” nie może jednocześnie należeć do {1} i liczyć się jako „Brak ubezpieczyciela”.",
        FAILED: "Zapis nie powiódł się.",
      },
      rowActions: "Akcje",
      mergedInto: "Scalono z {0}",
      move: {
        menu: "Przenieś zapisy",
        title: "Przenieś zapisy ubezpieczyciela {0}",
        spellings: "Zapisy",
        words: "Słowa rozpoznawania",
        toInsurer: "Do innego ubezpieczyciela",
        toNewInsurer: "Do nowego ubezpieczyciela",
        notInsurer: "Brak ubezpieczyciela",
        release: "Ponownie otwarte (niezidentyfikowane)",
        insurer: "Ubezpieczyciel",
        action: "Przenieś",
        done: "Przeniesiono",
        effectInsurer: "Dotyczy wszystkich klientów: od następnego nocnego przebiegu projekty z tymi zapisami nie liczą się już dla {0}, lecz dla {1}.",
        effectNotInsurer: "Dotyczy wszystkich klientów: od następnego nocnego przebiegu projekty z tymi zapisami nie liczą się już dla {0}, lecz jako „Brak ubezpieczyciela”.",
        effectRelease: "Dotyczy wszystkich klientów: od następnego nocnego przebiegu projekty z tymi zapisami nie liczą się już dla {0}, lecz jako niezidentyfikowane. W Niezidentyfikowanych ubezpieczycielach pojawią się dopiero po tym przebiegu.",
      },
      merge: {
        menu: "Scal",
        title: "Scal ubezpieczycieli",
        intro: "{0} ({1}) zostaje scalony z innym ubezpieczycielem.",
        into: "Scal z",
        action: "Scal",
        done: "Scalono",
        effect: "Dotyczy wszystkich klientów: {0} zostaje wycofany. Jego nazwy, klucze, zapisy i słowa rozpoznawania należą wtedy do {1}, a jego projekty liczą się dla {1} od następnego nocnego przebiegu.",
      },
    },
    miraInsurerReview: {
      title: "Niezidentyfikowani ubezpieczyciele",
      search: "Szukaj zapisu",
      loadedAt: "Stan: {0}",
      suggestionsAt: "Propozycje z {0}",
      loadFailed: "Nie udało się wczytać listy.",
      views: {
        OPEN: "Otwarte",
        SUGGESTED: "Z propozycją",
        NOT_INSURER: "Brak ubezpieczyciela",
      },
      headings: {
        OPEN: "Grupy",
        SUGGESTED: "Grupy z propozycją",
        NOT_INSURER: "Brak ubezpieczyciela",
      },
      hints: {
        OPEN: "Nazwy, których Mira nie mogła przypisać do ubezpieczyciela w ostatnim nocnym przebiegu, pogrupowane, największe najpierw. Decyzja obowiązuje w Mirze od następnego przebiegu.",
        SUGGESTED: "Grupy, dla których Mira ma propozycję. Haczyk otwiera okno już wypełnione; nic nie zostanie zapisane przed jego przyciskiem. Krzyżyk odrzuca propozycję.",
        NOT_INSURER: "Zapisy uznane za „Brak ubezpieczyciela”. W Mirze nie liczą się ani jako rozpoznane, ani jako niezidentyfikowane.",
      },
      none: {
        OPEN: "Brak otwartych grup",
        SUGGESTED: "Brak otwartych propozycji",
        NOT_INSURER: "Żaden zapis nie został jeszcze uznany za „Brak ubezpieczyciela”",
      },
      columns: {
        spellings: "Zapisy",
        projects: "Projekty",
        clients: "Klienci",
      },
      moreSpellings: "{0} i {1} innych",
      droppedTexts: "{0} rzadko używanych zapisów nie zmieściło się na liście i ich tu brakuje.",
      release: "Cofnij",
      releaseConfirm: {
        title: "Cofnij decyzję",
        message: "„{0}” od następnego przebiegu Miry znów liczy się jako niezidentyfikowany.",
      },
      released: "Decyzja cofnięta",
      decided: "Zdecydowano",
      decision: {
        title: "Przypisz grupę",
        spellings: "Zapisy",
        spellingWithCount: "{0} (jeden projekt) | {0} ({1} projekty)",
        toInsurer: "Przypisz do ubezpieczyciela",
        toNewInsurer: "Przypisz do nowego ubezpieczyciela",
        notInsurer: "Brak ubezpieczyciela (nieznany, pośrednik, bank, test …)",
        insurer: "Ubezpieczyciel",
        apply: "Przypisz",
        next: "Dalej",
        nextNewInsurer: "W następnym kroku tworzysz ubezpieczyciela. Zapisy są tam już wpisane.",
        effectInsurer: "Dotyczy wszystkich klientów: od następnego nocnego przebiegu projekty z tymi zapisami liczą się dla {0}.",
        effectNotInsurer: "Dotyczy wszystkich klientów: od następnego nocnego przebiegu projekty z tymi zapisami liczą się jako „Brak ubezpieczyciela” i już nie do wskaźnika przypisania.",
      },
      suggestion: {
        insurer: "Propozycja: {0} ({1})",
        newInsurer: "Propozycja: nowy ubezpieczyciel {0} ({1})",
        notInsurer: "Propozycja: Brak ubezpieczyciela",
        unsure: "niepewne",
        takeOver: "Przejmij",
        dismissAction: "Odrzuć",
        dismissed: "Propozycja odrzucona",
        dismiss: {
          title: "Odrzuć propozycję",
          action: "Odrzuć",
          reason: "Powód",
        },
        errors: {
          NO_SUGGESTION: "Ta propozycja już nie istnieje. Lista zostanie wczytana ponownie.",
          CHANGED_MEANWHILE: "Propozycje zostały w międzyczasie ponownie wczytane. Lista zostanie wczytana ponownie.",
          INVALID_REASON: "Podaj powód.",
          FAILED: "Odrzucenie nie powiodło się.",
        },
      },
    },
    clients: {
      title: "Klienci",
      counts: {
        all: "Klienci",
      },
      search: "Nazwa, skrót lub numer klienta",
      masterClient: "Master",
      helperFunctions: {
        recalculateAllDryings: {
          button: "Przelicz wszystkie osuszania",
          description: "Przelicza prognozy ASSIST dla wszystkich osuszań tego klienta najnowszym modelem.",
          confirmTitle: "Przeliczyć wszystkie osuszania?",
          confirmMessage: "Prognozy ASSIST dla wszystkich osuszań tego klienta zostaną przeliczone najnowszym modelem. Może to chwilę potrwać.",
          confirmAccept: "Przelicz",
          started: "Przeliczanie zostało uruchomione.",
          alreadyRunning: "Przeliczanie jest już uruchomione.",
          noOp: "Nie uruchomiono przeliczania (funkcja może nie być aktywna dla tego klienta).",
          error: "Błąd podczas uruchamiania przeliczania: {0}",
          failed: "Nie udało się uruchomić przeliczania.",
          statusStarted: "Uruchomione",
          statusAlreadyRunning: "Już trwa",
          statusNoOp: "Nic do zrobienia",
          refusals: {
            INVALID: "Nie udało się uruchomić przeliczania.",
            NO_CLIENT: "Ten klient już nie istnieje.",
            DELETED_CLIENT: "Dla usuniętego klienta nie można nic przeliczyć.",
            SHARED_LOGIN: "Przy wspólnym loginie administratora IRES nie można nic zmienić. Zaloguj się własnym użytkownikiem.",
            PERMISSION_DENIED: "Nie masz do tego uprawnień.",
          },
        },
      },
      changes: {
        title: "Historia",
        loadFailed: "Nie udało się wczytać historii.",
        none: "W IRES Admin Client nie zmieniono jeszcze niczego u tego klienta.",
        showMore: "Pokaż więcej",
        followsGlobalTarget: "Wersja globalna",
        everyProjectType: "Wszystkie typy projektów z produktów",
        filters: {
          CLIENT_LOGIN: "Logowania jako klient",
        },
        groups: {
          INFO_CONFIG_TARGET: "Opis",
          CLIENT_LOGIN: "Zalogowano jako klient",
          CREATED: "Utworzono",
        },
        fields: {
          membersAdded: "Dodani członkowie",
          membersRemoved: "Usunięci członkowie",
          serviceContractSince: "Umowa serwisowa FW / konfiguracja od",
          warrantyExtensionSince: "Przedłużenie gwarancji paneli od",
          allowedProjectTypeIds: "Typy projektów (IRES)",
          activeProjectTypeIds: "Aktywne u klienta",
          enabledFunctions: "Włączone funkcje",
        },
      },
      contracts: {
        editTitle: "Edytuj umowy",
        since: "Od",
        saved: "Zapisano umowy.",
        saveFailed: "Nie udało się zapisać umów.",
      },
      testSettings: {
        editTitle: "Edytuj test",
        saved: "Test zapisany.",
        saveFailed: "Nie udało się zapisać testu.",
        usersLoadFailed: "Nie udało się wczytać użytkowników.",
        errors: {
          UNKNOWN_TEST_USER: "Wybrany użytkownik testowy nie jest aktywnym użytkownikiem tego mandanta.",
        },
      },
      masterData: {
        clientName: "Nazwa",
        houseNumber: "Numer domu",
        editTitle: "Edytuj dane podstawowe",
        projectNumberPrefixKept: "Skrót jest tylko oznaczeniem: numery projektów IRES tego klienta nadal zaczynają się od {0}.",
        iresTypeWarning: "Klient typu IRES ma dostęp do danych wszystkich klientów. Zmień typ klienta tylko wtedy, gdy jest to zamierzone.",
        saved: "Zapisano dane podstawowe.",
        fieldErrors: {
          required: "Pole wymagane",
          tooLong: "Maksymalnie 100 znaków",
          prefixLength: "Dokładnie 4 znaki",
        },
        errors: {
          CHANGED_MEANWHILE: "Klient został w międzyczasie zmieniony. Aktualne dane zostały ponownie wczytane, wprowadź zmianę jeszcze raz.",
          PREFIX_TAKEN: "Inny klient ma już ten skrót.",
          INVALID_VALUE: "Jedno pole jest nieprawidłowe.",
          NO_CLIENT: "Ten klient już nie istnieje.",
          FAILED: "Nie udało się zapisać danych podstawowych.",
        },
      },
      group: {
        editTitle: "Edytuj grupę",
        hasMembersHint: "Klient MASTER z członkami pozostaje nim, dopóki nie usuniesz wszystkich członków.",
        clientsLoadFailed: "Nie udało się wczytać klientów.",
        inactive: "(nieaktywny)",
        deleted: "(usunięty)",
        thisClient: "ten klient",
        overwriteTitle: "Nadpisać ustawienia?",
        overwriteMessage: "Ustawienia klienta {0} zastąpią wszystkie ustawienia tego klienta MASTER.",
        overwriteAccept: "Nadpisz",
        saved: "Grupa zapisana.",
        saveFailed: "Nie udało się zapisać grupy.",
        migrateSharedUsers: "Migruj współdzielonych użytkowników",
        migrateSharedUsersMessage: "Współdzielone adresy e-mail grupy staną się współdzielonymi użytkownikami grupy. Tej operacji nie można cofnąć.",
        migrateSharedUsersAccept: "Migruj",
        migratedSharedUsers: "Zmigrowano współdzielonych użytkowników: {0}.",
        noSharedUsersToMigrate: "Wszyscy współdzieleni użytkownicy są już zmigrowani albo nie ma żadnych.",
        migrateSharedUsersFailed: "Nie udało się zmigrować współdzielonych użytkowników.",
        refusals: {
          INVALID: "Nie udało się zapisać grupy.",
          NO_CLIENT: "Ten klient już nie istnieje.",
          DELETED_CLIENT: "Nie można zmienić grupy usuniętego klienta.",
          CHANGED_MEANWHILE: "Grupa została w międzyczasie zmieniona. Widok został ponownie wczytany.",
          IS_MEMBER: "Członek grupy nie może zostać klientem MASTER.",
          HAS_MEMBERS: "Najpierw usuń wszystkich członków.",
          NOT_A_CANDIDATE: "Ci klienci nie mogą zostać członkami: {0}",
          NOT_A_MEMBER: "Ustawienia można przejąć tylko od członka.",
          DUPLICATE_BRANCH_NUMBERS: "Numer oddziału {0} występuje u {1} i u {2}.",
          SHARED_LOGIN: "Za pomocą wspólnego loginu administratora IRES nie można niczego zmienić. Zaloguj się własnym użytkownikiem.",
        },
      },
      products: {
        editTitle: "Edytuj produkty",
        saved: "Produkty zapisane.",
        saveFailed: "Nie udało się zapisać produktów.",
        saveWarning: "Przy zapisaniu zostanie zaktualizowany wybór produktu (stary), który odczytują IRES Project, IRES Work i IRES Office, a licencje zostaną przeliczone na nowo.",
        derivedCaption: "Nadal wyprowadzone z wyboru produktu i jeszcze niezapisane.",
        choices: {
          DEVICES_ONLY_WEBSITE: "Portal urządzeń",
          WEBSITE: "Portal projektów",
          DEFAULT: "Manager projektów",
          PROJECT_OPTION: "Opcja projektu",
        },
        explanations: {
          officeDeviceAssignment: "Projekty GZ i GL w IRES Office. Samo IRES Office jest zawsze dostępne.",
          project: "Zarządzanie projektami w IRES Project.",
          work: "Zarządzanie urządzeniami w aplikacji IRES Work. Bez IRES Work nikt u klienta nie może zalogować się do IRES Work.",
          interface: "Interfejs REST do systemu zewnętrznego.",
        },
        errors: {
          CHANGED_MEANWHILE: "Produkty zostały w międzyczasie zmienione. Widok został wczytany ponownie.",
          INVALID_CLIENT: "Ten klient nie może mieć produktów.",
          INVALID: "Nieprawidłowy wybór produktu.",
          NO_CLIENT: "Tego klienta już nie ma.",
          DELETED_CLIENT: "Produktów usuniętego klienta nie można zmienić.",
          SHARED_LOGIN: "Przy wspólnym loginie administratora IRES nic nie można zmienić. Zaloguj się własnym użytkownikiem.",
          FAILED: "Nie udało się zapisać produktów.",
        },
      },
      projectTypes: {
        editTitle: "Edytuj typy projektów",
        explanation: "Które typy projektów ze swoich produktów otrzymuje klient. Odznaczonych typów IRES Office, IRES Project, IRES Work i interfejsy już nie oferują.",
        notRestricted: "Bez ograniczeń: klient otrzymuje każdy typ projektu ze swoich produktów.",
        followsMaster: "Ustalone u klienta MASTER",
        activeInClientTable: "aktywny u klienta",
        inactiveInClientTable: "nieaktywny u klienta",
        atLeastOne: "Wybierz co najmniej jeden typ projektu.",
        withdrawWarning: "Przy zapisie każdy odznaczony typ projektu zostanie wyłączony w możliwych typach projektów klienta, aby żadna aplikacja już go nie oferowała. Istniejące projekty pozostają bez zmian.",
        withdrawWarningMaster: "Dotyczy to także członków, którzy korzystają z ustawień projektów tego klienta MASTER.",
        allowNote: "Klient może potem włączyć nowy typ projektu w Ustawieniach przetwarzania projektu.",
        saved: "Typy projektów zapisane.",
        errors: {
          CHANGED_MEANWHILE: "Typy projektów zostały w międzyczasie zmienione. Widok został wczytany ponownie.",
          INVALID_CLIENT: "Ten klient nie może mieć typów projektów.",
          INVALID: "Nieprawidłowy wybór typów projektów.",
          EMPTY: "Wybierz co najmniej jeden typ projektu.",
          NO_CLIENT: "Tego klienta już nie ma.",
          DELETED_CLIENT: "Nie można zmienić typów projektów usuniętego klienta.",
          FOLLOWS_MASTER: "Ten klient korzysta z ustawień projektów swojego klienta MASTER. Zmień typy projektów tam.",
          SHARED_LOGIN: "Przy wspólnym loginie administratora IRES nic nie można zmienić. Zaloguj się własnym użytkownikiem.",
          FAILED: "Nie udało się zapisać typów projektów.",
        },
      },
      projectOrganisation: {
        editTitle: "Edytuj organizację projektów",
        followsMaster: "Ustalone u klienta MASTER",
        notStored: "Nie zapisano: aplikacje korzystają z ustawień domyślnych, jak pokazano tutaj.",
        reachNote: "Obowiązuje po zapisaniu w IRES Office, IRES Project, IRES Work i interfejsie.",
        reachNoteMaster: "Dotyczy to także członków, którzy korzystają z ustawień projektów tego klienta MASTER.",
        saved: "Organizacja projektów zapisana.",
        errors: {
          CHANGED_MEANWHILE: "Organizacja projektów została w międzyczasie zmieniona. Widok został wczytany ponownie.",
          INVALID_CLIENT: "Ten klient nie może mieć organizacji projektów.",
          INVALID: "Nieprawidłowy wybór. Terminy i zakończenie projektu wymagają co najmniej jednej aplikacji.",
          NO_CLIENT: "Tego klienta już nie ma.",
          DELETED_CLIENT: "Nie można zmienić organizacji projektów usuniętego klienta.",
          FOLLOWS_MASTER: "Ten klient korzysta z ustawień projektów swojego klienta MASTER. Zmień organizację projektów tam.",
          NO_PROJECTS: "Produkty tego klienta nie obejmują projektów.",
          SHARED_LOGIN: "Przy wspólnym loginie administratora IRES nic nie można zmienić. Zaloguj się własnym użytkownikiem.",
          FAILED: "Nie udało się zapisać organizacji projektów.",
        },
      },
      systemConfiguration: {
        editTitle: "Edytuj konfigurację systemu",
        followsMaster: "Ustalone u klienta MASTER",
        notStored: "Nie zapisano: IRES Office korzysta ze starszych ustawień klienta, jak pokazano tutaj.",
        reachNote: "Po zapisaniu obowiązuje dla wszystkich użytkowników tego klienta.",
        reachNoteMaster: "Dotyczy to także członków, którzy korzystają z konfiguracji systemu tego klienta MASTER.",
        saved: "Konfiguracja systemu zapisana.",
        assistScope: "Zakres ASSIST",
        effectsFailed: "Zapisano, ale skutki zmiany (pojazdy, geokodowanie adresów, ASSIST) nie powiodły się. Zgłoś to, proszę.",
        errors: {
          CHANGED_MEANWHILE: "Konfiguracja systemu została w międzyczasie zmieniona. Widok został wczytany ponownie.",
          INVALID_CLIENT: "Ten klient nie może mieć konfiguracji systemu.",
          INVALID: "Nieprawidłowy wybór. „Śledzenie” wymaga „Mapa”, „Zarządzanie urządzeniami pokazać w kokpicie” wymaga „Wszystkie urządzenia zarządzanie”.",
          NO_CLIENT: "Tego klienta już nie ma.",
          DELETED_CLIENT: "Nie można zmienić konfiguracji systemu usuniętego klienta.",
          FOLLOWS_MASTER: "Ten klient korzysta z konfiguracji systemu swojego klienta MASTER. Zmień ją tam.",
          SHARED_LOGIN: "Przy wspólnym loginie administratora IRES nic nie można zmienić. Zaloguj się własnym użytkownikiem.",
          FAILED: "Nie udało się zapisać konfiguracji systemu.",
        },
      },
      setup: {
        title: "Nowy klient",
        loadFailed: "Nie udało się wczytać konfiguracji.",
        externalSystems: {
          explanation: "Z API klient może od razu otrzymać system zewnętrzny, np. swój ERP. Nie otrzymuje niczego, dopóki IRES go nie włączy, i zaczyna w konfiguracji. Jego hasło jest pokazywane raz po utworzeniu. Osoby kontaktowe i kolejne systemy dodasz później na stronie systemu.",
          create: "Utwórz system zewnętrzny",
          memberExplanation: "Członek korzysta z systemów zewnętrznych swojego klienta MASTER. Zaznaczony system ma potem dostęp do projektów tego klienta.",
          masterHasNone: "Klient MASTER nie ma systemów zewnętrznych.",
          system: "System zewnętrzny",
          linked: "Powiązane systemy",
          none: "Brak",
          sameAsClient: "System potrzebuje własnego adresu, nie adresu klienta.",
        },
        steps: {
          masterData: "Klient",
          products: "Produkty",
          projectTypes: "Typy projektów",
          projectOrganisation: "Organizacja projektów",
          functions: "Funkcje",
          licences: "Licencje",
          contracts: "Umowy i urządzenia",
          users: "Użytkownicy",
          externalSystems: "Systemy zewnętrzne",
          summary: "Podsumowanie",
        },
        next: "Dalej",
        create: "Utwórz",
        change: "Zmień",
        created: "Klient utworzony.",
        createWarning: "UTWÓRZ zakłada klienta ze wszystkim, co tu widać. Może się od razu zalogować.",
        signInEmail: "Adres e-mail (logowanie)",
        signInPassword: "Hasło (logowanie)",
        passwordTooShort: "Co najmniej {0} znaków",
        address: "Adres",
        followsMaster: "jak u klienta MASTER",
        followsMasterExplanation: "Jako członek klient korzysta z ustawień swojego klienta MASTER {0}.",
        noProjects: "Bez IRES Project, IRES Work ani IRES Office (GZ / GL) nie ma tu nic do ustawienia.",
        organisationRequired: "Wybierz co najmniej jedną aplikację.",
        group: {
          kinds: {
            STANDALONE: "Samodzielny",
            MEMBER: "Członek klienta MASTER",
            MASTER: "Nowy klient MASTER",
          },
          master: "Klient MASTER",
          masterRequired: "Wybierz klienta MASTER.",
          memberHint: "Członek przejmuje typy projektów, organizację projektów, funkcje, umowy i urządzenia swojego klienta MASTER. Jego licencje są jego własne.",
          memberOf: "Członek {0}",
        },
        products: {
          officeAlways: "IRES Office z zarządzaniem urządzeniami HyDry jest zawsze w zestawie.",
          officeOnly: "Tylko IRES Office (urządzenia HyDry)",
        },
        functions: {
          enabled: "Włączone",
          personalChat: "Czat osobisty",
          projectChat: "Czat projektu",
        },
        licences: {
          explanation: "Licencje kupione dla wybranych produktów. Później zmienisz je w IRES Admin.",
          noneNeeded: "Wybrane produkty nie potrzebują licencji.",
          invalid: "Liczba całkowita od 0 do {0}",
        },
        contracts: {
          devices: "Urządzenia",
          updateFirmwareViaIot: "Aktualizacja firmware IPU E-G przez IOT",
          updateConfigViaIot: "Aktualizacja konfiguracji przez IOT",
          conditions: {
            ALWAYS: "Zawsze",
            NEVER: "Nigdy",
            WHEN_IDLE_OR_AFTER_POWER_ON: "Panel bezczynny / uruchomiony",
          },
          yesSince: "Tak, od {0}",
          followsFleet: "jak flota",
          followsFleetExplanation: "Klient korzysta z wersji docelowych floty. Własne wersje docelowe ustawisz później w IRES Admin.",
        },
        users: {
          iresAdminExplanation: "Użytkownik administracyjny IRES jest zawsze tworzony: „Zaloguj jako klient” otwiera klienta za jego pomocą.",
          createFirstUser: "Utwórz pierwszego użytkownika klienta",
          role: "Rola: {0}",
          iresAdmin: "Użytkownik administracyjny IRES",
          iresAdminAlways: "Zostanie utworzony",
          firstUser: "Pierwszy użytkownik",
          noFirstUser: "Brak, później w Użytkownikach",
        },
        errors: {
          INVALID: "Któraś wartość jest nieprawidłowa. Sprawdź kroki.",
          NOT_A_MASTER: "Wybrany klient nie jest (już) klientem MASTER.",
          PROJECT_TYPES_EMPTY: "Wybierz co najmniej jeden typ projektu.",
          TRACKING_WITHOUT_MAP: "Śledzenie wymaga mapy.",
          TILE_WITHOUT_ALL_DEVICES: "Zarządzanie urządzeniami w kokpicie wymaga zarządzania wszystkimi urządzeniami.",
          NICKNAME_TAKEN: "Ta nazwa skrócona już istnieje.",
          STAFF_NUMBER_TAKEN: "Ten numer pracownika już istnieje.",
          PREFIX_TAKEN: "Inny klient ma już ten skrót.",
          EMAIL_TAKEN: "Inny klient loguje się już tym adresem e-mail.",
          USER_EMAIL_TAKEN: "Inny użytkownik ma już ten adres e-mail.",
          IRES_ADMIN_EMAIL_TAKEN: "Dla tego skrótu nie ma wolnego adresu dla użytkownika administracyjnego IRES. Wybierz inny skrót.",
          EXTERNAL_SYSTEM_EMAIL_TAKEN: "Konto z tym adresem już istnieje. Wybierz inny adres dla systemu zewnętrznego.",
          NOT_THE_MASTERS_SYSTEM: "Wybrany system nie należy już do klienta MASTER. Wybierz systemy ponownie.",
          SHARED_LOGIN: "Wspólnym loginem administratora IRES nie można niczego zmieniać. Zaloguj się własnym użytkownikiem.",
          FAILED: "Nie udało się utworzyć klienta.",
        },
      },
      partners: {
        title: "Systemy zewnętrzne",
        loadFailed: "Nie udało się wczytać systemów zewnętrznych.",
        none: "Brak połączonego systemu zewnętrznego.",
        viaMaster: "przez klienta MASTER",
        editOnOwner: "Ten system zewnętrzny należy do klienta MASTER i tam się go zmienia.",
        partner: "System zewnętrzny",
        saved: "Zapisano.",
        noAddress: "Brak (IRES nic nie wysyła)",
        defaultEndpoint: "Domyślnie: {0}",
        endpointLabel: "{0} (puste: {1})",
        byRoute: "Tylko dla wywołań przez EasyTec",
        statuses: {
          SETUP: "Konfiguracja",
          TEST: "Test",
          LIVE: "Live",
          PAUSED: "Wstrzymany",
        },
        statusDescriptions: {
          SETUP: "Połączenie jest konfigurowane.",
          TEST: "Połączenie jest testowane z systemem.",
          LIVE: "Projekty są wymieniane z systemem.",
          PAUSED: "IRES nic nie wysyła systemowi; to, co się pojawi, zostanie wysłane po wznowieniu. System nadal może wywoływać IRES.",
        },
        systems: {
          EASY_TEC: "Pełna lista kroków (EasyTec)",
          EXTERNAL: "Jeden krok naraz (API IRES)",
          NONE: "Brak (tylko przychodzące)",
        },
        signIn: {
          API_KEY: "Klucz API",
          SIGN_IN: "Adres e-mail i hasło",
          EASY_TEC: "Logowanie EasyTec (klient i hasło)",
          NONE: "Brak (IRES nic nie wysyła)",
        },
        fields: {
          integrationStatus: "Status",
          baseUrl: "Bazowy URL",
          signIn: "IRES loguje się przez",
          system: "Przesyłanie kroków",
        },
        endpoints: {
          createProject: "Nowy projekt",
          projectData: "Dane projektu",
          projectStatus: "Status",
          noteUpdate: "Notatki",
        },
        accepts: {
          acceptsNewProjects: "Nowe projekty",
          acceptsProjectDataUpdates: "Dane projektu",
          acceptsProjectStatusUpdates: "Status",
          acceptsNotes: "Notatki",
          includeProjectOwnersInfo: "Odpowiedzialni za projekt",
          sendsExtraPhaseData: "Dodatkowe dane faz",
        },
        behaviour: {
          appointmentFieldSwap: "Stosuj mapowanie termin / rozpoczęto",
          incomingContactPerson0: "Wymuszaj osobę kontaktową 0",
          sendsLatestProjectStatus: "Wysyłaj najnowszy status projektu",
          isTestSystem: "System testowy (numery projektów zamienione)",
        },
        cards: {
          status: "Status",
          connection: "Połączenie",
          accepts: "Co dostaje {0}",
          behaviour: "Zachowanie",
        },
        changeGroups: {
          created: "Utworzono system zewnętrzny",
          password: "Nowe hasło",
          accepts: "Co dostaje system",
          credentials: "Dane logowania",
        },
        contacts: {
          title: "Osoby kontaktowe",
          none: "Brak osoby kontaktowej.",
          name: "Imię i nazwisko",
          role: "Rola",
          email: "Adres e-mail",
          phone: "Telefon",
          add: "Dodaj osobę kontaktową",
          remove: "Usuń osobę kontaktową",
          roles: {
            TECHNICAL: "Techniczna",
            BUSINESS: "Merytoryczna",
          },
          invalid: {
            email: "Nieprawidłowy adres e-mail.",
            phone: "Tylko cyfry, spacje i + ( ) / - .",
          },
        },
        goLive: {
          title: "Uruchomienie",
          description: "Sprawdzane automatycznie przy otwarciu. Nic z tego nie blokuje statusu Live.",
          checks: {
            CONTACT: "Osoba kontaktowa wpisana",
            SIGNED_IN: "Zalogowany w IRES",
            CONNECTION: "Połączenie kompletne (bazowy URL i dane logowania)",
            PROJECT: "Pierwszy projekt wymieniony",
          },
          lastSignIn: "{0}, ostatnio {1}",
          openWarning: "Jeszcze otwarte przy uruchomieniu: {0}. Live można mimo to ustawić.",
        },
        packages: {
          title: "Pakiety",
          description: "To, co przekazujesz partnerowi do połączenia: opis API REST IRES ograniczony do jego punktów końcowych, jako YAML i jako strona dla przeglądarki, oraz przegląd wymiany jako PDF. Każdy pakiet jest zapisywany z datą, autorem, wersją i odbiorcą.",
          none: "Nie utworzono jeszcze pakietu.",
          notAvailable: "Systemy EasyTec nie mają jeszcze pakietów: korzystają z własnego interfejsu.",
          loadFailed: "Nie udało się wczytać pakietów.",
          create: "Nowy pakiet",
          createTitle: "Nowy pakiet dla {0}",
          createButton: "Utwórz",
          created: "Pakiet utworzony.",
          changeGroup: "Pakiet utworzony",
          version: "API {0}",
          by: "autor: {0}",
          for: "dla {0}",
          apiVersion: "Wersja API",
          groups: "Punkty końcowe",
          recipient: "Odbiorca",
          otherRecipient: "Inna osoba",
          recipientName: "Imię i nazwisko",
          recipientEmail: "Adres e-mail (opcjonalnie)",
          noCredentials: "Nigdy nie zawiera danych logowania: hasło systemu przekazujesz osobno.",
          describes: "Pakiet opisuje API REST IRES {0}.",
          groupNames: {
            SIGN_IN: "Logowanie",
            PROJECTS: "Projekty",
            STATUS: "Status i kroki",
            NOTES: "Notatki",
            REPORTS: "Raporty",
            DEVICES: "Urządzenia i przypisania",
            DEVICE_CATEGORIES: "Kategorie i typy urządzeń",
            USERS: "Użytkownicy i role",
          },
          states: {
            CURRENT: "Aktualny",
            OUTDATED: "Nieaktualny",
            SUPERSEDED: "Zastąpiony",
            UNCHECKED: "Nie można sprawdzić",
          },
          unchecked: "Nie udało się odczytać opisu w pakiecie, więc nie sprawdzono, czy API się zmieniło.",
          operations: {
            added: "Nowe punkty końcowe: {0}",
            removed: "Usunięte punkty końcowe: {0}",
            changed: "Zmienione punkty końcowe: {0}",
          },
          general: "Zmieniono: {0}",
          generalParts: {
            SERVERS: "Bazowy URL API",
            SECURITY: "Logowanie do API",
          },
          settingsNotChecked: "Ustawienia nie są sprawdzone: pakiet jest starszy niż to sprawdzenie.",
          changelogLine: "API {0}: {1}",
          notSent: "nie wysyłane",
          settingNames: {
            name: "Nazwa",
            accessEmail: "Adres logowania systemu",
            ownerIsGroup: "Grupa klientów (regionId)",
            sends: "IRES wysyła do systemu",
          },
          files: {
            yaml: "Pobierz opis (YAML)",
            html: "Pobierz opis (HTML)",
            overview: "Pobierz przegląd (PDF)",
          },
        },
        editTitles: {
          PARTNER_STATUS: "Edytuj status",
          PARTNER_CONNECTION: "Edytuj połączenie",
          PARTNER_ACCEPTS: "Edytuj, co dostaje {0}",
          PARTNER_BEHAVIOUR: "Edytuj zachowanie",
          PARTNER_CREDENTIALS: "Edytuj dane logowania",
          PARTNER_CONTACTS: "Edytuj osoby kontaktowe",
        },
        warnings: {
          pause: "IRES nic nie wysyła temu systemowi, dopóki go nie wznowisz. Nadal może wywoływać IRES.",
          resume: "Przy wznowieniu IRES wyśle wszystko, co czekało podczas przerwy.",
          swapOff: "Bez mapowania termin i rozpoczęcie trafiają do systemu osobno. Każdy krok terminu otwartego projektu zostanie wysłany ponownie przy jego następnej zmianie. Uzgodnij to najpierw z jego operatorem.",
          noStatus: "System nie będzie wtedy dostawał zmian statusu.",
        },
        fieldErrors: {
          baseUrl: "URL zaczynający się od https:// lub http://",
          endpoint: "Tylko litery, cyfry oraz _ - . ~ /",
        },
        credentials: {
          button: "Zmień dane logowania",
          apiKey: "Klucz API",
          password: "Hasło",
          email: "Adres e-mail",
          clientId: "Klient (EasyTec)",
          authUrl: "Adres logowania",
          tokenUrl: "Adres tokena",
          set: "ustawiony",
          missing: "brak",
          secretSetLabel: "{0} (ustawiony; zostaw puste, aby zachować)",
          secretMissingLabel: "{0} (brak)",
          saved: "Zapisano dane logowania.",
          replaced: "zastąpiono",
        },
        errors: {
          NOT_AVAILABLE: "Systemy EasyTec nie mają jeszcze pakietów.",
          NO_PACKAGE: "Ten pakiet nie istnieje.",
          NOT_A_MEMBER: "Powiązać można tylko członków grupy właściciela.",
          NO_CHANGES: "Nic się nie zmieniło.",
          EMAIL_TAKEN: "Ktoś już loguje się tym adresem.",
          MEMBER_CLIENT: "Członek korzysta z systemów zewnętrznych swojego klienta MASTER.",
          CHANGED_MEANWHILE: "Ktoś w międzyczasie to zmienił. Strona została wczytana ponownie.",
          NOT_EDITABLE_HERE: "Ten system zewnętrzny zmienia się u klienta MASTER.",
          NEEDS_ERP_SIMULATOR: "System testowy tylko dla klienta z symulatorem ERP.",
          NO_PARTNER: "Ten system zewnętrzny nie istnieje dla tego klienta.",
          INVALID: "Jedna z wartości jest nieprawidłowa.",
          SHARED_LOGIN: "Za pomocą wspólnego loginu IRES-Admin nie można niczego zmienić. Zaloguj się własnym użytkownikiem.",
          FAILED: "Nie udało się zapisać systemu zewnętrznego.",
        },
        access: {
          title: "Dostęp",
          description: "System loguje się do IRES tym adresem i swoim hasłem. Hasło jest pokazywane tylko raz, przy tworzeniu i przy Nowe hasło.",
          email: "Logowanie systemu do IRES",
          password: "Hasło",
          newPassword: "Nowe hasło",
          newPasswordTitle: "Wygeneruj nowe hasło",
          newPasswordMessage: "Obecne hasło {0} od razu przestaje działać. System zaloguje się ponownie dopiero, gdy dostanie nowe.",
          passwordTitle: "Hasło dla {0}",
          onceWarning: "Hasło jest pokazywane tylko teraz i nigdzie nie jest zapisywane. Skopiuj je i przekaż operatorowi systemu.",
          copy: "Kopiuj",
          copied: "Skopiowano hasło.",
          copyFailed: "Kopiowanie nie zadziałało. Zaznacz hasło i skopiuj je ręcznie.",
          done: "Gotowe",
        },
        create: {
          open: "Nowy",
          title: "Nowy system zewnętrzny",
          name: "Nazwa",
          baseUrlOptional: "Bazowy URL (opcjonalnie, także później)",
          button: "Utwórz",
          created: "Utworzono system zewnętrzny.",
          emailInvalid: "Adres e-mail, np. prefiks-system@ires.de",
        },
        links: {
          title: "Powiązani klienci",
          description: "System dociera do tych klientów: może tworzyć i edytować ich projekty, a ich nowe projekty są z nim wymieniane. Tutaj powiązujesz członków grupy.",
          none: "Brak powiązanego klienta.",
          owner: "Właściciel",
          link: "Powiąż",
          linkTitle: "Powiąż klienta z {0}",
          member: "Klient",
          linkWarning: "{0} może wtedy tworzyć i edytować projekty tego klienta, a nowe projekty klienta są wymieniane z {0}.",
          linked: "Powiązano.",
          unlink: "Usuń powiązanie",
          unlinkTitle: "Usuń powiązanie",
          unlinkMessage: "{1} nie może już dotrzeć do {0}: jego wywołania dla tego klienta są odrzucane.",
          unlinked: "Usunięto powiązanie.",
          linkedClient: "Powiązany klient",
        },
      },
      clientLogin: {
        button: "Zaloguj jako klient",
        noTab: "Nowa karta nie odpowiedziała. Zezwól na wyskakujące okna dla IRES Office i spróbuj ponownie.",
        failed: "Nie udało się otworzyć klienta.",
        refusals: {
          SHARED_LOGIN: "Klienta nie można otworzyć przy użyciu wspólnego loginu administratora IRES. Zaloguj się własnym użytkownikiem.",
          NO_CLIENT: "Ten klient już nie istnieje.",
          PORTAL_CLIENT: "Własnego klienta IRES Admin Client nie można otworzyć w ten sposób.",
          ADMIN_APP_CLIENT: "Kont aplikacji IRES Admin nie można otworzyć w ten sposób.",
          NO_IRES_ADMIN_USER: "Ten klient nie ma użytkownika administratora IRES.",
        },
      },
      status: {
        blocked: {
          title: "Edytuj blokadę",
          no: "Niezablokowany",
          yes: "Zablokowany",
          consequence: "Nikt nie może się już zalogować do tego klienta, z wyjątkiem konta administratora IRES. Urządzenia i połączenia ERP działają dalej.",
          saved: "Blokada zapisana.",
        },
        active: {
          title: "Edytuj aktywny / nieaktywny",
          yes: "Aktywny",
          no: "Nieaktywny",
          consequence: "Użytkownicy nie mogą się już logować swoim adresem e-mail, a klient znika z list swojej grupy.",
          unmet: "Klienta nie można jeszcze ustawić jako nieaktywnego:",
          saved: "Zapisano.",
        },
        delete: {
          title: "Usuń klienta",
          consequence: "Klient znika ze wszystkich list i nikt nie może się już zalogować. Wszystkie dane zostają zachowane; przywrócenie cofa usunięcie.",
          unmet: "Klienta nie można jeszcze usunąć:",
          saved: "Klient usunięty.",
        },
        restore: {
          title: "Przywróć klienta",
          message: "Klient pojawia się ponownie na listach i logowanie znowu działa, o ile nie jest zablokowany.",
          button: "Przywróć",
          saved: "Klient przywrócony.",
        },
        deleteReason: "Powód",
        deleteReasons: {
          CUSTOMER_LEFT: "Klient odszedł",
          DUPLICATE: "Duplikat",
          TEST_ACCOUNT: "Konto testowe",
          OTHER: "Inny",
        },
        note: "Uwaga (opcjonalnie)",
        noteRequired: "Uwaga",
        noteTooLong: "Maksymalnie 200 znaków",
        conditions: {
          DEVICES_ASSIGNED: "Urządzenia są nadal przypisane.",
          RUNNING_PROJECTS: "Projekty są nadal w toku.",
          SHARED_USERS_AT_HOME: "Wspólni użytkownicy grupy mają tu swojego klienta macierzystego.",
          MASTER_WITH_MEMBERS: "Klient jest masterem grupy z członkami.",
          ERP_CONNECTED: "Połączenie ERP jest aktywne.",
        },
        changedMeanwhile: "Status został w międzyczasie zmieniony. Widok został ponownie załadowany.",
        saveFailed: "Nie udało się zapisać statusu.",
      },
      liveOperation: {
        live: "Produkcyjny",
        notLive: "Nieprodukcyjny",
        notLiveWithReason: "Nieprodukcyjny ({0})",
        reasons: {
          TEST: "Test",
          DEMO: "Demo",
          WAREHOUSE: "Magazyn",
        },
        reason: "Powód",
        change: "zmień",
        changedAt: "zmieniono {0}",
        changedAtBy: "zmieniono {0} przez {1}",
        editTitle: "Edytuj tryb działania",
        consequence: "Od następnej nocy Mira pomija klientów nieprodukcyjnych we wszystkich liczbach i porównaniach. Po przywróceniu trybu produkcyjnego znów są liczeni.",
        saved: "Zapisano tryb działania.",
        saveFailed: "Nie udało się zapisać trybu działania.",
      },
      miraAllClients: {
        on: "Tak: Mira pokazuje wszystkich klientów łącznie",
        off: "Nie",
        editTitle: "Edytuj Mira: wszyscy klienci",
        consequence: "Od następnej nocy Mira pokazuje wtedy dane wszystkich klientów łącznie. Widzi je każdy użytkownik tego klienta.",
        savedOn: "Mira pokazuje wszystkich klientów od następnej nocy.",
        savedOff: "Mira nie pokazuje już danych wszystkich klientów.",
        saveFailed: "Nie udało się zapisać ustawienia.",
        notIresAccount: "Tylko klient IRES może pokazywać wszystkich klientów.",
      },
      columns: {
        name: "Nazwa",
        currentProjects: "Bieżące",
        oldProjects: "Stare",
        deletedProjects: "Usunięte",
        reports: "Raporty",
        panels: "Panele",
        comBoxes: "Boxy",
        minis: "Mini",
        number: "Numer",
        shorthand: "Skrót",
        users: "Użytkownicy",
      },
      columnGroups: {
        projects: "Projekty",
        devices: "Urządzenia",
      },
      filters: {
        ALL: "Wszyscy",
        IRES: "IRES",
        CLIENT: "Klienci zewnętrzni",
        SERVICE_CONTRACT: "Umowa serwisowa",
        CONTRACT_PURCHASE: "Zakup",
        CONTRACT_PERMANENT_RENT: "Najem stały",
        CONTRACT_TESTING: "Faza testowa",
        HAS_APP: "Ma aplikację",
        MASTER: "Master",
        LIVE: "Produkcyjny",
        NOT_LIVE: "Nieprodukcyjny",
        BLOCKED: "Zablokowany",
        DELETED: "Usunięci",
        ACTIVE: "Aktywni",
        INACTIVE: "Nieaktywni",
      },
      filterGroups: {
        TYPE: "Typ",
        CONTRACT: "Umowa",
        APP: "Aplikacja",
        GROUP: "Grupa",
        OPERATION: "Tryb działania",
        ACCESS: "Dostęp",
        STATUS: "Status",
      },
      serviceContractSince: "od {0}",
      noneMatching: "Żaden klient nie pasuje do wyszukiwania i filtra.",
      loadFailed: "Nie udało się wczytać klientów.",
      figuresUpdatedAt: "Stan: {0}",
      detail: {
        loadFailed: "Nie udało się wczytać klienta.",
        notFound: "Ten klient nie istnieje (już).",
        licences: {
          title: "Licencje",
          modelV2: "Model licencji 2 · limity",
          modelV3: "Model licencji 3 · użyte z zakupionych",
          exceeded: "Użyto więcej licencji niż zakupiono.",
        },
        devices: {
          title: "Urządzenia",
          loadFailed: "Nie udało się wczytać liczby urządzeń.",
          hint: "Panele bez otwartego przypisania liczą się jako byłe. Sumy paneli obejmują tylko HyDry Panel, HyDry Slim i HyDry Edge.",
          columns: {
            type: "Przypisanie",
            panels: "Panele",
            comBoxes: "Boxy",
            minis: "Mini",
          },
          assignmentTypes: {
            SOLD: "Zakup",
            PERMANENT_RENT: "Najem stały",
            DAILY_RENT: "Najem dzienny",
            CONSIGNMENT_STOCK: "Magazyn konsygnacyjny",
            TESTING: "Test",
            OTHER: "Inne",
            AVAILABLE: "Dostępne",
          },
          former: "Byłe panele",
          total: "Razem",
        },
        sections: {
          masterData: "Dane podstawowe",
          products: "Produkty",
          projectTypes: "Typy projektów",
          projectOrganisation: "Organizacja projektów",
          systemConfiguration: "Konfiguracja systemu",
          group: "Grupa",
          contracts: "Umowy",
          targetVersions: "Wersje docelowe",
          testSettings: "Test",
          status: "Status",
          helperFunctions: "Funkcje pomocnicze",
        },
        fields: {
          isMaster: "Klient MASTER",
          groupMembers: "Członkowie",
          settingsSource: "Ustawienia przejęte od",
          masterClient: "Członek grupy",
          clientNumber: "Numer klienta",
          companyName: "Firma",
          zip: "Kod pocztowy",
          city: "Miejscowość",
          street: "Ulica",
          clientType: "Typ klienta",
          email: "Adres e-mail",
          clientShorthand: "Skrót klienta",
          officeDeviceAssignment: "IRES Office (GZ / GL)",
          project: "IRES Project",
          work: "IRES Work",
          interface: "API",
          productChoice: "Wybór produktu (stary)",
          contracts: "Umowy",
          warrantyExtensionForPanels: "Przedłużenie gwarancji paneli",
          serviceContract: "Umowa serwisowa FW / konfiguracja",
          hasApp: "Ma aplikację",
          blocked: "Zablokowany",
          isActive: "Aktywny",
          deleted: "Usunięty",
          liveOperation: "Tryb działania",
          miraAllClients: "Mira: wszyscy klienci",
          isTestSystem: "ERP-Symulator",
          testAppVersion: "Docelowa wersja aplikacji testowej",
          testRoomInfoConfigVersion: "Docelowa wersja opisu testowego",
          testUsers: "Użytkownicy testowi",
          numUsers: "Użytkownicy",
          numProjects: "Projekty",
          numArchivedProjects: "Stare projekty",
          numDeletedProjects: "Usunięte projekty",
          figuresUpdatedAt: "Stan danych",
          numReports: "Raporty",
        },
        clientTypes: {
          IRES: "IRES",
          CLIENT: "Klient",
          OTHER: "Inny",
        },
        contractTypes: {
          PURCHASE: "Zakup",
          PERMANENT_RENT: "Najem stały",
          TESTING: "Faza testowa",
        },
        testSettings: {
          unknownUser: "Nieznany użytkownik",
          inactiveUser: "(usunięty)",
          reachesNobody: "Test nie dociera do nikogo, dopóki nie wybrano użytkownika testowego.",
        },
        targetVersions: {
          targetFirmwareName: "Firmware docelowy A, B, C",
          targetIotFirmwareName: "Firmware docelowy D+",
          targetConfigName: "Konfiguracja docelowa",
          targetAppApk: "Wersja aplikacji",
          targetLeakDetectionInfoConfigVersion: "Wykrywanie nieszczelności",
          targetRoomInfoConfigVersion: "Suszenie",
          targetHtmlTipsAndTricksFile: "Porady i wskazówki",
          targetHtmlHistoryFile: "Historia wersji",
        },
      },
    },
    cockpit: {
      contractsAndApp: "Umowy i aplikacja",
      tasks: "Zadania",
      totalsTitle: "Łącznie",
      totalsScope: "Klienci w trybie produkcyjnym",
      totals: {
        projects: "Projekty",
        oldProjects: "Stare projekty",
      },
      exceptionSuggestions: "Propozycje wyjątków Mira",
      externalSystemsInStatus: "Systemy zewnętrzne: {0}",
      waitingDeviceReports: "Raporty testów nieprzypisane",
      ownTargets: "Klienci z własnym celem",
      testTargets: "Klienci z celem testowym",
      loadFailed: "Nie udało się wczytać wszystkich liczb.",
    },
    clientSensorDataExport: {
      title: "Eksport danych czujników",
      description: "Zarejestrowane dane czujników wybranych urządzeń HyDry Box i paneli w pliku Excel, jeden arkusz na urządzenie. Urządzenie dostarcza tylko przebiegi, w których było przypisane do tego klienta.",
      startDate: "Data początkowa",
      endDate: "Data końcowa",
      selected: "Zaznaczono: {0}",
      selectAll: "Zaznacz wszystko",
      selectNone: "Wyczyść zaznaczenie",
      none: "Ten klient nie ma urządzeń HyDry Box ani paneli.",
      progress: "Przetworzono {0} z {1} urządzeń",
      exportSuccess: "Eksport utworzony pomyślnie.",
      exportError: "Wystąpił błąd podczas eksportu.",
      noData: "Brak pomiarów dla wybranych urządzeń w wybranym okresie.",
    },
    clientDevices: {
      title: "Urządzenia",
      allDevices: "Wszystkie urządzenia",
      search: "Numer seryjny",
      count: "Urządzenia",
      kinds: {
        PANELS: "HyDry Panele",
        BOXES: "HyDry Boxy",
        MINIS: "HyDry Mini",
      },
      scopes: {
        CURRENT: "Aktualnie przypisane",
        FORMER: "Byłe",
      },
      filterGroups: {
        KIND: "Typ urządzenia",
        PANEL_TYPE: "Typ panelu",
        PERIOD: "Okres",
        ASSIGNMENT: "Przypisanie",
      },
      sorts: {
        SERIAL_NUMBER: "Numer seryjny",
        ASSIGNMENT_TYPE: "Przypisanie",
        ASSIGNMENT_DATE: "Data przypisania",
      },
      columns: {
        serialNumber: "Numer seryjny",
        type: "Typ urządzenia",
        assignment: "Przypisanie",
        firmware: "Firmware",
        lastContact: "Ostatni kontakt",
      },
      since: "od {0}",
      open: "otwarte",
      history: "Wszystkie przypisania",
      noHistory: "Brak przypisań",
      build: "Build {0}",
      config: "Konfiguracja {0}",
      ipu: "IPU {0}",
      display: "Wyświetlacz {0}",
      noneMatching: "Żadne urządzenie nie pasuje do tych filtrów.",
      loadFailed: "Nie udało się wczytać urządzeń.",
    },
    clientProjects: {
      title: "Projekty",
      search: "Nazwa / numer",
      count: "Projekty",
      filterGroups: {
        STATUS: "Status",
        KIND: "Rodzaj projektu",
      },
      columns: {
        period: "Okres",
        devices: "Urządzenia",
        steps: "Kroki",
      },
      since: "od {0}",
      officeNumber: "Office: {0}",
      erpNumber: "Numer zbiorczy: {0}",
      showMore: "Pokaż więcej ({0} z {1})",
      noneMatching: "Żaden projekt nie pasuje do tych filtrów.",
      loadFailed: "Nie udało się wczytać projektów.",
      archiveLoading: "{0} % wczytano",
      archiveLoadFailed: "Nie udało się wczytać starych projektów.",
    },
    clientReports: {
      title: "Raporty",
      count: "Raporty",
      columns: {
        report: "Raport",
        project: "Projekt",
        date: "Data",
        size: "Rozmiar",
      },
      outdated: "nieaktualny",
      sizeMb: "{0} MB",
      showMore: "Pokaż więcej ({0} z {1})",
      none: "Brak raportów.",
      loadFailed: "Nie udało się wczytać raportów.",
      loadMoreFailed: "Nie udało się wczytać kolejnych raportów.",
      openFailed: "Nie udało się otworzyć raportu.",
      fileMissing: "Brak pliku tego raportu.",
      noFile: "Ten raport nie ma pliku.",
      popupBlocked: "Twoja przeglądarka zablokowała nowe okno. Zezwól na wyskakujące okna dla IRES Office.",
    },
    clientUsers: {
      title: "Użytkownicy",
      search: "Pseudonim / nazwisko",
      count: "Użytkownicy",
      status: "Status",
      filterGroups: {
        STATUS: "Status",
        ROLE: "Rola",
      },
      statuses: {
        ACTIVE: "Aktywny",
        BLOCKED: "Zablokowany",
        DELETED: "Usunięty",
      },
      noneMatching: "Żaden użytkownik nie pasuje do tych filtrów.",
      loadFailed: "Nie udało się wczytać użytkowników.",
    },
    pdfTemplates: {
      loading: "Wczytywanie szablonu …",
      title: "Szablony PDF",
      sharedTitle: "Wspólne szablony PDF",
      search: "Nazwa lub plik",
      count: "Szablony PDF",
      sharedCount: "Wspólne szablony PDF",
      openShared: "Wspólne szablony",
      sharedHint: "Wspólne szablony może przejąć każdy klient. Certyfikat HyDry używa tylko własnych szablonów klienta.",
      columns: {
        name: "Szablon",
        fields: "Pola",
        problems: "Problemy",
        lastSaved: "Ostatni zapis",
      },
      hyDryCertificate: "Certyfikat HyDry",
      ignoredCertificate: "-HyDry, nieużywany",
      problemValues: "1 wartość pozostaje pusta | {count} wartości pozostaje pustych",
      noProblems: "Wszystkie wartości są wypełniane",
      none: "Brak szablonów PDF.",
      noFields: "Ten szablon nie ma pól.",
      loadFailed: "Nie udało się wczytać szablonów PDF.",
      notFound: "Ten szablon PDF nie istnieje.",
      download: "Pobierz",
      downloadFailed: "Nie udało się pobrać szablonu.",
      fileMissing: "Brak pliku tego szablonu.",
      detail: {
        field: "Pole",
        category: "Kategoria",
        values: "Wartości",
        texts: "Tekst przed / po",
        prefix: "przed: „{0}” ({1})",
        suffix: "po: „{0}” ({1})",
      },
      statuses: {
        UNKNOWN_TO_CLOUD: "pozostaje puste: IRES Cloud nie zna tej wartości",
        NOT_IMPLEMENTED: "pozostaje puste: nie zaimplementowano w IRES Cloud",
        CHECKBOX_ALWAYS_OFF: "pole wyboru zawsze pozostaje puste",
      },
      fieldTypes: {
        TEXT: "Pole tekstowe",
        CHECK_BOX: "Pole wyboru",
        SIGNATURE: "Pole podpisu",
        DROPDOWN: "Lista rozwijana",
      },
      edit: {
        dialogTitle: "Edytuj {0}",
        filters: {
          ALL: "Wszystkie pola",
          LINKED: "Powiązane",
          UNLINKED: "Niepowiązane",
        },
        linkedCount: "Powiązane pola: {0} z {1}",
        notLinked: "niepowiązane",
        notInPdf: "Nie ma już w PDF",
        childFields: "Grupa pól: {count} | Grupa pól: {count}",
        noneMatching: "Żadne pole nie pasuje do tego filtra.",
        unavailable: {
          NO_FILE: "Ten szablon nie ma pliku.",
          FILE_MISSING: "Brakuje pliku tego szablonu.",
          ENCRYPTED: "PDF jest zaszyfrowany, nie można odczytać jego pól.",
          UNREADABLE: "Nie można odczytać pliku PDF.",
        },
        onlyLinkedShown: "Wyświetlane są tylko powiązane pola.",
        selection: "Wybór",
        noValue: "Nie powiązano jeszcze żadnej wartości.",
        addValue: "Dodaj wartość",
        replaceValue: "Zastąp wartość",
        prefix: "Tekst przed",
        suffix: "Tekst po",
        preview: "Podgląd",
        unlink: "Usuń powiązanie",
        changedMeanwhile: "Szablon został w międzyczasie zapisany, na przykład w IRES Admin. Odśwież stronę i wprowadź zmiany ponownie.",
        saveRefused: "Nie zapisano: powiązanie pola „{0}” nie pasuje do PDF ani do wartości jego kategorii.",
        saveFailed: "Nie udało się zapisać powiązań.",
        scopeClient: "Szablon {0}: zapisane zmiany obowiązują dla wszystkich nowych plików PDF, które IRES Project tworzy dla tego mandanta.",
        scopeCertificate: "Ten szablon wypełnia też certyfikat HyDry tego mandanta.",
        scopeShared: "Szablon wspólny: zapisane zmiany obowiązują tylko przy przyszłych przejęciach. Mandanci, którzy już go przejęli, zachowują swoją kopię bez zmian.",
        confirmTitle: "Zapisać powiązania?",
        confirmClient: "Zapisujesz szablon „{0}” mandanta {1}. Nowe pliki PDF, które IRES Project tworzy dla tego mandanta, będą używać zmienionych powiązań.",
        confirmShared: "Zapisujesz wspólny szablon „{0}”. Dotyczy to tylko przyszłych przejęć; istniejące kopie u mandantów pozostają bez zmian.",
        changesAdded: "Nowo powiązane: {0}",
        changesChanged: "Zmienione: {0}",
        changesRemoved: "Usunięte powiązania: {0}",
      },
      files: {
        upload: "Nowy szablon",
        uploadTitle: "Nowy szablon PDF",
        replace: "Zastąp PDF",
        rename: "Zmień nazwę",
        copyToShared: "Kopiuj do szablonów wspólnych",
        copyFromShared: "Przejmij ze wspólnych",
        delete: "Usuń",
        deleteTitle: "Usunąć szablon?",
        preview: "Podgląd",
        previewFailed: "Nie udało się utworzyć podglądu.",
        popupBlocked: "Przeglądarka zablokowała nowe okno. Zezwól na wyskakujące okna dla tej strony.",
        importMappings: "Przejmij powiązania",
        fileLabel: "Plik PDF",
        nameLabel: "Nazwa pliku",
        sourceLabel: "Szablon wspólny",
        actions: {
          upload: "Prześlij",
          replace: "Zastąp",
          rename: "Zmień nazwę",
          copy: "Kopiuj",
        },
        problems: {
          EMPTY: "Wpisz nazwę.",
          TOO_LONG: "Nazwa jest za długa.",
          INVALID_CHARACTERS: "Nazwa nie może zawierać / ani \\ ani ..",
          TAKEN: "Szablon o tej nazwie już tu istnieje. Tablety przechowują szablon pod jego nazwą, więc każdy PDF potrzebuje nowej.",
        },
        switches: {
          title: "Jak IRES Project odczytuje nazwę:",
          hidden: "ukryty w wyborze; IRES Cloud może go użyć do certyfikatu HyDry",
          always: "oferowany w każdej fazie i dla każdego ubezpieczyciela",
          phase: "faza {0}",
          noPhase: "bez fazy",
          insurer: "tylko dla ubezpieczyciela „{0}”",
          images: "ze zdjęciami (+Bild)",
          phases: {
            LEAK_DETECTION: "lokalizacja wycieku",
            DAMAGE_ASSESSMENT: "oględziny szkody",
            DRYING_CONCLUSION: "zakończenie osuszania",
            REPAIR: "naprawa",
          },
        },
        consequences: {
          uploadClient: "Szablon będzie do wyboru w IRES Project dla {0}.",
          uploadShared: "Szablon będzie dostępny dla wszystkich mandantów. W IRES Project pojawi się dopiero po przejęciu.",
          replaceClient: "Nowe pliki PDF tworzone przez IRES Project dla {0} używają nowego pliku.",
          replaceShared: "Dotyczy to tylko przyszłych przejęć; mandanci, którzy już przejęli szablon, zachowują swoją kopię.",
          replaceFile: "Nowy plik potrzebuje nowej nazwy, bo tablety przechowują szablon pod jego nazwą. Stary plik zostaje, powiązania też; pola, których nowy PDF nie ma, zostaną oznaczone.",
          renameClient: "Nowe pliki PDF tworzone przez IRES Project dla {0} mają nową nazwę, a jej przełączniki (faza, ubezpieczyciel, +Bild) obowiązują od teraz. Istniejące dokumenty pozostają bez zmian.",
          renameShared: "Dotyczy to tylko przyszłych przejęć; istniejące kopie zachowują swoją nazwę.",
          copyToShared: "Kopia będzie dostępna dla wszystkich mandantów. Jest niezależna od szablonu {0}: zmiany w jednym nie docierają do drugiego.",
          copyFromShared: "Kopia należy do {0} i będzie tam do wyboru w IRES Project. Jest niezależna od szablonu wspólnego: zmiany w jednym nie docierają do drugiego.",
          deleteClient: "„{0}” mandanta {1} zostanie usunięty. IRES Project nie będzie go już oferować; istniejące dokumenty pozostają bez zmian.",
          deleteShared: "Wspólny szablon „{0}” zostanie usunięty. Mandanci, którzy go przejęli, zachowują swoją kopię.",
          deleteKeepsFile: "Plik pozostaje zapisany w IRES i można go przywrócić.",
          certificateReplace: "Ten szablon wypełnia certyfikat HyDry tego mandanta. Zachowaj -HyDry na początku nazwy, inaczej IRES Cloud przestanie go do tego używać.",
          certificateRename: "Ten szablon wypełnia certyfikat HyDry tego mandanta. Bez -HyDry na początku nazwy IRES Cloud przestanie go do tego używać.",
          certificateLOST: "Ten mandant nie będzie miał wtedy szablonu certyfikatu HyDry; IRES Cloud nie utworzy wtedy certyfikatów.",
          certificateCHANGED: "Certyfikat HyDry tego mandanta będzie wtedy używał innego szablonu.",
        },
        success: {
          created: "Szablon utworzony. Teraz powiąż jego pola.",
          replaced: "PDF zastąpiony.",
          renamed: "Zmieniono nazwę szablonu.",
          copied: "Szablon skopiowany do szablonów wspólnych.",
          deleted: "Szablon usunięty.",
        },
        errors: {
          FILE_NAME_TAKEN: "Ta nazwa pliku już tu istnieje, także przy usuniętym lub zastąpionym szablonie. Wybierz inną.",
          FILE_TOO_LARGE: "PDF jest większy niż 6 MB.",
          NOT_A_PDF: "Plik nie jest czytelnym PDF.",
          ENCRYPTED: "PDF jest zaszyfrowany; nie można odczytać jego pól.",
          NO_FILE: "Brakuje pliku tego szablonu.",
          FILE_NAME_EMPTY: "Wpisz nazwę.",
          FILE_NAME_TOO_LONG: "Nazwa jest za długa.",
          FILE_NAME_INVALID_CHARACTERS: "Nazwa nie może zawierać / ani \\ ani ..",
          FAILED: "Nie udało się. Spróbuj ponownie.",
        },
        import: {
          title: "Przejmij powiązania",
          sourceLabel: "Z szablonu",
          groups: {
            own: "Szablony tego zakresu",
            shared: "Szablony wspólne",
          },
          fresh: "Pola bez powiązania otrzymują powiązanie szablonu ({count}): | Pola bez powiązania otrzymują powiązanie szablonu ({count}):",
          conflicting: "Te pola są tu powiązane inaczej. Zaznacz, co ma zostać nadpisane:",
          nothing: "Ten szablon nie ma powiązań dla pól tego PDF, które można przejąć.",
          missing: "Pola szablonu, których nie ma w tym PDF, zostaną pominięte ({count}). | Pola szablonu, których nie ma w tym PDF, zostaną pominięte ({count}).",
          savedLater: "Przejęte do twoich zmian; zapisane dopiero przyciskiem ZAPISZ.",
        },
      },
    },
    infoConfig: {
      title: "Opisy",
      globalTarget: "Cel globalny: {0}",
      newVersion: "Nowa wersja",
      columns: {
        version: "Wersja",
        state: "Status",
        uploaded: "Przesłano",
      },
      filters: {
        CURRENT: "Aktualne wersje",
        TARGETS: "Cele",
        RETIRED: "Wycofane",
        LEGACY: "Lokalizacja wycieku (stare)",
      },
      legacyHint: "Te pliki należą do samodzielnych projektów lokalizacji wycieku, których od 2021 r. się nie tworzy. Są tylko do odczytu.",
      retiredHint: "Wycofane wersje nie są już oferowane jako cel. Projekty, które ich używają, pozostają bez zmian.",
      loadFailed: "Nie udało się wczytać opisów.",
      none: "Brak wersji.",
      badges: {
        globalTarget: "Cel globalny",
        clientTargets: "Cel mandantów: {count} | Cel mandantów: {count}",
        testTargets: "Cel testowy u mandantów: {count} | Cel testowy u mandantów: {count}",
        retired: "Wycofana",
        unlisted: "Poza listą",
        noFile: "Brak pliku",
      },
      publish: {
        title: "Nowa wersja opisu",
        file: "Plik CSV",
        version: "Numer wersji",
        permanent: "Opublikowanej wersji nie można już zmienić ani usunąć, więc sprawdź ją wcześniej.",
        facts: "Kodowanie {0} · separator {1} · nagłówek {2} · wiersze: {3}",
        noProblems: "Nie znaleziono problemów.",
        acknowledge: "Przeczytałem uwagi i mimo to chcę opublikować.",
        differences: "Różnice względem wersji {0}",
        noBase: "Brak celu globalnego do porównania.",
        check: "Sprawdź",
        publish: "Opublikuj",
        published: "Wersja {0} opublikowana.",
        versionProblems: {
          FORMAT: "Cyfry, kropka i dwa miejsca po przecinku, np. 5.58.",
          TAKEN: "Ta wersja już istnieje.",
          NOT_NEWER: "Wersja musi być wyższa niż najnowsza.",
        },
      },
      problems: {
        line: "Wiersz {0}:",
        NOT_UTF8: "Plik nie jest w UTF-8. Zapisz go jako „CSV UTF-8”, inaczej polskie i niemieckie znaki znikną na tabletach.",
        EMPTY_FILE: "Plik jest pusty.",
        FIRST_LINE_WITHOUT_SEPARATOR: "Pierwszy wiersz nie kończy się separatorem; IRES Project rozpoznaje po nim separator.",
        VERSION_HEADER_MISSING: "Pierwszy wiersz musi zaczynać się od #Version.",
        VERSION_HEADER_MISMATCH: "Nagłówek podaje wersję {0}, a plik ma być opublikowany pod innym numerem.",
        VERSION_FORMAT: "„{0}” nie jest poprawnym numerem wersji (cyfry, kropka, dwa miejsca po przecinku).",
        ROW_TOO_SHORT: "Wiersz {0} ma za mało kolumn; IRES Project nie odczytałby całego pliku.",
        ROW_BEFORE_SECTION: "Wiersz {0} stoi przed pierwszą sekcją i jest pomijany.",
        COMMA_SEPARATOR: "Plik jest rozdzielony przecinkami zamiast średnikami.",
        VERSION_TAKEN: "Wersja {0} już istnieje.",
        VERSION_NOT_NEWER: "Wersja nie jest wyższa niż najnowsza ({0}).",
      },
      differences: {
        none: "Brak różnic.",
        optionChangesHint: "Wartości na pozycjach, które wcześniej znaczyły coś innego: {count} | Wartości na pozycjach, które wcześniej znaczyły coś innego: {count}",
        SECTION_ADDED: "Nowa sekcja",
        SECTION_REMOVED: "Sekcja usunięta",
        ROW_ADDED: "{0}: nowy",
        ROW_REMOVED: "{0}: usunięty",
        ROW_CHANGED: "{0}: etykieta „{2}” → „{3}”",
        TYPE_CHANGED: "{0}: typ {2} → {3}",
        OPTION_ADDED: "{0}, wartość {1}: nowa „{3}”",
        OPTION_REMOVED: "{0}, wartość {1}: usunięto „{2}”",
        OPTION_CHANGED: "{0}, wartość {1}: „{2}” → „{3}”",
      },
      detail: {
        loading: "Wczytywanie wersji {0} …",
        newFromThis: "Nowa wersja na podstawie tej",
        legacy: "Lokalizacja wycieku (stara)",
        rowCount: "Wiersze: {count} | Wiersze: {count}",
        notFound: "Ta wersja nie istnieje.",
        setGlobalTarget: "Ustaw jako cel globalny",
        setGlobalTargetTitle: "Zmienić cel globalny?",
        setGlobalTargetMessage: "Nowe projekty wszystkich mandantów bez własnego celu będą wtedy używać wersji {0}. Istniejące projekty zachowują swoją wersję.",
        globalTargetSet: "Wersja {0} jest teraz celem globalnym.",
        retire: "Wycofaj",
        retireTitle: "Wycofać tę wersję?",
        retireMessage: "Wersja {0} nie będzie już oferowana na listach ani jako cel. Projekty, które jej używają, pozostają bez zmian, a plik zostaje zachowany.",
        retired: "Wersja {0} została wycofana.",
      },
      target: {
        editTitle: "Edytuj opis mandanta",
        version: "Wersja",
        consequence: "Nowe projekty tego mandanta będą wtedy używać tej wersji. Istniejące projekty zachowują swoją.",
        followGlobal: "Użyj celu globalnego ({0})",
        saved: "Cel zapisany.",
        change: "zmień",
      },
      errors: {
        CHECK_FAILED: "Plik zawiera błędy; sprawdź go ponownie.",
        WARNINGS_NOT_ACKNOWLEDGED: "Najpierw potwierdź uwagi.",
        VERSION_TAKEN: "Ta wersja już tymczasem istnieje.",
        VERSION_RETIRED: "Ta wersja jest wycofana.",
        VERSION_IS_TARGET: "Ta wersja jest jeszcze celem i nie można jej wycofać.",
        NEEDS_SYSADMIN: "Może to zrobić tylko SysAdmin portalu.",
        NO_FILE: "Brakuje pliku tej wersji.",
        FILE_TOO_LARGE: "Plik jest większy niż 2 MB.",
        FAILED: "Nie udało się. Spróbuj ponownie.",
      },
      sections: {
        search: "Klucz lub tekst",
        noneMatching: "Żaden wiersz nie pasuje do wyszukiwania.",
        columns: {
          key: "Klucz",
          category: "Kategoria",
          group: "Grupa",
          entry: "Wpis",
          trade: "Branża",
          type: "Typ",
          values: "Wartości",
        },
      },
      draft: {
        rowDialogTitle: "Edytuj {0}",
        title: "Szkic {0} (z {1})",
        savedHere: "Zapisywany w tej przeglądarce",
        none: "Brak szkicu. Otwórz wersję i wybierz „Nowa wersja na podstawie tej”.",
        notSaved: "Przeglądarka nie zapisuje szkicu (okno prywatne lub pełna pamięć). Odświeżenie go usunie.",
        discard: "Odrzuć",
        discardTitle: "Odrzucić szkic?",
        discardMessage: "Wszystkie zmiany tego szkicu zostaną utracone. Opublikowane wersje pozostają bez zmian.",
        checkAndPublish: "Sprawdź i opublikuj",
        changeVersion: "Zmień numer wersji",
        insertRow: "Wstaw wiersz poniżej",
        insertRowMessage: "Nowy wiersz po {0}, ta sama sekcja.",
        removeRow: "Usuń wiersz",
        removeRowMessage: "Usunąć wiersz {0} ze szkicu?",
        keyRequired: "Wpisz klucz.",
        keyTaken: "Ten klucz już istnieje.",
        rowHint: "Zmiany dotyczą tylko tego szkicu.",
        valuesHint: "Liczba po lewej to numer, pod którym opis odwołuje się do wartości (Boden0010-3 to trzecia wartość Boden0010). W wierszu z typem / i puste wartości się nie liczą, w wierszu bez typu (Def…) liczy się każda komórka.",
        addValue: "Dodaj wartość",
        referencesShifted: "Te odwołania będą potem wskazywać na inną wartość i nie zostaną dostosowane:",
        referenceShift: "{0}: „{1}” → „{2}”, używane w {3}",
        referenceGone: "{0}: „{1}” → brak wartości, używane w {2}",
        referencedByMore: "{0} i {1} innych",
        replaceTitle: "Zastąpić otwarty szkic?",
        replaceMessage: "Ta przeglądarka ma już szkic {0} (z {1}). Nowy szkic go zastąpi.",
        replace: "Zastąp",
        openExisting: "Otwórz go",
        open: "Otwarty szkic {0} (z {1})",
        continue: "Kontynuuj",
      },
    },
    deviceReports: {
      resultsTitle: "Wyniki",
      matchingReports: "Pasujące raporty testowe",
      filters: "Filtry",
      device: "Urządzenie",
      anyDevice: "Wszystkie urządzenia",
      deviceCategory: "Typ urządzenia",
      allCategories: "Wszystkie",
      categoryComBox: "ComBox",
      categorySensor: "Czujnik",
      categoryPanel: "Panel",
      allReportTypes: "Wszystkie",
      period: "Okres",
      noPeriodLimit: "Bez ograniczeń",
      maxAgeMonths: "Ostatnie",
      fromDate: "Od daty",
      monthsSuffix: "miesięcy",
      outcomeAll: "Wszystkie",
      outcomePassed: "Zaliczone",
      outcomeFailed: "Niezaliczone",
      assignment: "Przypisanie",
      assignmentAll: "Wszystkie",
      assignmentAssigned: "Przypisane",
      assignmentUnassigned: "Nieprzypisane",
      categoryExcludesUnassigned: "Nieprzypisane raporty nie mają jeszcze urządzenia, a więc i typu urządzenia. Są ukrywane, gdy filtrujesz według typu.",
      showReports: "Pokaż raporty",
      noneMatching: "Żaden raport testowy nie pasuje do tych filtrów.",
      countNone: "brak",
      countApprox: "ok. {0}",
      pageLimited: "Pokazano {0} najnowszych przypisanych raportów. Zawęź okres, aby zobaczyć starsze.",
      waitingBySerialNumber: "Urządzenie jeszcze nieutworzone",
      waitingByMacAddress: "Jeszcze bez numeru seryjnego",
      title: "Raporty testowe",
      serialNumber: "Numer seryjny",
      searchHint: "Wpisz numer seryjny, aby zobaczyć raporty testowe urządzenia.",
      noneForDevice: "Dla tego urządzenia nie ma raportów testowych.",
      loadFailed: "Nie udało się wczytać raportów testowych.",
      capturedAt: "Testowano",
      reportType: "Typ",
      result: "Wynik",
      uploadedBy: "Przesłane przez",
      initial: "Test początkowy",
      viewer: {
        title: "Raport testowy",
        loadFailed: "Nie udało się wczytać raportu testowego.",
        unknownDevice: "Nieznane urządzenie",
        steps: "Kroki testu",
        step: "Krok",
        comment: "Opis",
        status: "Status",
        detail: "Szczegóły",
        duration: "Czas trwania",
        rawData: "Pełny raport",
        formatPdf: "PDF",
        formatJson: "JSON",
        downloadFailed: "Nie udało się pobrać raportu testowego.",
      },
    },
  },
  administratorClient: {
    clientOptionsDialog: {
      message:
        "Wielokrotna rejestracja w portalu HyDry. Wybierz żądanego klienta.",
      title: "Wielokrotna rejestracja w portalu HyDry",
      titleForSwitchingClient: "Wybór klient",
    },
  },
  allDevices: {
    acquisitionDate: "Data nabycia",
    addNewCategory: "Utwórz nową kategorię",
    addNewCategoryDesc: "Proszę wprowadzić nazwę nowej kategorii",
    allDevicesOverview: "Urządzenia przegląd",
    availability: "Dostępność",
    available: "Dostępne",
    categoryNotSaved: "Kategoria nie została zapisana",
    categorySaved: "Kategoria została pomyślnie zapisana",
    createDeviceDialogTitle: "Utwórz nowe urządzenie typu {0}",
    currentProject: "Aktualny projekt",
    currentProjectStartedAt: "Projekt {0}, od {1}",
    deleteCategoryConfirmMessage: "Czy na pewno chcesz usunąć kategorię {0}?",
    deleteCategoryConfirmTitle: "Kategoria urządzenia usuwanie",
    deleteTemplateConfirmMessage:
      "Czy jesteś pewien, że urządzenie typu {0} powinno zostać usunięte?",
    deleteTemplateConfirmTitle: "Usuń typ urządzenia",
    deleted: "Usunięto",
    deletionConfirmationDialog: {
      errorMessage: "Błąd podczas usuwania urządzeń",
      message: "Czy na pewno chcesz usunąć wszystkie wybrane urządzenia?",
      successMessage: "Urządzenia zostały pomyślnie usunięte",
      title: "Usuwanie urządzeń",
    },
    description:
      "Zarządzanie Wszystkie urządzenia: 1 urządzenie | zarządzanie Wszystkie urządzenia: {count} urządzenia",
    descriptionAlt:
      "Wybór Wszystkie urządzenia: 1 urządzenie | Wybór Wszystkie urządzenia: {count} urządzenia",
    deviceCategoryDeleted: "Kategoria została pomyślnie usunięta",
    deviceCode: "Kod",
    deviceCreated: "Utworzono pomyślnie! Urządzenie zostało pomyślnie dodane.",
    deviceNotCreated: "Tworzenie nie powiodło się! Nie można dodać urządzenia.",
    deviceTemplateDeleted: "Typ urządzenia został pomyślnie usunięty",
    deviceTemplateNotSaved: "Typ urządzenia nie został zapisany",
    deviceTemplateSaved: "Typ urządzenia został pomyślnie zapisany",
    editCategory: "Kategoria urządzenia zmiana nazwy",
    editCategoryDesc: "Proszę wprowadzić nową nazwę dla kategorii {0}",
    editDeviceType: "Edytuj typ urządzenia",
    electricityMeter: "Prąd",
    electricityMeterForOtherDevices: "Prąd obcy",
    electricityMeterManufacturer: "Producent liczników energii",
    electricityMeterManufacturerFull: "Producent licznika energii elektrycznej",
    electricityMeterNumber: "Numer licznika energii",
    electricityMeterNumberAndManufacturer: "Numer licznika / producent",
    electricityMeterNumberFull: "Numer licznika energii elektrycznej",
    emptyDeviceCategoriesTemplatesHint:
      "Nie utworzono jeszcze żadnych kategorii urządzeń. Utwórz nową kategorię urządzeń za pomocą +.",
    emptyDeviceCategory:
      "Ta kategoria jest jeszcze pusta. Nowe typy urządzeń można tworzyć w panelu administracyjnym.",
    emptyDeviceTemplatesHint:
      "Nie utworzono jeszcze żadnych typów urządzeń. Utwórz nowy typ urządzenia za pomocą +.",
    emptyDeviceTemplatesHintWithoutCreateOption:
      "Nie przypisano jeszcze żadnych urządzeń.",
    emptyDevicesHint:
      "Nie znaleziono urządzeń. Utwórz nowe urządzenie za pomocą +.",
    emptyPanelTypes: "Nie znaleziono {0}.",
    errorCategoryNotFound: "Kategoria nie została znaleziona",
    errorDeviceNameEmpty: "Typ urządzenia jest pusty.",
    errorDevicePowerUsageTypeEmpty: "Typ użytkowania urządzenia jest pusty.",
    errorDeviceTemplateHasDevices:
      "Typ urządzenia zawierający urządzenia nie może zostać usunięty",
    errorExistingCategoryName: "Istnieje już kategoria o tej nazwie",
    errorExistingDeviceName: "Typ urządzenia o tej nazwie już istnieje.",
    errorInvalidElectricityMeterManufacturer:
      "Producent licznika jest nieprawidłowy",
    errorInvalidElectricityMeterNumber: "Numer licznika jest nieprawidłowy",
    errorInvalidManufacturer: "Producent jest nieważny",
    errorInvalidNote: "Komentarz jest nieprawidłowy",
    errorInvalidQrCode: "Kod QR jest nieprawidłowy",
    errorInvalidSerialNumber: "Numer seryjny jest nieprawidłowy",
    errorInventoryNumber: "Proszę wprowadzić numer inwentarzowy",
    errorInventoryNumberAlreadyExists:
      "Ten numer inwentarzowy został już przypisany",
    errorInventoryNumberInvalid: "Numer inwentarzowy jest nieprawidłowy.",
    errorPowerConsumptionPerHourError: "Proszę określić typową moc",
    errorQrCodeAlreadyExists: "Ten kod QR jest już zajęty",
    errorQrCodeTooLong:
      "Kod QR przekracza maksymalny limit 30 znaków, wprowadź krótszy kod.",
    filterAllDevices: "Wszystkie",
    filterAvailableDevices: "Mający zastosowanie",
    filterDevicesInUsage: "w użyciu",
    filterUnavailableDevices: "Niedostępny",
    formatLastProjectTimeInfo: "{0} - {1}",
    inventoryNumber: "Numer inwentarzowy",
    lastCheck: "letzter Check",
    lastProject: "Ostatni projekt",
    manageAllDevices: "Wybór urządzeń",
    manufacturer: "Producent",
    meterInfoStart: "Stan początkowy licznika: {0}",
    meterInfoStartEnd: "Stan licznika {0} - {1}",
    multiDevicesEditDialog: {
      title: "Edycja urządzeń",
    },
    nextCheck: "nächster Check",
    noDevicePowerUsage: "Brak",
    noDevicesFound: "Nie znaleziono żadnych urządzeń",
    noMatchingDevicesFound: "Nie znaleziono odpowiednich urządzeń",
    noQrCode: "Brak kodu",
    notAvailable: "Niedostępny",
    note: "Uwaga",
    operatingHours: "Godziny pracy",
    operatingHoursFromAssignment: "Przydział",
    powerConsumptionPerHour: "Typowa moc (W)",
    powerUsageType: "Licznik",
    qrCodeNotStored: "Brak",
    qrCodeStored: "Zapisane",
    recentlyClosedProject: "Projekt {0}, od {1} do {2}",
    recentlyClosedProjectAlt: "Projekt {0}, {1}",
    serialNumber: "Numer seryjny",
    title: "Zarządzanie wszystkimi urządzeniami",
  },
  appointmentType: {
    damageAssessment: "Obsługa szkody",
    dryingConclusion: "Demontaż osuszania",
    dryingSetup: "Osuszanie rozpoczęcie",
    followUpInspection: "Ponowne przesłanie",
    leakDetection: "Wykrywanie nieszczelności",
    measurement: "Pomiar",
    repair: "Przywrócenie",
  },
  archivedProjectList: {
    activeFilters: "--- Aktywne filtry: {0} ---",
    deletionConfirmationDialog: {
      errorMessage: "Wybrane projekty nie mogły zostać usunięte",
      errorMessageAlt: "Wybrane projekty nie mogły zostać usunięte",
      message: "Czy na pewno chcesz usunąć te projekty?",
      messageAlt: "Czy na pewno chcesz nieodwracalnie usunąć te projekty?",
      successMessage: "1 usunięty projekt | {count} usunięte projekty",
      successMessageAlt: "1 usunięty projekt | {count} usunięte projekty",
      title: "1 Usuń projekt | {count} Usuń projekty",
      titleAlt: "1 Usuń projekt | {count} Usuń projekty",
    },
    deletedProjectsOverview: "Przegląd usuniętych projektów",
    description:
      "Zarządzanie starymi projektami: 1 projekt | Zarządzanie starymi projektami: {count} projekty",
    descriptionAllProjects:
      "Globalne wyszukiwanie projektów: znaleziono 1 projekt | Globalne wyszukiwanie projektów: znaleziono projektów {count}",
    descriptionAlt:
      "Zarządzanie usuniętymi projektami: 1 projekt | Zarządzanie usuniętymi projektami: {count} projekty",
    descriptionSelectionMode:
      "Wybór starych projektów: 1 projekt | Wybór starych projektów: {count} projekty",
    descriptionSelectionModeAlt:
      "Wybór usuniętych projektów: 1 projekt | Wybór usuniętych projektów: {count} projekty",
    filterArchivedProjects: "zarchiwizowane",
    filterDeletedProjects: "usunięto",
    hint: "Kliknij, aby wybrać projekt {0}",
    manageDeletedProjects: "Wybierz usunięte projekty",
    manageOldProjects: "Wybierz stare projekty",
    loadingArchive: "załadowano {0} %",
    noArchivedProjectsFound: "--- nie znaleziono żadnych starych projektów ---",
    noProjectsFound: "--- nie znaleziono żadnych projektów ---",
    oldProjectsOverview: "Przegląd starych projektów",
    title: "Stare projekty",
    titleAllProjects: "Wszystkie projekty",
    delete: "Usuń",
    permanentlyDelete: "Usunąć",
    projectsBeingLoaded: "... W jednej chwili tworzona jest lista ...",
    restorationConfirmationDialog: {
      errorMessage: "Wybrane projekty nie mogły zostać przywrócone",
      message: "Czy na pewno chcesz przywrócić wybrane projekty?",
      successMessage:
        "1 projekt przywrócony i przeniesiony do UKOŃCZONE PROJEKTY | {count} projekty przywrócone i przeniesione do UKOŃCZONE PROJEKTY",
      title: "Przywróć 1 projekt | Przywróć  {count} projekty",
    },
    restore: "Przywracanie",
    restoreAndDelete: "Przywrócenie / usunięcie",
    restoreAndPermanentDelete: "Przywracanie / usuwanie",
    maximumProjectsSelectionLimitWarning:
      "Można wybrać maksymalnie 100 projektów",
  },
  archivedProjects: {
    deletionConfirmationDialog: {
      errorMessage:
        "Błąd podczas usuwania projektu {0}. Projekt nie został usunięty.",
      errorMessageAlt:
        "Błąd podczas usuwania projektu {0}. Projekt nie został usunięty.",
      message: "Czy na pewno chcesz usunąć ten projekt?",
      messageAlt: "Czy na pewno chcesz nieodwołalnie usunąć ten projekt?",
      successMessage: "Projekt {0} skasowany",
      successMessageAlt: "Projekt {0} usunięty",
      title: "Projekt {0} skasowany",
      titleAlt: "Projekt {0} usunąć ",
    },
    restorationConfirmationDialog: {
      errorMessage:
        "Fehler beim Wiederherstellen von Projekt {0}. Projekt nicht wiederhergestellt.",
      message: "Czy na pewno chcesz przywrócić ten projekt?",
      messageAlt: "Ten projekt jest zarchiwizowany. Przywrócić projekt?",
      successMessage:
        "Projekt {0} przywrócony i przeniesiony do UKOŃCZONE PROJEKTY",
      title: "Projekt {0} przywróć",
      titleAlt: "Przywrócić projekt",
    },
    restorationAndDeletionDialog: {
      message: "",
      title: "Projekt {0}? przywrócić / usunąć?",
      titleAlt: "Projekt {0}? przywrócić / usunąć?",
    },
  },
  assignDevice: {
    addAssignmentHint: "Nowy przydział z +",
    addHyDryAssignmentHint: "Przypisywanie nowych urządzeń Hydry za pomocą +",
    assignHyDryDevice: "Urządzenie HyDry przydzielanie",
    assignPanel: "Panel przypisać",
    assignToday: "Dzisiaj przydzielić",
    assignmentFrom: "Przydział od",
    assignmentHintTitle: "Przydział urządzeń HyDry",
    assignmentUntil: "Przydział do",
    billingViaDevice: "Rozliczanie przez: {0}",
    externalCountingStartDateError:
      "Przydział niemożliwy. Data rozpoczęcia musi być od {0}.",
    externalCountingOpenAssignmentError:
      "Przydział niemożliwy. Otwarty przydział nie jest dozwolony, ponieważ urządzenie rozliczające jest przypisane do {0}.",
    externalCountingEndDateError:
      "Przydział niemożliwy. Data zakończenia musi być do {0}.",
    countingDeviceHasActiveDependentsError:
      "Zwolnienie niemożliwe. Istnieją aktywne przydziały rozliczane przez to urządzenie. Proszę najpierw zwolnić te urządzenia.",
    countingDeviceWindowBeforeMinDate:
      "Przydział niemożliwy. Przydział urządzenia {0} kończy się przed najwcześniejszą możliwą datą rozpoczęcia tego urządzenia.",
    countingDeviceEndDateTooEarlyError:
      "Zwolnienie niemożliwe. Data zakończenia musi być {0} lub później, ponieważ istnieją zależne urządzenia z późniejszą datą zakończenia.",
    externalCountingStartDateAdjustedTitle: "Wskazówka",
    externalCountingStartDateAdjustedMessage:
      "Data rozpoczęcia przydziału została dopasowana do przydziału urządzenia {0}.",
    collidingAssignment:
      "Na {0} jest inny przydział (niż na {1}). Nie można utworzyć przydziału.",
    correct: "Skorygować",
    correctedBy: "skorygowany {0} {1}",
    countedViaExternalDevice: "Rozliczenie energii przez inne urządzenie?",
    deleteAssignmentMessage: "Czy na pewno chcesz usunąć przydział?",
    deleteAssignmentTitle: "Usuń przypisanie urządzenia",
    deviceAlreadyAssigned:
      "Urządzenie HyDry {0} jest już przypisane do projektu {1}.",
    genericDeviceAlreadyAssignedMessage:
      "Urządzenie {0} jest już przypisane do projektu {1}.",
    deviceAlreadyAssignedMessage:
      "Istnieje inny przydział na {0} (do {1}). Nie można utworzyć przydziału.",
    deviceAlreadyAssignedTitle: "Urządzenie HyDry zostało już przypisane",
    genericDeviceAlreadyAssignedTitle: "Urządzenie jest już przypisane",
    deviceBranchError:
      "Przydział niemożliwy. Urządzenie HyDry znajduje się w zakładzie {0}.",
    dryingNoStartedWarning: "Osuszanie jeszcze się nie rozpoczęło",
    errorEndDateTitle: "Sprawdź datę zakończenia przydziału",
    errorMeterReadingEnd: "Wartość musi być >= początek odczytu licznika",
    errorMeterReadingStart: "Wartość musi być >= 0",
    errorStartDateTitle: "Sprawdź datę rozpoczęcia przydziału",
    formatAssignComBox: "HyDry Box {0} przypisz",
    formatAssignPanel: "HyDry Panel {0} przypisz",
    formatCalculatedPowerConsumption: "Obliczone zużycie energii:",
    assignmentHoursPrompt: "Proszę podać czas przydziału w godzinach.",
    operationTimeHint: "{0} godzin (obliczone od {1} 12:00 do {2} 12:00)",
    formatHyDryInApartment: "Urządzenia HyDry mieszkanie {0}",
    formatHyDryInElectricitySupply: "Urządzenia HyDry pobór energii {0}",
    roomLevelAssignToRoomHint: "W tym projekcie urządzenia przypisuje się do pomieszczenia. Użyj plusa przy pomieszczeniu.",
    roomLevelNoRoomsHint: "To mieszkanie nie ma jeszcze pomieszczeń. Najpierw dodaj pomieszczenie, aby przypisać urządzenia.",
    formatPowerConsumption: "Zużycie energii: {0}",
    formatSignOffComBox: "HyDry Box {0} wyloguj",
    formatSignOffPanel: "HyDry Panel {0} wyloguj",
    genericAssignmentHintTitle: "Przydział urządzeń",
    meterReadingEnd: "Stan końcowy licznika:",
    meterReadingEndChanged: "Stanu licznika zmieniony",
    meterReadingEndChangedMessage:
      "Odczyt licznika zmieniony. Pomimo tego zapisać?",
    meterReadingFromAssignment: "Projekt {0}: {1}",
    meterReadingFromIot: "odczyt: {0}",
    meterReadingStart: "Rozpoczęcie odczytu licznika:",
    meterReadingsForPowerConsumption: "Odczyty licznika zużycia energii",
    selectNoCountingDevice: "Nie wybieraj",
    selectCountingDeviceTitle:
      "Wybierz urządzenie do rozliczania energii elektrycznej",
    useForElectricityBilling: "Użyć do rozliczenia energii?",
    noAvailableHyDryDevices: "Nie znaleziono dostępnych urządzeń HyDry",
    noAvailableDevices: "Nie znaleziono dostępnych urządzeń",
    noMatchingDeviceFound: "Nie znaleziono odpowiednich urządzeń HyDry",
    noProgramChainsInAssignmentWarning:
      "Nie znaleziono osuszania. Sprawdź okres.",
    note: "Notatka: {0}",
    noUnassignedProgramChainFoundMessage:
      "W okresie przypisania nie znaleziono żadnych osuszań. Czy mimo to utworzyć przypisanie?",
    powerConsumption: "Zużycie energii",
    powerConsumptionKWh: "Zużycie energii (kWh)",
    powerConsumptionRemote: "Zużycie energii (należy sprawdzić zdalne odczyty)",
    signOff: "Wylogowanie",
    signOffToday: "Dzisiaj wyloguj",
    releaseDependantDevicesFirst: "Zależne urządzenia muszą zostać najpierw wylogowane.",
    assignmentSavedSuccess: "Przydział zapisany pomyślnie.",
    assignmentSavedError: "Wystąpił błąd podczas zapisywania przydziału.",
    assignmentReleasedSuccess: "Przydział wylogowany pomyślnie.",
    assignmentReleasedError: "Wystąpił błąd podczas wylogowywania przydziału.",
    assignmentCorrectedSuccess: "Przydział skorygowany pomyślnie.",
    assignmentCorrectedError: "Wystąpił błąd podczas korygowania przydziału.",
    assignmentDeletedSuccess: "Przydział usunięty pomyślnie.",
    assignmentDeletedError: "Wystąpił błąd podczas usuwania przydziału.",
    releaseDevices: "Zwolnij urządzenia",
    devicesAssignedCount: "1 urządzenie przydzielone | {n} urządzeń przydzielonych",
  },
  assignDeviceToProjectBranchDialog: {
    changeBranch: "Pobierz urządzenie",
    message:
      "Urządzenie {0} jest dostępne w lokalizacji {1}. Czy urządzenie powinno zostać przeniesione do obecnej lokalizacji {2}?",
    title: "Lokalizacja urządzenia",
  },
  assignIresDevice: {
    assignAnyway: "Niemniej jednak przydzielić do tego dnia",
    assignAnywayMessage:
      "Przydział jest wykonywany z {0}. osuszanie {1} nie może zostać przydzielone.",
    chainWillBeAssignedMessage:
      "Wyrejestrowanie odbywa się w {0}. Osuszanie {1} jest przypisane.",
    dialogIncludeOverlappingProgramChainFinishedMessage:
      "W dniu {0} trwa proces osuszania (proces osuszania {1}, rozpoczęty w dniu {2}, zakończony w dniu {3}).\nTen proces osuszania nie jest przypisany.\nJeśli to możliwe, wybierz inny dzień.",
    dialogOverlappingProgramChainFinishedMessage:
      "W dniu {0} przebiega proces osuszania (proces osuszania {1}, rozpoczęty w dniu {2}, zakończony w dniu {3}).\nTen proces osuszania nie jest przypisany.\nJeśli to możliwe, wybierz inny dzień.",
    dialogOverlappingProgramChainMessage:
      "W dniu {0} trwa proces osuszania (proces osuszania {1}, rozpoczęty w dniu {2}).\nTen proces osuszania nie jest przypisany.\nJeśli to możliwe, wybierz inny dzień.",
    releaseAnyway: "Niemniej jednak, wyrejestruj się tego dnia",
  },
  assignLicences: {
    basic: "Podstawa",
    basicLicences: "Licencje podstawowe",
    damageAssessmentAndLeakDetection: "Nagrywanie",
    damageAssessmentAndLeakDetectionLicences: "Licencje rejestracja",
    drying: "Osuszanie",
    dryingLicences: "Licencje osuszanie",
    dryingAndRepair: "Osuszanie",
    dryingAndRepairLicences: "Licencje osuszanie",
    errorLicencesV3LimitExceeded:
      "Przekroczono dozwolone licencje. Kopia zapasowa nie jest możliwa.",
    errorMissingLicences: "Wszystkie licencje typu {0} są już w użyciu.",
    formatUsage: "{0} z {1}",
    formatUsageMemberClients: "{0}",
    numMemberClients: "Oddziały (bez Master)",
    leakDetection: "Wykrywanie nieszczelności",
    overviewLicences: "Przegląd licencji",
    overviewUsedLicences: "Przegląd wykorzystywanych licencji",
    selectLicences: "Licencje wybór",
  },
  assignmentDetails: {
    titleComBox: "HyDry box {0}",
    titlePanel: "HyDry Panel {0}",
  },
  changeEmailAndPassword: {
    changeEmailAndPasswordTitle: "Zmiana adresu e-mail i hasła do bazy danych",
    emailAddress: "Adres e-mail",
    emailAddressAlreadyUsed: "Ten adres e-mail jest już używany",
    firstSignInMessage: "Proszę wypełnić następujące pola",
    firstSignInTitle: "Pierwsza rejestracja",
    newEmailAddress: "Now baza danych adresy e-mail",
    oldPassword: "Dotychczasowe hasło",
    password: "Hasło",
    passwordError: "Hasło jest nieprawidłowe",
  },
  chartData: {
    ground: "Podłoga",
    groundTemp: "Temperatura podłogi",
    humidity: "Wilgotność",
    intensity: "Intensywność",
    temp: "Temperatura",
    wall: "Ściana",
    wallTemp: "Temperatura ściany",
  },
  clientData: {
    addContactPerson: "Osoba kontaktowa +",
    addDevices: "Urządzenia dodaj",
    additionalInsuranceInfo: "Dodatek ubezpieczeniowy",
    apartment: "Mieszkanie",
    apartmentNumber: "W{0}",
    appointmentAgreement: "Ustalenie terminu spotkania",
    approveProject: "Potwierdź projekt",
    approvedBy: "Projekt potwierdzony: {0} do {1}",
    changeProjectOwner: "Zmiana kierownika projektu",
    changingProjectTypeToPortalMessage:
      "Czy jesteś pewien, że projekt managera projektu powinien zostać zmieniony na projekt portalu?",
    changingProjectTypeToPortalTitle: "Zmiana typu projektu",
    changingProjectTypeToProjectmanagerMessage:
      "Czy jesteś pewien, że projekt portalu powinien zostać zmieniony na projekt menedżera projektu?",
    changingProjectTypeToProjectmanagerTitle: "Zmiana typu projektu",
    client: "Zleceniodawca",
    confirmProject: "Potwierdź projekt",
    confirmProjectTitle: "Potwierdzić projekt?",
    contact: "Kontakt ogólny",
    contactBy: "Kontakt przez",
    contactPerson: "Kontakt Mieszkanie",
    contract: "Zamówienie",
    contractCreatedBy: "Wykonane przez",
    contractType: "Typ zamówienia",
    copyClient: "Jak zleceniodawca",
    copyPolicyHolder: "Podobnie jak posiadacze polisy",
    createProject: "Projekt utworzyć",
    createdAt: "Zlecenie zarejestrowane: {0} przez {1}",
    damage: "Szkoda",
    damageAssessment: "Obsługa szkody",
    damageDay: "Data szkody",
    damageId: "Odniesienie do szkody",
    damageLocation: "Miejsce szkody",
    damageNumber: "Numer szkody",
    damageNumberShort: "Nr. szkody.",
    damageType: "Rodzaj szkody",
    datePlanned: "Planowana data",
    deleteContactPartnerConfirmationMessage:
      "Naprawdę usunąć osobę kontaktową {0}?",
    deleteContactPartnerConfirmationTitle: "Osobę kontaktową usuń",
    deleteContactPerson: "Osoba kontaktowa -",
    deleteContactPersonBlockedByDevices:
      "Mieszkanie {0} nie może zostać usunięte, ponieważ przypisane są urządzenia.",
    contactPersonAddedSuccess: "Mieszkanie {0} dodane",
    contactPersonDeletedSuccess: "Mieszkanie {0} usunięte",
    deleteProject: "Projekt usunąć",
    deleteProjectMessage: "Czy na pewno chcesz usunąć ten projekt?",
    deleteProjectErrorMessage:
      "Błąd podczas usuwania projektu {0}. Projekt nie został usunięty.",
    deleteProjectSuccessMessage: "Projekt {0} skasowany",
    deleteProjectTitle: "Projekt {0} skasowany",
    directOrder: "Zamówienie bezpośrednie",
    doNotApproveProject: "Nie potwierdzać projektu",
    firstContact: "Nawiązanie kontaktu",
    saveProjectErrorMessage: "Błąd podczas zapisywania projektu",
    formatApartment: "Mieszkanie {0}",
    formatElectricitySupply: "Pobór energii {0}",
    formatBranch: "Lokalizacja: {0}",
    formatContactPerson: "Osoba kontaktowa {0}",
    formatNote: "Uwaga: {0}",
    formatProjectNumberIres: "Numer projektu IRES: {0}",
    formatProjectNumberOffice: "Numer projektu Biuro: {0}",
    formatProjectNumberOfficeForSantec: "Numer projektu biuro: {0} / {1}",
    formatProjectOwner: "Kierownik projektu: {0}",
    formatProjectStart: "Rozpoczęcie projektu: {0}",
    formatProjectSupervisor: "Kierownik projektu: {0}",
    insurance: "Ubezpieczenie",
    insuranceCase: "Zdarzenie objęte ubezpieczeniem",
    insuranceContactName: "Nazwa",
    insuranceName: "Nazwa ubezpieczenia",
    lossAdjuster: "Likwidator szkody",
    mainContractNumber: "Główny numer zamówienia: {0}",
    missingProjectNumberOfficeMessage:
      '"Numer projektu biura" nie został określony. Potwierdzić projekt?',
    missingProjectNumberOfficeTitle: "Numer projektu biuro",
    mobilePhone: "Mobil {0}",
    moveProjectToFinishedDialog: {
      errorMessage:
        "Projekt {0} nie został przeniesiony do UKOŃCZONE PROJEKTY.",
      message:
        "Czy na pewno chcesz przenieść ten projekt do kategorii UKOŃCZONE PROJEKTY?",
      successMessage:
        "Projekt {0} został przeniesiony do kategorii UKOŃCZONE PROJEKTY",
      title: "Projekt {0} przenieść",
    },
    moveProjectToRunningDialog: {
      acceptButtonText: "Ponowne otwierać",
      acceptButtonTextAlt: "Ponownie aktywować",
      errorMessage: "Projekt {0} nie został ponownie otwarty",
      errorMessageAlt: "Projekt {0} nie został reaktywowany",
      message: "Naprawdę ponownie otworzyć projekt?",
      messageAlt: "Naprawdę ponownie aktywować projekt?",
      messageForRestoredProjects:
        "Ten projekt został przywrócony. Ponownie otworzyć projekt?",
      messageForRestoredProjectsAlt:
        "Ten projekt został przywrócony. Aktywować projekt ponownie?",
      successMessage:
        "Projekt {0} został ponownie otwarty i przeniesiony do AKTUALNE PROJEKTY",
      successMessageAlt:
        "Projekt {0} został ponownie aktywowany i przeniesiony do AKTUALNE PROJEKTY",
      title: "Projekt {0} został ponowne otwarcie",
      titleAlt: "Projekt {0} ponownie aktywować",
    },
    newOrder: "Nowe zamówienie",
    note: "Notatka",
    pdfDocument: "Dodaj PDF 1",
    pdfDocument2: "Dodaj PDF 2",
    pdfDocumentInfo: "Więcej informacji w PDF",
    phone: "Telefon {0}",
    policy: "Policja",
    policyHolder: "Ubezpieczony",
    policyNumber: "Numer polisy",
    process: "Proces",
    processNumber: "Numer procesu",
    projectControl: "Zarządzanie projektami",
    projectControlHint: "Wprowadź i zmień, klikając kolorowe pola",
    projectData: "Dane projektu",
    projectHint: "Wprowadź i zmień, klikając kolorowe pola",
    projectName: "Nazwa projektu",
    projectNumber: "Numer projektu",
    projectNumberIres: "Numer projektu IRES",
    projectNumberOffice: "Numer projektu biuro",
    projectOwner: "Kierownik projektu",
    projectStartDate: "Rozpoczęcie projektu",
    projectSupervisor: "Kierownik projektu",
    regulation: "Regulacja",
    regulationBy: "Regulacja przez",
    rejectProject: "Projekt odrzucić",
    rejectedBy: "Projekt odrzucony: {0} przez {1}",
    runningTasksSuspensionDeleteQuestion: "Na pewno usunąć?",
    runningTasksSuspensionMoveToFinishedQuestion:
      "Na pewno przenieść do UKOŃCZONE PROJEKTY?",
    runningTasksSuspensionWarning:
      "Na tym projekcie trwa jeszcze praca ({0}). Zadanie zostanie przerwane. | Na tym projekcie trwa jeszcze praca ({0}). Zadania zostaną przerwane.",
    setProjectOwner: "Ustaw kierownika projektu",
    setProjectSupervisor: "Ustaw kierownika projektu",
    timePlanned: "Zaplanowany czas",
    title: "Powitanie",
    uploadDocument: "Prześlij dokument",
  },
  clientSelector: {
    client: "Który/e oddział/y?",
  },
  cockpit: {
    allDevices: "Urządzenia zarządzanie",
    allHyDryDevices: "Wszystkie urządzenia HyDry",
    allProjects: "Wszystkie projekty",
    appointmentManagement: "Ustalenie terminu spotkania",
    appointments: {
      later: "Później",
      overdue: "Zaległy",
      today: "Dzisiaj",
      tomorrow: "Jutro",
    },
    createNewProject: "Utwórz nowy projekt",
    dummyCardTitle: "Nic do roboty!",
    extras: "Dodatki",
    formatCompany: "Oddział: {0}",
    iresExtra: {
      backToUser: "Powrót do {0}",
      selectClient: "Wybór klient",
      selectSharedUser: "Wybór współdzielonego użytkownika",
      selectUser: "Wybierz użytkownika",
    },
    iresExtras: "IRES Dodatki",
    myAppointments: "Moje spotkania",
    myHyDryDevices: "Moje urządzenia HyDry",
    myMessages: "Moje wiadomości",
    myProjects: "Moje projekty",
    projectOrganisation: "Organizacja projektów",
    projects: "Projekty",
    relevantProjects: "Odpowiednie projekty",
  },
  comBox: {
    deviceList: {
      formatSensorValuesFloor: "Podłoga: {0}, Wilgotność: {1}",
      formatSensorValuesRoom: "Pomieszczenie: {0}, Wilgotność: {1}",
    },
    deviceState: {
      active: "Osuszanie w toku",
      dryRunEnded: "Osuszanie zakończone",
      idle: "Instalacja osuszania",
      lidClosed: "Pokrywa zamknięta",
      lidOpen: "Pokrywa otwarta",
      malfunction: "Błąd",
      paused: "Wstrzymane",
      powerFail: "Wyciągnięta wtyczka",
      standBy: "Od",
      suspended: "zatrzymany",
      transition: "Przejście",
      waiting: "przerwany",
      warning: "Ostrzeżenie",
    },
    dryingPauseType: {
      humidityThresholdReached: "Aktywna pauza osuszania",
      manual: "Pauza ręczna aktywna",
      powerOverload: "Aktywna pauza przeciążeniowa",
      program: "Pauza programowa aktywna",
      temperatureTooHigh: "Aktywna pauza nadmiernej temperatury",
    },
    errors: {
      error0: "Uszkodzony zegar czasu rzeczywistego",
      error1: "Nieprawidłowy czas",
      error2: "Uszkodzona pamięć (EEPROM)",
      error3: "Uszkodzona pamięć (SPI Flash)",
      error4: "Limit czasu wyświetlania",
      error5: "Licznik energii nie odpowiada",
      error6: "Brak czujnika kontrolnego",
      error7: "Zbyt wysoka temperatura czujnika",
      error8: "Zbyt wysoka temperatura otoczenia",
      error9: "Zbyt wysoki pobór mocy",
      error10: "Zwarcie na jednym z czujników",
      error11: "Czujnik 1 nie odpowiada",
      error11New: "Co najmniej jeden czujnik nie odpowiada",
      error12: "Czujnik 2 nie odpowiada",
      error13: "Czujnik 3 nie odpowiada",
      error14: "Czujnik 4 nie odpowiada",
      error15: "Czujnik otoczenia nie odpowiada",
      error15New: "Awaria czujnika pomieszczenia",
      error16: "Przekaźnik uszkodzony",
      error17: "Modem BLE nie odpowiada",
      error18: "NB1 modem nie uruchamia się",
      error19: "Karta SIM nie została rozpoznana",
      error20: "Box przywrócenie ustawień fabrycznych",
      error21: "Reset konfiguracji urządzenia",
      error22: "Resetowanie konfiguracji klienta",
      error23: "Reset konfiguracji osuszania",
      error24: "Watchdog-Reset",
      error25: "Overrun UART 1",
      error26: "Overrun UART 2",
      error27: "Overrun UART 3",
      error28: "Overrun UART 4",
      error29: "Overrun UART 5",
    },
    events: {
      event: "Event {0}",
      event1: "Box podłączony do prądu",
      event2: "Box włączony, osuszanie przerwane",
      event3: "Box włączony, osuszanie kontynuowane",
      event6: "Box włączony",
      event7: "Rozpoczął się nowy proces osuszania",
      event8: "Nowa przebieg rozpoczęto",
      event9: "Osuszanie wstrzymane",
      event10: "osuszanie kontynuowane",
      event11: "osuszanie kontynuowane",
      event12: "Osuszanie zakończone",
      event13: "Instalacja osuszania",
      event14: "Box wyłączony",
      event15: "Krok zakończony",
      event16: "Koniec programu",
      event17: "Rozpoczęto nowy przebieg (maks. czas trwania)",
      event18: "Rozpoczęto nowy przebieg (maks. liczba próbek)",
      event20: "Pauza nocna rozpoczęcie",
      event21: "Pauza nocna zakończenie",
      event22: "Monitorowana próbka",
      event23: "Zakończono interwał monitorowania",
      event24: "PRZERWA OSUSZANIA ROZPOCZĘTA",
      event25: "Pauza nocna zakończona",
      event26: "Faza pzredłużenia",
      event28: "Ostrzeżenie",
      event29: "Funkcja błędów",
      event30: "Restart (rozruch)",
      event31: "Box odłączony od prądu",
      event32: "Połączenie BLE nawiązane",
      event33: "Połączenie BLE rozłączone",
      event34: "Start programu",
      event36: "Pokrywa otwarta",
      event37: "Pokrywa zamknięta",
      event40: "NB1 połączenie z siecią nawiązane",
      event41: "NB1 połączenie z siecią nie powiodło się",
      event42: "NB1 połączenie z serwerem nawiązane",
      event43: "NB1 połączenie z serwerem nie powiodło się",
      event44: "NB1 limit czasu połączenia",
      event45: "NB1 połączenie zamknięte",
      event46: "NB1 sieć wylogowana",
      event47: "NB1 dezaktywowany",
      event48: "NB1 połączenie zakończone (0) (wylogowanie)",
      event49: "NB1 połączenie zakończone (1) (ponowne nawiązanie)",
      event50: "NB1 połączenie zakończone (2)",
      event53: "NB1 aktualizacji jakości sygnału",
      event54: "NB1 modem włączony",
      event55: "NB1 modem wyłączony",
      event56: "NB1 ponowna próba sesji",
      event59: "Czas letni / zimowy",
      event60: "Aktualizacja czasu",
      event61: "Restart (polecenie)",
      event62: "Restart (nowa konfiguracja)",
      event64: "Reset (konfiguracja urządzenia)",
      event65: "Restart (nowe oprogramowanie sprzętowe)",
      event66: "Restart (nowe oprogramowanie)",
      event67: "Aktualizacja (konfiguracja)",
      event68: "Aktualizacja (firmware IPU)",
      event69: "Aktualizacja (Firmware Display)",
      event70: "Pomiar napięcia akumulatora",
      event71: "Depasywacja baterii rozpoczęta",
      event72: "Depasywacja baterii zakończona",
      event75: "128 Błąd na I2C2",
      event76: "NB1 stan z awarią zasilania",
      event77: "Konfiguracja czujnika zmieniona",
      event80: "Temperatura w pomieszczeniu zbyt wysoka",
      event81: "Temperatura w pomieszczeniu ok",
      event82: "Powietrze w pomieszczeniu wystarczająco osuszone",
      event83: "Powietrze w pomieszczeniu jest ponownie osuszane",
      event84: "Temperatura w pomieszczeniu bardzo niska",
      event86: "Wilgotność w pomieszczeniu bardzo wysoka",
      event88: "Pauza przeciążeniowa",
      event125: "Gniazdko zostało włączone z opóźnieniem",
      warningFixed: "Ostrzeżenie zweryfikowane",
    },
    formatComBox: "Box {0}",
    formatComBoxError: "Błąd: {0}",
    formatComBoxInfo: "Info: {0}",
    formatComBoxWarning: "Ostrzeżenie: {0}",
    humidityUnit: {
      absoluteHumidity: "wilg. abs.",
      absoluteHumidityAll: "wilg. abs./opady/ciśnienie/moc",
      absoluteHumidityAllWithoutPower: "wilg. abs./opady/ciśnienie",
      absoluteHumidityAndPower: "wilg. abs./moc",
      absoluteHumidityAndPressure: "wilg. abs./ciśnienie",
      formatAbsoluteHumidity: "{0} g/m³",
      formatAbsoluteHumidityAll: "{0} g/m³ / {1}mm / {2}hPa / {3}W",
      formatAbsoluteHumidityAllWithoutPower: "{0} g/m³ / {1}mm / {2}hPa",
      formatAbsoluteHumidityAndPower: "{0} g/m³ / {1}W",
      formatAbsoluteHumidityAndPressure: "{0} g/m³ / {1}hPa",
      formatMixingRatio: "{0} g/kg",
      formatMixingRatioAll: "{0} g/kg / {1}mm / {2}hPa / {3}W",
      formatMixingRatioAllWithoutPower: "{0} g/kg / {1}mm / {2}hPa",
      formatMixingRatioAndPower: "{0} g/kg / {1}W",
      formatMixingRatioAndPressure: "{0} g/kg / {1}hPa",
      formatPercent: "{0}%",
      formatPercentAll: "{0}% / {1}W / {2}hPa",
      formatPercentAndPressure: "{0}% / {1}hPa",
      formatPercentAndPowerConsumption: "{0}% / {1}W",
      formatPercentAndPowerConsumptionAndPressure: "{0}% / {1}W / {2}hPa",
      formatRelativeHumidity: "{0} %RH",
      mixingRatio: "Proporcja mieszania",
      mixingRatioAll: "Prop miesz/opady/ciśnienie/moc",
      mixingRatioAllWithoutPower: "Prop miesz/opady/ciśnienie",
      mixingRatioAndPower: "Prop miesz/moc",
      mixingRatioAndPressure: "Prop miesz/ciśnienie",
      powerConsumption: "Moc",
      relativeHumidity: "wilg. rel.",
      relativeHumidityAll: "wilg. rel./opady/ciśnienie/moc",
      relativeHumidityAndPressure: "wilg. rel./opady/ciśnienie",
      relativeHumidityAndPowerConsumption: "wilg. rel./moc",
      relativeHumidityAndPowerConsumptionAndPressure:
        "wilg. rel./moc/ciśnienie",
    },
    nightModeActive: "Tryb nocny aktywny",
    relativeHumidity: "wilg. rel.",
    sensorType: {
      bluetoothType3: "BLE typ 3",
      bluetoothType1: "BLE Typ 1",
      bluetoothType5: "BLE typ 5",
      empty: "Brak czujnika",
      radon: "Radon",
      sht3x: "SHT3X",
      telaire: "Telaire",
      unknow: "Nieznany",
    },
    temperature: "Temperatura",
  },
  comBoxClientConfig: {
    clientConfig: "Konfiguracja klienta HyDry Control",
    createClientConfig: "Tworzenie konfiguracji klienta HyDry Control",
    displayMessage: "Wyświetlany tekst",
    expertMode: "Tryb eksperta",
    formatSensorProgram: "S{0}",
    name: "Nazwa",
    programmSensors: "Czujniki programowe",
    selectableDryingPrograms: "Możliwy wybór programów osuszania",
    selectableDryingProgramsBox: "Możliwy wybór programów osuszania (Box)",
    selectableDryingProgramsMini: "Możliwy wybór programów osuszania (Mini)",
    defaultProgramMini: "Program standardowy (Mini)",
    selectableSensorPrograms: "Możliwy wybór programów czujnika",
    sensor: "Czujnik {0}",
    version: "Wersja",
  },
  sensorInfo: {
    title: "SENSOR INFO ({0})",
    titleRoom: "SENSOR INFO (POMIESZCZENIE)",
    serialNumber: "Numer seryjny",
    type: "Typ",
    status: "Status",
    statusOk: "OK",
    statusBatteryLow: "Niski poziom baterii",
    statusPoorLink: "Słaba jakość połączenia",
    statusSensorLost: "Czujnik utracony",
    statusTurnedOff: "Czujnik został wyłączony ręcznie",
    typeTempHumidity: "Czujnik temp / wilgotności",
    typePressure: "Czujnik ciśnienia",
    typeHammerElectrode: "Elektroda wbijana",
    typeRadon: "Czujnik radonu",
    typeInternalSensor: "Wewn\u0119trzny czujnik urz\u0105dzenia",
    connection: "Po\u0142\u0105czenie",
    wired: "Przewodowy",
    wireless: "Bezprzewodowy",
    integrated: "Zintegrowany",
    signalStrength: "Siła sygnału",
    batteryStatus: "Stan baterii",
    firmware: "Firmware",
    noData: "Brak danych czujnika",
  },
  dryingGraph: {
    temperatureAxisLabel: "Temp",
    absoluteHumidityAxisLabel: "wilg. abs.",
    relativeHumidityAxisLabel: "wilg. rel.",
    mixingRatioAxisLabel: "Prop miesz",
    resistanceDigitsAxisLabel: "Digits",
    formatResistanceDigits: "{0}",
    tooltipSensorHumidity: "Wilgotność",
    tooltipSensorResistance: "Digits",
    tooltipSensorTemperature: "Temperatura",
    tooltipWeather: "Pogoda",
    tooltipPower: "Moc",
    tooltipIntensity: "Intensywność",
    weatherDataUnavailable: "Nie udało się załadować danych pogodowych. Spróbuj ponownie później.",
  },
  comBoxDetail: {
    confirmMeterReadingPowerUpTitle: "HyDry Box będzie włączony",
    confirmMeterReadingUpMessage:
      "Proszę potwierdzić aktualny stan licznika energii",
    control: {
      change: "ZMIANA",
      confirmPowerOn: {
        messageBox:
          "Czy na pewno chcesz włączyć box? Gdy pokrywa jest otwarta, gniazda są aktywne.",
        messageMini:
          "Czy na pewno chcesz włączyć MINI? Po włączeniu MINI gniazda są aktywne.",
        title: "HyDry Box włączanie urządzenia z trybu gotowości",
      },
      formatPowerOnTitle: "Box {0} włączyć",
      iotMeterReadingHint:
        "Instrukcja jest wykonywana przy następnym połączeniu IoT. Odczyt licznika jest odczytywany i akceptowany przez IoT. Czy na pewno?",
      pause: "Pauza",
      powerOff: "WYŁĄCZYĆ",
      powerOn: "Włączanie",
      relays: "Przekaźnik",
      resume: "Kontynuuj",
      start: "Włączyć",
      terminate: "Zakończyć",
    },
    controlConfig: {
      changeDryRun: "Box {0}: Zmiana osuszania",
      currentConfigUnknown:
        "Aktualne ustawienia tego urządzenia nie są znane. Wstawiono ustawienia domyślne: sprawdź je przed zapisaniem.",
      defaultDryingMode: "Standardowa procedura",
      defaultNightMode: "Tryb nocny konfiguracji standardowej",
      defaultProgram: "Program standardowy",
      defaultProgramBox: "Program standardowy (Box)",
      defaultSocketAB: "Standardowa konfiguracja gniazd A+B",
      defaultSocketCD: "Standardowa konfiguracja gniazd C+D",
      dryRunParameters: "PARAMETRY PRACY",
      dryingMode: "Procedura",
      dryingModeChangeDisabledDialogMessage:
        "Trybu pracy nie można zmienić podczas trwającego osuszania. Najpierw należy zakończyć osuszanie.",
      dryingModeChangeDisabledDialogTitle: "Zmiana trybu pracy",
      dryingModeOptions: {
        monitor: "MONITOR",
        negativePressure: "PODCIŚNIENIE",
        positivePressure: "Nadciśnienie",
        pushPull: "Push pull",
        roomDrying: "Osuszanie kubaturowe",
      },
      formatNightModeParameters: "od {0} do {1} {2} {3}",
      formatNightModeParametersAlternate: "{0}-{1}, {2}, {3}",
      formatNightModeParametersNoDaysAlternate: "{0}-{1}, {2}",
      missingFloorSensorWarningMessageForBoxDefault:
        "Program osuszania bez wybranych czujników podłogowych: Program jest sterowany wyłącznie czasem do maksymalnego czasu trwania programu.",
      missingFloorSensorWarningMessageForBoxSupportingRoomDrying:
        "Wybrano program osuszania bez wybranych czujników podłogowych: Suszenie jest kontrolowane wyłącznie przez czas do maksymalnego czasu trwania programu. \n\nZalecamy suszenie za pomocą programu OSUSZANIE KUBATUROWE.",
      missingFloorSensorWarningStartAnyway: "Potwierdzam start",
      missingFloorSensorWarningTitle: "Sprawdź program osuszania",
      nightMode: "Tryb nocny",
      nightModeDays: "Tryb dzienny i nocny",
      nightModeEnd: "Koniec trybu nocnego",
      nightModeOff: "Tryb nocny wyłączony",
      nightModeOn: "Tryb nocny włączony",
      nightModeSockets: "Tryb nocny gniazda",
      nightModeSocketsOptions: {
        allSockets: "Wszystkie gniazda",
        allSocketsAlternate: "Wszystkie",
        allSocketsShort: "Wszystkie",
        allSocketsShortAlternate: "Wszystkie",
        programSockets: "Gniazda programowalne",
        programSocketsAlternate: "Prog",
        programSocketsShort: "Prog",
        programSocketsShortAlternate: "Prog",
      },
      nightModeStart: "Rozpoczęcie trybu nocnego",
      program: "Program",
      roomDryingHintMessageBox:
        "Zalecane są następujące ustawienia:\n\nGniazda A+B PROG: Osuszacz\nGniazda C+D ON: Wentylator i/lub urządzenia do osuszania ścian",
      roomDryingHintMessageMini:
        "Zalecane są następujące ustawienia:\n\nGniazdo A PROG: Osuszacz\nGniazdo B ON: Wentylator i/lub urządzenia do osuszania ścian",
      roomDryingHintTitle: "Osuszanie kubaturowe",
      sensors: "CZUJNIKI",
      socketA: "Gniazdo A",
      socketAB: "Gniazda A+B",
      socketB: "Gniazdo B",
      socketCD: "Gniazda C+D",
      socketModeOptions: {
        off: "Od",
        on: "Do",
        program: "Prog",
      },
      start: "Włączyć",
      startDryRun: "Box {0}: Rozpocznij osuszanie",
    },
    floorTempHumidity: "Podłoga Temp / Wilg",
    tempHumidity: "Temp / Wilg",
    formatEndOfPhase: "P{0} koniec",
    formatEndOfPhases: {
      boost: "Boost koniec",
      comfort: "Comfort Ende",
      eco: "Eco koniec",
      smart: "Smart zakończenie",
    },
    formatPhase: "Faza {0}",
    formatProgram: "P{0}",
    formatSensor: "Czujnik {0}",
    monitor: "MONITOR",
    nightModeParameters: {
      title: "Ustawienia trybu nocnego",
    },
    pause: {
      confirm: "Pauza potwierdzić",
      hint: "Przerwa (min)",
      message: "Proszę wprowadzić długość pauzy (min)",
      title: "Box {0} zatrzynać",
    },
    phases: "Fazy",
    postDryingRun: "Przebieg końcowy",
    program: "Program",
    programDryingSensor: "Czujnik osuszania",
    programDryingTime: "Czas osuszania",
    roomTempHumidity: "Temp / Wilgość w pomieszczeniu",
    sensorData: {
      roomSensor: "Pomieszczenie",
      sensor: "Czujnik",
    },
    sensorUsage: {
      measurement: "Pomiar",
      measurementShort: "POM",
      program: "Program",
      programShort: "PRG",
      reference: "Referencja",
      referenceShort: "REF",
      usage: "Wykorzystanie",
    },
    sensorUsageRecommendation: {
      dryingMode: "Tryb pracy",
      hint1: "Zalecane są następujące ustawienia czujnika:",
      hint2: "Patrz także instrukcja obsługi.",
      referenceSensor: "Czujnik referencyjny",
      roomSensor: "Czujnik pokojowy",
      roomSensorOrSensor1: "Czujnik pokojowy lub czujnik 1",
      sensor1: "Czujnik 1",
      title: "Wybrany program suszenia ze sterowaniem czujnikami",
    },
    terminateDryRun: {
      dryRunKeyValues: "DANE OSUSZANIA",
      keyValueCurrent: "Aktualny",
      keyValueDuration: "Czas działania",
      keyValueHumidity: "Wilgotność",
      keyValueMeter: "Licznik",
      keyValueStart: "Start",
      terminateDryRun: "Zakończenie osuszania",
    },
    testRelays: {
      numCycles: "Cykle przełączania",
      onOffDuration: "Czas włączenia i wyłączenia (1/10 sek.)",
      relay1Active: "Przekaźnik 1 aktywny",
      relay2Active: "Przekaźnik 2 aktywny",
      title: "Test przekaźnika {0}",
    },
    title: "Szczegóły box {0}",
  },
  comBoxSampleIotInfo: {
    batteryVoltageToLow: "Zbyt niskie napięcie akumulatora",
    disconnectFailure: "Błąd podczas wysyłania odłączenia NB1",
    formatIotInfo:
      "Komunikat o awarii zasilania: {0} ({1}), BC66: {2}, NB1: {3}, Licznik: {4}",
    iotConnectonDisabled: "NB1 połączenie dezaktywowane",
    iotServerConnectionFailure: "Serwer IoT jest niedostępny",
    noIpAddress: "Brak adresu IP",
    noNetwork: "Logowanie nie powiodło się",
    reserved: "Zarezerwowane",
    socketFailure: "Błąd podczas otwierania gniazda",
    success: "Wysłane pomyślnie",
    timeoutIotServerConnect:
      "Limit czasu przekroczony podczas łączenia się z serwerem IoT",
    unexpectedModemReset: "Nieoczekiwany reset modemu",
  },
  comBoxSettings: {
    battery: "Akumulator",
    electricityMeter: "Licznik energii elektrycznej",
    factoryReset: {
      action: "Ustawienia fabryczne",
      confirm: "Zresetuj",
      consequences: {
        datalog: "Wszystkie przebiegi zapisane w boxie zostaną usunięte. Przebiegi już przesłane przez box pozostaną w portalu.",
        queued: "Polecenia zostaną odnotowane przez IoT i wykonane przy następnym połączeniu boxa.",
        reboot: "Box uruchomi się potem ponownie.",
        terminate: "Jeśli w boxie trwa osuszanie, zostanie najpierw zakończone.",
      },
      flags: {
        bConfig: "Konfiguracja podstawowa",
        cConfig: "Konfiguracja klienta",
        counters: "Licznik godzin pracy i włączeń",
        datalog: "Dziennik danych: usuń wszystkie przebiegi z boxa",
        dConfig: "Programy osuszania i czujników",
        fileInfo: "Pliki: logo i obrazy firmware",
      },
      queueFailed: "Nie udało się odnotować resetu.",
      reboots: "Uruchamia box ponownie",
      title: "Zresetuj box {0}",
    },
    firmwareDisplay: "Firmware Display",
    firmwareIPU: "Firmware IPU",
    mcuResetSource: "MCU Reset Source",
    mcuResetSourceValues: {
      independentWatchdog: "Independent Watchdog",
      lowPower: "Niska moc",
      powerOn: "Power-On",
      resetPin: "Reset-Pin",
      software: "Oprogramowanie",
      windowWatchdog: "Window Watchdog",
    },
    restartConfirmMessage: "Ponowne uruchomienie zostanie odnotowane przez IoT.",
    restartConfirmTitle: "Uruchomić ponownie box {0}?",
    title: "Ustawienia box {0}",
  },
  common: {
    abort: "ANULUJ",
    apply: "ZASTOSUJ",
    refresh: "Odśwież",
    download: "Pobierz",
    address: "Adres",
    all: "Wszystkie",
    allDevices: "Wszystkie urządzenia",
    activeDevices: "Aktywne urządzenia",
    activeHydryDevices: "Aktywne urządzenia HyDry",
    and: "oraz",
    api: "API",
    appointment: "Termin",
    appUpdate: {
      message: "Nowa wersja jest dostępna.",
      refresh: "Odśwież",
      later: "Później",
    },
    archived: "Zarchiwizowane",
    areYouSure: "Jesteś pewien?",
    assign: "Przypisanie",
    back: "WSTECZ",
    barcode: "BARCODE",
    both: "Oba",
    box: "Box",
    branch: "Lokalizacja",
    branchDeleted: "Lokalizacje usunięte",
    branches: "Lokalizacje",
    build: "Build {0} ({1})",
    change: "ZMIANA",
    changesNotSaved: "Zmiany nie zostały zapisane",
    changesSaved: "Zapisane zmiany",
    close: "Zamknij",
    concluded: "Zakończono",
    confirm: "Potwierdzić",
    confirmationDialog: {
      cancelMessage:
        "Zmiany zostały już wprowadzone. Czy chcesz odrzucić te zmiany?",
      cancelTitle: "Odrzucić zmiany?",
      unsavedChangesMessage: "Czy na pewno chcesz anulować?",
      unsavedChangesTitle: "Uwaga: utrata danych",
    },
    confirmSignOutMessage: "Czy naprawdę chce się pan/pani wylogować?",
    confirmSignOutTitle: "Wylogowanie",
    country: "Kraj",
    currentProject: "Aktualny projekt: {0}",
    dataComplete: "Dane są kompletne",
    dataSaved: "Dane zapisane",
    date: "data",
    dayOfTheWeek: {
      friday: "pt",
      monday: "pon",
      saturday: "sob",
      sunday: "nd",
      thursday: "czw",
      tuesday: "wt",
      wednesday: "śr",
    },
    delete: "Usuń",
    deleted: "Usunięto",
    details: "szczegóły",
    development: "Development V{0}",
    device: "Urządzenie",
    deviceManager: "IRES Work",
    devices: "Urządzenia",
    drying: "Osuszanie",
    duration: {
      formatDays: "1 dzień | {count} dni",
      formatDaysOpenEnded: "1 dzień | {count} dni",
      formatHours: "1 godzina | {count} godziny",
      formatMinutes: "1 minuta | {count} minuta",
      now: "Teraz",
    },
    edit: "Edytuj",
    electricityMeter: "Licznik energii elektrycznej",
    electricityMeterKwh: "Licznik energii elektrycznej (kWh):",
    email: "Adres e-mail",
    emailShort: "e-mail",
    invalidEmailAddress: "Nieprawidłowy adres e-mail",
    end: "Koniec",
    endViewAs: "Zakończ widok",
    execute: "Wykonanie",
    executionBy: "Wykonanie przez",
    additionalUser: "Dodatkowy pracownik",
    additionalUsers: "Dodatkowi pracownicy",
    addAdditionalUser: "Dodaj dodatkowego pracownika",
    export: "Eksportować",
    filter: "Filtrować",
    finished: "Ukończony",
    firstName: "Imię",
    floor: "Adres dodatkowe informacje",
    formatKWh: "{0} kWh",
    formatPercent: "{0} %",
    formatRelativeHumidity: "{0} %RH",
    formatRun: "Przebieg {0}",
    formatRuns: "1 przebieg | {count} przebiegi",
    formatTemperature: "{0} °C",
    formatTemperatureCompact: "{0} °C",
    from: "z {0}",
    fromAlt: "od",
    fromUntil: "od {0} do {1}",
    fromUntilAlt: "od {0} do {1}",
    homeLocation: "Heimatstandort",
    houseNumber: "Numer domu",
    hydryDevices: "Urządzenia HyDry",
    usedDevices: "Używane urządzenia",
    ires: "IRES",
    iresFunctionsHint: "Widok klienta",
    isAdmin: "TAK",
    kwh: "kWh",
    lastName: "Nazwisko",
    lastProject: "Ostatni projekt: {0}",
    leakDetection: "Wykrywanie nieszczelności",
    load: "Ładowanie",
    location: "Miejsce",
    mobilePhone: "Komórka",
    moveToFinished: "Przesuwanie",
    movedToFinished: "Przesunięte",
    name: "Nazwa",
    new: "Nowy",
    never: "Nigdy",
    nfc: "NFC",
    no: "Nie",
    noMatchFound: "Nie znaleziono dopasowania",
    none: "Brak",
    noUsersToShow: "Nie znaleziono odpowiedniego Użytkownika do tego zadania.",
    notAvailable: "niedostępny",
    numPanels: "{0} HyDry",
    off: "Od",
    ok: "Ok",
    on: "Wł",
    onDate: "na {0}",
    open: "Otwarty",
    otherDevices: "Wszystkie urządzenia",
    pageNotAvailable: "Ta strona nie jest dla ciebie dostępna.",
    panel: "Panel",
    phone: "Telefon",
    portal: "IRES Office",
    production: "Produkcja V{0}",
    project: "Projekt",
    projectManager: "IRES Project",
    projects: "Projekty",
    qrCode: "QR",
    restore: "Przywracanie",
    restored: "Przywrócony",
    save: "ZAPISZ",
    saveData: "Zapisywanie danych",
    search: "Wyszukiwanie",
    select: "Wybierz",
    serialNumber: "Numer seryjny",
    signOut: "Wylogowanie",
    more: "Więcej",
    moreActions: "Więcej akcji",
    toggleTheme: "Przełącz motyw",
    signedInAs: "Zalogowany jako {0}",
    since: "od {0}",
    sinceUntil: "od {0} do {1}",
    sort: "Sortuj",
    start: "Start",
    startingAt: "od {0}",
    street: "Ulica",
    submit: "Przejęcie",
    time: "Czas",
    timeOfDay: "Pora dnia",
    todo: "TODO",
    unknown: "Nieznany",
    unsavedChangesDialog: {
      doNotSave: "NIE ZAPISYWAĆ",
      message: "Istnieją niezapisane zmiany. Czy chcesz je zapisać?",
      title: "Niezapisane zmiany",
    },
    until: "do {0}",
    user: "Użytkownik",
    userProjects: "Widok {0}",
    version: "Wersja: {0}",
    viewAsEndedNoRight: "Widok został zakończony, ponieważ nie masz już do niego uprawnień.",
    viewAsEndedUserUnavailable: "Widok został zakończony, ponieważ użytkownik nie jest już dostępny.",
    viewAsReadOnly: "W widoku innego użytkownika nie można niczego zmieniać.",
    viewOf: "Widok na: {0}",
    viewOfProjects: "Widok {0}",
    web: "Sieć",
    yes: "Tak",
    zipCode: "Kod pocztowy",
  },
  dataViewer: {
    rows: "Wiersze",
    columns: "Kolumny",
    search: "Szukaj...",
    noResults: "Brak wyników",
    noData: "Brak danych",
    noSections: "Brak sekcji",
    expandAll: "Rozwiń wszystko",
    collapseAll: "Zwiń wszystko",
    editModeOn: "Edytuj",
    editModeOff: "Zakończ edycję",
  },
  pdeViewer: {
    title: "Wymiana danych projektu (PDE)",
    loading: "Wczytywanie PDE...",
    loadError: "Nie udało się załadować danych PDE",
    noStorageLocation: "Brak ścieżki pliku PDE",
    download: "Pobierz",
    noSelection: "Brak wyboru",
    saveSuccess: "Zapisano dane PDE",
    saveError: "Nie udało się zapisać danych PDE",
    sections: {
      projectInfo: "Dane projektu",
      apartments: "Mieszkania",
      rooms: "Pomieszczenia",
      consolidatedWorkItems: "Pozycje prac (CWI)",
      materials: "Materiały",
      timeEstimate: "Szacowanie czasu",
      timeTracking: "Śledzenie czasu",
      deviceAssignments: "Przypisania urządzeń",
      workItems: "Pozycje prac",
      affectedComponents: "Dotknięte elementy",
    },
    fields: {
      projectIdIres: "ID projektu IRES",
      projectIdErp: "ID projektu ERP",
      projectTypeId: "Typ projektu",
      creationTimestamp: "Utworzono",
      pdeSchemaVersion: "Wersja schematu",
      infoConfigVersion: "Wersja opisu",
      erpBoQVersion: "Wersja LV",
      senderId: "Nadawca",
      projectStatus: "Status",
      apartmentNumber: "Mieszkanie",
      lastName: "Nazwisko",
      firstName: "Imię",
      floor: "Piętro",
      roomNumber: "Nr pokoju",
      roomName: "Nazwa pokoju",
      note: "Notatka",
      numberOfAffectedWalls: "Dotknięte ściany",
      numberOfWalls: "Liczba ścian",
      roomWidth: "Szerokość",
      roomLength: "Długość",
      roomHeight: "Wysokość",
      roomArea: "Powierzchnia",
      component: "Element",
      workItemId: "Pozycja pracy",
      billingItemId: "Pozycja rozliczeniowa",
      billingItemId2: "Pozycja rozliczeniowa 2",
      workItemText: "Opis",
      billingItemTextErp: "Tekst ERP",
      quantityIres: "Ilość IRES",
      quantityErp: "Ilość ERP",
      quantityCompleted: "Ilość zakończona",
      unit: "Jednostka",
      phase: "Faza",
      trade: "Branża",
      serviceProviderIres: "Wykonawca IRES",
      serviceProviderErp: "Wykonawca ERP",
      chapter: "Rozdział",
      section: "Sekcja",
      paragraph: "Akapit",
      asset: "Materiał",
      quantity: "Ilość",
      technicianId: "Technik",
      protectionHours: "Ochrona (godz.)",
      dismantlingHours: "Demontaż (godz.)",
      setupDryingHours: "Montaż suszenia (godz.)",
      measurementHours: "Pomiar (godz.)",
      packupDryingHours: "Demontaż suszenia (godz.)",
      restorationHours: "Renowacja (godz.)",
      entryNumber: "Nr",
      date: "Data",
      startOfWork: "Początek",
      endOfWork: "Koniec",
      travelTimeHours: "Czas dojazdu (godz.)",
      leakDetectionHours: "Wykrywanie nieszczelności (godz.)",
      damageAssessmentHours: "Ocena szkód (godz.)",
      userNumber: "Nr pracownika",
      workDone: "Wykonana praca",
      materialUsed: "Użyty materiał",
      deviceAssignmentNumber: "Nr przypisania",
      deviceType: "Typ urządzenia",
      deviceId: "ID urządzenia",
      countingDeviceId: "ID licznika",
      electricityMeterType: "Typ licznika",
      meterStart: "Licznik początkowy",
      meterEnd: "Licznik końcowy",
      consumption: "Zużycie",
      fromDate: "Od",
      toDate: "Do",
      wallNumber: "Nr ściany",
      componentWidth: "Szerokość elementu",
      componentLength: "Długość elementu",
      componentHeight: "Wysokość elementu",
      componentArea: "Powierzchnia elementu",
      damageWidth: "Szerokość szkody",
      damageLength: "Długość szkody",
      damageHeight: "Wysokość szkody",
      damageArea: "Powierzchnia szkody",
    },
    biInfo: {
      notFound: "Nie znaleziono pozycji rozliczeniowej w katalogu.",
      noCatalogReference: "PDE nie wskazuje żadnego katalogu, dlatego teksty LV są niedostępne.",
      catalogNotFound: "Żaden aktywny katalog nie pasuje do „{0}”, dlatego teksty LV są niedostępne.",
      catalogAmbiguous: "Uwaga: {0} katalogów pasuje do „{1}”. Wyświetlane teksty pochodzą z „{2}”. Sprawdź, czy to prawidłowe.",
      catalogLoadFailed: "Nie udało się załadować tekstów LV.",
    },
  },
  beschreibungViewer: {
    title: "Opis (Zadania)",
    loading: "Ładowanie opisu...",
    loadError: "Nie udało się załadować danych opisu",
    noStorageLocation: "Brak ścieżki pliku",
    download: "Pobierz",
    sections: {
      projectInfo: "Informacje o projekcie",
      apartments: "Mieszkania",
      rooms: "Pomieszczenia",
      workItems: "Pozycje robót",
      materials: "Materiały",
      timeEstimate: "Szacunek czasu",
      timeTracking: "Rejestracja czasu",
      buildingStructure: "Struktura budowlana",
      workItemChanges: "Zmiany pozycji robót",
      tasks: "Kroki robocze",
    },
    fields: {
      projectId: "Nr projektu",
      address: "Adres",
      dateTime: "Data/Godzina",
      lastName: "Nazwisko",
      firstName: "Imię",
    },
  },
  deviceDetailsDialog: {
    deviceInVehicle: "Gerät im Fahrzeug {0}",
    deviceLastMovedInfo: "Geladen von {0} am {1}",
    openProject: "Projekt otwarty",
    openVehicle: "Fahrzeug öffnen",
  },
  deviceFilter: {
    active: "aktywny",
    available: "mający zastosowanie",
    finished: "ukończony",
    inUsage: "w użyciu",
    noAssignedToProject: "bez projektu",
    notAvailable: "niedostępny",
    overall: "łącznie",
    overdue: "zaległy",
  },
  deviceHistory: {
    externalMeterUsed: "Zliczanie zewnętrzne",
    headerLabel: "Operacja {0}",
  },
  dryingHistory: {
    dryingHistoryDevice: "Historia urządzenia {0}",
    formatDryingHistoryBox: "Historia box {0}",
    formatDryingHistoryPanel: "Historia panel {0}",
    formatDryingHistoryWithChainNumber: "{0} Osuszanie {1}",
    notAvailable: "--- Historia niedostępna ---",
  },
  dryingInfo: {
    assigned: "Przypisany",
    createDryingReport: "Raport osuszania",
    day: "Dzień",
    devicesAssinged: "Przydział",
    drying: "Osuszanie",
    endValue: "Koniec",
    formatDurationClosedAssignment: "od {0} do {1} ({2})",
    formatDurationCompletedChain: "od {0} do {1} ({2})",
    formatDurationOpenAssignment: "od {0} ({1})",
    formatDurationOpenChain: "od {0} ({1})",
    formatMeterReading: "Start {0}, Koniec {1}, Zużycie {2}",
    formatMeterReadingActiveProject: "Początek {0}",
    formatMeterReadingActiveRun: "Początek {0}, Prąd {1}, Zużycie {2}",
    formatMeterReadingConsumed: "Zużycie {0}",
    formatMeterReadingEnd: "Koniec {0}",
    formatMeterReadingStart: "Początek {0}",
    formatPercentageDryingPause: "{0}, z czego {1} % przerw na suszenie",
    formatRelativeAndAbsoluteChainNumber: "{0} Osuszanie ({1})",
    formatRelativeChainNumber: "{0}. Osuszanie",
    groundTemp: "Temperatura podłogi °C",
    heatRatioWall: "Intensywność ściany %",
    humidity: "Wilgotność",
    latestValue: "aktualny",
    maxValue: "maks",
    measurements: "Wartości pomiarowe",
    minValue: "min",
    noProject: "Brak projektu",
    program: "Program",
    project: "Projekt {0}",
    resistanceDigits: "Digits",
    startValue: "Początek",
    temp: "Temp",
    wallTemp: "Ściana temperatury °C",
  },
  dryingProjectOverview: {
    apartments: "1 mieszkanie | {count} mieszkań",
    damagePatternCompletedItem: "{0} {1} ({2})",
    damagePatternConclusionStates: {
      carryOutDrying: "Przeprowadzanie osuszania",
      noContract: "Brak zamówienia",
      noDryingNecessary: "Nie wymaga osuszania",
      onHold: "Projekt wstrzymany",
      yesOffer: "Tak, oferta",
    },
    damagePatternProjectStates: {
      finished: "Projekt zakończony",
    },
    damagePatternItem: "{0} Charakter szkody ({1})",
    devices: "1 urządzenie | {count} urządzenia",
    dryingStartItem: "Początek osuszania",
    plannedDamageAssessmentItem: "{0} Wprowadzenie szkody planowane ({1})",
    projectItemFinished: "Projekt zakończony",
    projectNoContract: "Projekt zakończony, brak zamówienia",
    projectNoDryingNecessary:
      "Projekt zakończony, osuszanie nie jest potrzebne",
    projectNumberItem: "{0} Projekt {1} ({2})",
    projectOnHold: "Projekt wstrzymany",
    projectTitle: "Osuszanie: {0}",
    rooms: "1 pomieszczenie | {count} pomieszczenia",
  },
  hyDryEventLog: {
    date: "data",
    deleteNote: "Notatkę usuń",
    event: "Event",
    formatCycle: "Z{0}",
    formatPhase: "P{0}",
    formatStep: "S{0}",
    lid: "Pokrywa",
    log: "Dziennik",
    logbook: "Dziennik logwania",
    noLogs:
      "DZIENNIK LOGOWANIA nie jest jeszcze dostępny dla tego procesu osuszania.",
    note: "Notatka",
    pause: "Pauza",
    program: "Program",
    sortAscending: "Sortuj rosnąco",
    sortDescending: "Sortuj malejąco",
    step: "Krok",
  },
  hyDryEvents: {
    categories: {
      longDescription: {
        alert: "Alarm",
        drying: "Osuszanie",
        ires: "IRES",
        lid: "Pokrywa",
        note: "Notatka",
        organisation: "Organizacja",
        other: "Inne",
        pause: "Pauza",
        sensor: "Czujnik",
      },
      shortDescription: {
        alert: "Alarm",
        drying: "Osuszanie",
        ires: "IRES",
        lid: "Pokrywa",
        note: "Notatka",
        organisation: "Orga",
        other: "Inne",
        pause: "Pauza",
        sensor: "Czujnik",
      },
    },
    longDescription: {
      battery: "Bateria {0}%",
      checkDryingProgress: "Sprawdź postęp osuszania",
      comBoxDryingCompleted: "Osuszanie zakończone",
      deviceOverdue: "Zaległości w IoT",
      dryingEnded: "Osuszanie zakończone",
      dryingParametersChanged: "Zmiana parametrów osuszania",
      dryingPausedAfterPowerOn: "Prąd ponownie włączony, osuszanie przerwane",
      dryingProgramDone: "Program osuszania gotowy",
      dryingProgramStarted: "Rozpoczęto program osuszania",
      dryingProgramTerminated: "Program osuszania zakończony",
      dryingProgressNotPlausible: "Proces osuszania nie jest możliwy",
      dryingQualityAssessment: "Ocena jakości osuszania",
      dryingResumed: "osuszanie kontynuowane",
      dryingResumedAfterPowerOn:
        "Prąd ponownie włączony, osuszanie kontynuowane",
      dryingStartNotPlausible: "Rozpoczęcie osuszania nie jest możliwe",
      dryingStarted: "Rozpoczęto nowy proces osuszania",
      dryingSucceed: "Osuszanie zakończone",
      dryingSuspended: "Osuszanie wstrzymane",
      errorWhileDrying: "Błąd urządzenia podczas osuszania",
      firmware: "FW {0}",
      formatPowerFailWhileDrying: "Utrata mocy podczas osuszania (ponad {0} h)",
      interruptedDryingEnded: "przerwane osuszanie zakończone",
      interruptedDryingResumed: "przerwane osuszanie kontynuowane",
      lidClosed: "Pokrywa zamknięta",
      lidOpened: "Pokrywa otwarta",
      malfunction: "Błąd: {0}, brak osuszania",
      malfunctionWhileDrying: "Błąd: {0}, osuszanie w toku",
      manualPauseEnded: "Pauza ręczna zakończona",
      manualPauseStarted: "Pauza ręczna uruchomiona",
      newDrying: "Instalacja osuszania",
      note: "Notatka",
      pauseEnded: "Pauza zakończona",
      pauseStarted: "Pauza w osuszaniu",
      powerFailWhileDrying: "Utrata mocy podczas osuszania",
      poweredOff: "Bez podłączenia, bez osuszania",
      poweredOffWhileDrying: "Odłączony od zasilania, brak osuszania",
      poweredOn: "Podłączony",
      programCompleted: "Program osuszania gotowy",
      programPauseEnded: "Pauza programowa zakończona",
      programPauseStarted: "Pauza programowa rozpoczęta",
      programPhaseEnded: "Faza {0} rozpoczęta",
      programStepCompleted: "Rozpoczęła się faza osuszania {0}",
      prolongedPowerFail: "Dłuższa utrata mocy",
      roomDryingHumidityVeryHigh: "Wilgotność w pomieszczeniu bardzo wysoka",
      roomDryingPauseEndendHumidityTargetReached:
        "Powietrze w pomieszczeniu jest osuszane, przerwa zakończona",
      roomDryingPauseEndendTemperatureTooHigh:
        "Temperatura OK, przerwa zakończona",
      roomDryingPauseStartedHumidityTargetReached:
        "Wystarczająco osuszony, przerwa rozpoczęta",
      roomDryingPauseStartedTemperatureTooHigh:
        "Zbyt wysoka temperatura, uruchomiono pauzę",
      roomDryingTemperatureVeryLow: "Temperatura w pomieszczeniu bardzo niska",
      rssi: "RSSI {0}",
      sensorBackInRange: "Czujnik (Slot {0}) ponownie w zasięgu",
      sensorBatteryWeak: "Czujnik (Slot {0}): słaba bateria",
      sensorButtonPressed: "Czujnik (Slot {0}): naciśnięto przycisk",
      sensorConfigurationChanged: "Zmieniono konfigurację czujników: {0}",
      sensorConfigurationChangedWithEventNo:
        "Zmieniono konfigurację czujników (zdarzenie {0}):\n{1}",
      sensorConfigurationSnapshot:
        "Osuszanie rozpoczęte z konfiguracją czujników: {0}",
      sensorOutOfRange: "Czujnik (Slot {0}) poza zasięgiem",
      sensorLinkGood: "Czujnik (Slot {0}): połączenie ok",
      sensorLinkTimeout: "Czujnik (Slot {0}): przekroczono czas komunikacji",
      sensorLinkTimeoutResolved:
        "Czujnik (Slot {0}): przywrócono komunikację",
      sensorLinkWeak: "Czujnik (Slot {0}): słabe połączenie",
      sensorTurnedOff: "Czujnik (Slot {0}) wyłączony",
      successfulDryingEndend: "Zakończono ukończone osuszanie",
      timerPauseEnded: "Pauza nocna zakończenie",
      timerPauseStarted: "Pauza nocna rozpoczęcie",
      turnedOff: "Wyłączony",
      turnedOn: "Włączony",
      unknownEvent: "Nieznany",
      warning: "Ostrzeżenie: {0}, bez osuszania",
      warningWhileDrying: "Ostrzeżenie: {0}, osuszanie w toku",
    },
    shortDescription: {
      battery: "Bateria {0}%",
      checkDryingProgress: "Sprawdź postęp osuszania",
      comBoxDryingCompleted: "Osuszanie zakończone",
      deviceOverdue: "Zaległości w IoT",
      dryingEnded: "Osuszanie zakończone",
      dryingParametersChanged: "Zmiana parametrów osuszania",
      dryingPausedAfterPowerOn: "Osuszanie wstrzymane",
      dryingProgramDone: "Program osuszania",
      dryingProgramStarted: "Rozpoczęto program osuszania",
      dryingProgramTerminated: "Program osuszania zakończony",
      dryingProgressNotPlausible: "Sprawdź proces osuszania",
      dryingQualityAssessment: "Ocena jakości osuszania",
      dryingResumed: "osuszanie kontynuowane",
      dryingResumedAfterPowerOn: "osuszanie kontynuowane",
      dryingStartNotPlausible: "Sprawdź proces osuszania",
      dryingStarted: "Osuszanie rozpoczęte",
      dryingSucceed: "Osuszanie zakończone",
      dryingSuspended: "Osuszanie wstrzymane",
      errorWhileDrying: "Błąd urządzenia",
      firmware: "FW {0}",
      formatPowerFailWhileDrying: "Utrata mocy (> {0} h)",
      interruptedDryingEnded: "Osuszanie zakończone",
      interruptedDryingResumed: "osuszanie kontynuowane",
      lidClosed: "Pokrywa zamknięta",
      lidOpened: "Pokrywa otwarta",
      malfunction: "Błąd: {0}, brak osuszania",
      malfunctionWhileDrying: "Błąd: {0}, osuszanie w toku",
      manualPauseEnded: "Pauza ręczna zakończona",
      manualPauseStarted: "Pauza ręczna uruchomiona",
      newDrying: "Instalacja osuszania",
      note: "Notatka",
      pauseEnded: "Pauza zakończona",
      pauseStarted: "Pauza rozpoczęta",
      powerFailWhileDrying: "Utrata mocy",
      poweredOff: "Bez podłączenia, bez osuszania",
      poweredOffWhileDrying: "Odłączony od zasilania, brak osuszania",
      poweredOn: "Podłączony",
      programCompleted: "Program osuszania gotowy",
      programPauseEnded: "Pauza programowa zakończona",
      programPauseStarted: "Pauza programowa rozpoczęta",
      programPhaseEnded: "Krok programu {0} zakończony",
      programStepCompleted: "Osuszanie zakończyło etap programu",
      prolongedPowerFail: "Dłuższa utrata mocy",
      roomDryingHumidityVeryHigh: "Wilgotność w pomieszczeniu bardzo wysoka",
      roomDryingPauseEndendHumidityTargetReached:
        "Powietrze w pomieszczeniu jest osuszane, przerwa zakończona",
      roomDryingPauseEndendTemperatureTooHigh:
        "Temperatura OK, przerwa zakończona",
      roomDryingPauseStartedHumidityTargetReached:
        "Wystarczająco osuszony, przerwa rozpoczęta",
      roomDryingPauseStartedTemperatureTooHigh:
        "Zbyt wysoka temperatura, uruchomiono pauzę",
      roomDryingTemperatureVeryLow: "Temperatura w pomieszczeniu bardzo niska",
      rssi: "RSSI {0}",
      sensorBackInRange: "Czujnik (Slot {0}) ponownie w zasięgu",
      sensorBatteryWeak: "Czujnik (Slot {0}): słaba bateria",
      sensorButtonPressed: "Czujnik (Slot {0}): naciśnięto przycisk",
      sensorConfigurationChanged: "Zmieniono konfigurację czujników: {0}",
      sensorConfigurationChangedWithEventNo:
        "Zmieniono konfigurację czujników (zdarzenie {0}):\n{1}",
      sensorConfigurationSnapshot:
        "Osuszanie rozpoczęte z konfiguracją czujników: {0}",
      sensorOutOfRange: "Czujnik (Slot {0}) poza zasięgiem",
      sensorLinkGood: "Czujnik (Slot {0}): dobre połączenie",
      sensorLinkTimeout: "Czujnik (Slot {0}): przekroczono czas komunikacji",
      sensorLinkTimeoutResolved:
        "Czujnik (Slot {0}): przywrócono komunikację",
      sensorLinkWeak: "Czujnik (Slot {0}): słabe połączenie",
      sensorTurnedOff: "Czujnik (Slot {0}) wyłączony",
      successfulDryingEndend: "Osuszanie zakończone",
      timerPauseEnded: "Pauza nocna zakończenie",
      timerPauseStarted: "Pauza nocna rozpoczęcie",
      turnedOff: "Wyłączony",
      turnedOn: "Włączony",
      unknownEvent: "Nieznany",
      warning: "Ostrzeżenie: {0}, bez osuszania",
      warningWhileDrying: "Ostrzeżenie: {0}, osuszanie w toku",
    },
  },
  iresDevice: {
    deviceAssignedToProject: "Urządzenie przypisane do projektu",
    deviceInUsage: "Urządzenie jest w użyciu",
    deviceNotAvailable: "Urządzenie jest przypisane do innego oddziału",
    formatBatteryStatus: "{0} V, Uwaga {1}",
    moveDevicesButtonText: "Urządzenia przesuwanie",
    moveDevicesDialog: {
      assignmentStartDate: "od daty",
      branch: "Lokalizacja",
      client: "Który/e oddział/y?",
      errorMessage: "Urządzenia nie mogły zostać przeniesione",
      successMessage:
        "1 urządzenie przesuniete | {count} urządzenia przesuniete",
      title: "Urządzenia przesuwanie",
    },
    notAvailable: "--- Urządzenie niedostępne ---",
  },
  iresDeviceDetail: {
    comBoxDoesNotExist: "Nie ma HyDry Box o numerze seryjnym {0}.",
    panelDoesNotExist: "Nie ma HyDry Panel o numerze seryjnym {0}.",
    neverReportedSince: "{0} utworzono {1}, ale urządzenie jeszcze nigdy się nie zgłosiło.",
    neverReported: "{0} utworzono, ale urządzenie jeszcze nigdy się nie zgłosiło.",
    warningCheckProjectAssignment: "Sprawdź okres przypisania projektu",
    warningNoProgramChainsInClosedAssignment:
      "Ten przydział ten nie zawiera osuszania",
  },
  iresDeviceSensor: {
    floorSensor1: "Czujnik1",
    floorSensor2: "Czujnik2",
    floorSensor3: "Czujnik3",
    floorSensor4: "Czujnik4",
    ground: "Podłoga",
    guideSensor: "Przewodnik",
    humidity: "Wilgotność",
    resistanceDigits: "Digits",
    intensity: "Intensywność",
    intensityAll: "Intensywność/opady/ciśnienie",
    intensityAndRelativeHumidityAndPressure:
      "Intensywność/wzgl. wilgotność/ciśnienie",
    roomSensor: "Pomieszczenie",
    temperature: "Temperatura",
    wall: "Ściana",
  },
  iresDeviceType: {
    box: "HyDry Box",
    edge: "HyDry Edge",
    formatHyDryBox: "HyDry box {0}",
    formatHyDryMini: "HyDry Mini {0}",
    formatHyDryPanel: "HyDry Panel {0}",
    mini: "HyDry Mini",
    panel: "HyDry Panel",
    slim: "HyDry Slim",
  },
  joinSharedEmailAddress: {
    errorWrongPassword: "Hasło jest nieważne",
    formatMessage:
      "Adres e-mail {0} jest współdzielony przez innego użytkownika, wprowadź hasło współdzielonego adresu e-mail.",
    title: "Wspólny adres e-mail",
  },
  language: {
    de: "Niemiecki",
    en: "Angielski",
    fr: "Francuski",
    it: "Włoski",
  },
  leakDetectionProjectOverview: {
    conclusion: "Zakończenie",
    leakDetection: "Wykrywanie nieszczelności",
    projectCreation: "Nowe urządzenie",
    projectItemFinished: "Projekt zakończony",
    projectTitle: "Wykrywanie nieszczelności: {0}",
  },
  location: {
    addressEdited: "Adres zmieniony. Kliknij, aby ponownie wyszukać pozycję.",
    ambiguous:
      "Ten adres pasuje do {0} możliwych miejsc. Wybierz właściwe z listy podpowiedzi lub ustaw punkt samodzielnie.",
    backfilled: "Kod pocztowy i miejscowość przejęte ze znalezionego adresu: {0}",
    confidence: {
      CONFIRMED: "Adres potwierdzony",
      GOOD: "Ustalone automatycznie, dobra jakość",
      POOR: "Ustalone automatycznie, słaba jakość",
      UNRELIABLE: "Brak użytecznej pozycji",
    },
    crossCheckMismatch:
      "Znaleziona pozycja należy do innego adresu niż wprowadzony. Sprawdź ją na mapie.",
    geocodingFailed: "Nie znaleziono adresu. Ustaw punkt samodzielnie na mapie.",
    legend: {
      CONFIRMED: "potwierdzony",
      GOOD: "dobry",
      POOR: "niedokładny",
      UNRELIABLE: "nieprzydatny",
      title: "Kolory",
    },
    lookingUp: "Szukanie pozycji …",
    mapLoadFailed: "Nie udało się załadować mapy.",
    noAddress: "Podaj co najmniej miejscowość, ulicę lub kod pocztowy.",
    pickerHint:
      "Przeciągnij punkt lub kliknij mapę, aby dokładnie ustawić pozycję. Pozycja zostanie zapisana dla funkcji przejazdów, a wprowadzony adres pozostanie bez zmian.",
    pickerHintReadonly: "Pozycja adresu.",
    pickerTitle: "Pozycja",
    quality: {
      APPROXIMATE: "Pokaż na mapie (położenie przybliżone)",
      GEOMETRIC_CENTER: "Pokaż na mapie (środek ulicy lub miejscowości)",
      MANUAL: "Pokaż na mapie (ustawione ręcznie)",
      RANGE_INTERPOLATED: "Pokaż na mapie (numer domu oszacowany)",
      ROOFTOP: "Pokaż na mapie (dokładny budynek)",
      none: "Jeszcze nie zlokalizowano. Pokaż na mapie",
      unknown: "Pokaż na mapie (dokładność nieznana)",
    },
    search: {
      hint: "Wpisz adres i wybierz pasującą podpowiedź.",
      label: "Szukaj adresu",
      noResults: "Nie znaleziono podpowiedzi.",
    },
  },
  login: {
    clientHandover: {
      opening: "Otwieranie jako klient …",
      failed: "Logowanie jako klient nie powiodło się. Zamknij tę kartę i spróbuj ponownie w IRES Admin Client.",
      refused: "Logowanie jako klient zostało odrzucone: {0} Zamknij tę kartę.",
    },
    backToLogin: "Powrót do logowania",
    clientPortal: "HyDry Portal klienta",
    clientPortalEmail: "Adres e-mail portalu",
    emailAddress: "Adres e-mail",
    forgotPassword: "Zapomniałeś hasła?",
    forgotUserPassword: "Zapomniałeś hasła użytkownika?",
    forgotUserPasswordMessage:
      "Prosimy o kontakt z administratorem lub z nami pod adresem support@hydry.de.",
    login: "Zaloguj się",
    loginContactEmail: "Poczta support@hydry.de",
    loginContactText:
      "Jeśli jako nasz partner nie jesteś zarejestrowany do użytku, poinformuj nas o tym e-mailem.",
    loginFailed:
      "Logowanie nie powiodło się. Sprawdź swój adres e-mail i hasło.",
    loginFailedBlocked:
      "Logowanie nie powiodło się. Użytkownik z adresem mailowym {0} jest zablokowany.",
    signInRefused: {
      CLIENT_BLOCKED: "Logowanie niemożliwe. Dostęp twojej firmy jest zablokowany. Skontaktuj się z IRES.",
      USER_BLOCKED: "Logowanie niemożliwe. Twój użytkownik jest zablokowany. Skontaktuj się z administratorem.",
    },
    loginWelcomeText: "Proszę się zalogować",
    loginWelcomeTitle: "HyDry Zarządzanie i zdalne sterowanie urządzeniami",
    networkBlocked: "Połączenie zablokowane. Sprawdź ustawienia proxy lub VPN i spróbuj ponownie.",
    noInternetAvailable: "Brak połączenia z internetem. Sprawdź połączenie sieciowe i spróbuj ponownie.",
    password: "Hasło",
    passowrdEmailSharing: "Hasło",
    passwordResetEmailAlreadySent:
      "Wiadomość e-mail umożliwiająca zresetowanie hasła została już wysłana. Prosimy o sprawdzenie skrzynki odbiorczej i jeśli to konieczne, folderu spamu.",
    passwordResetEmailError:
      "Wystąpił błąd podczas wysyłania wiadomości e-mail w celu zresetowania hasła. Spróbuj ponownie.",
    passwordResetEmailSent:
      "Wiadomość e-mail z prośbą o zresetowanie hasła została pomyślnie wysłana.",
    passwordResetSharedEmailError:
      "Nie można zresetować hasła udostępnionego użytkownika. Skontaktuj się z administratorem systemu.",
    pleaseSignIn: "Proszę wprowadzić identyfikator użytkownika i hasło",
    pleaseSignInWithEmail: "Proszę wprowadzić swój adres e-mail",
    resetPassword: "Resetowanie hasła",
    sessionEnd: "Zalogowałeś się na innym urządzeniu",
    unknownEmailAddress:
      "Logowanie do portalu HyDry dla {0}: Nie znaleziono adresu e-mail {1}. Czy użytkownicy zostali utworzeni poprawnie?",
    userIdentification: "Identyfikator użytkownika",
  },
  messageSettings: {
    erp: "ERP",
    erpConnection: "ERP-Połączenie",
    filterAll: "Filtr całkowity",
    filterMyProject: "Wiadomości z projektów",
    filterNoProject: "Filtr projekt",
    logCategories: "Klasy logowania",
    logCategoriesTotal: "Klasy logowania razem",
    mailboxes: "Skrzynki pocztowe",
    messages: "Wiadomości",
    organisationCapability: "Orga-Zadanie",
    organisationRole: "Orga-Rola",
    projectRole: "Rola w projekcie",
    selectLogCategories: "Wybór klas dziennika",
    showMessagesToProjectOwners: "do procesora",
    showMessagesToProjectSupervisors: "do menedżera",
  },
  messages: {
    details: {
      currentProject: "Aktualny projekt",
      device: "Urządzenie",
    },
    formatDrying: "Osuszanie {0}",
    formatMessagesTitle: "Nowe wiadomości ({0})",
    formatMoreMessages: "+{0}",
    formatNewMessages: "{0} ogółem",
    formatNewMessagesForCapability: "{0} do {1}",
    formatNewMessagesForMailbox: "{0} nowy do skrytki pocztowej {1}",
    formatNewMessagesForMe: "{0} do mnie",
    formatNewMessagesForRole: "{0} do {1}",
    formatNumNewMesssages: "1 nowa wiadomość | {count} nowe wiadomości",
    markAsRead: "Przeczytane",
    message: "Wiadomość",
    messages: "Wiadomości",
    newMessages: "łącznie",
    newMessagesForCapability: "do {0}",
    newMessagesForMailbox: "do skrytki pocztowej {0}",
    newMessagesForMe: "do mnie",
    newMessagesForRole: "do {0}",
    noMessagesFound: "--- nie znaleziono żadnych wiadomości ---",
    sortBy: {
      messageDate: "Najnowsze",
      projectNumber: "Numer projektu",
      serialNumber: "Numer seryjny",
    },
    yesterday: "wczoraj",
  },
  openProgramChainDecision: {
    confirmReleaseMessage:
      "Anulowanie nastąpiło w dniu {0} Proces osuszania {1} będzie przypisany. W razie potrzeby skorygować stan licznika końcowego.",
    decide: "Proszę o decyzję",
    deleteAssignment: "Usuń przydział",
    message:
      "Trwa proces osuszania {0} (proces osuszania {1}, rozpoczęty w dniu {2}).\n\nCzy rzeczywiście należy anulować zadanie w dniu {3}? Proces osuszania zostanie wówczas przerwany, a odczyt licznika energii elektrycznej może zostać w razie potrzeby skorygowany.",
    noProgramChainsFoundInAssignmentRange:
      "W okresie przypisania nie znaleziono żadnych osuszań. Czy mimo to anulować przydział?",
    openProgramChain: "OSUSZANIE W TOKU",
    recentlyActiveDeviceWarning:
      "Alternatywnie należy wybrać ANULUJ i wybrać inną datę.",
    release: "Wylogowanie",
    releaseDescription: "Mimo to wyloguj się",
    stop: "Stop",
    stopBoxMessage: "Chcesz zakończyć osuszanie z Box {0}?",
    stopCommandQueuedMessage:
      "Polecenie STOP odnotowane przez IoT. Chcesz poczekać czy wylogować się teraz?",
    stopDescription: "Zakończyć osuszanie teraz?",
    stopDrying: "KONIEC OSUSZANIA",
    stopPanelMessage: "Chcesz zakończyć osuszanie panelem {0}?",
    wait: "Oczekiwanie",
    waitDescription: "Poczekaj na koniec osuszania",
  },
  notFound: {
    message: "Ta strona nie istnieje (już).",
    toCockpit: "Do Cockpitu",
  },
  overview: {
    active: "aktywny",
    activeProjects: "Aktywne projekty",
    availableIresDevices: "Dostępne urządzenia HyDry",
    default: "HyDry Manager projektów",
    deviceTypeHyDryComBoxes: "HyDry Boxy",
    deviceTypeHyDryPanels: "HyDry Panele",
    deviceTypes: "1 Typ urządzenia | {count} Typy urządzeń",
    devices: "1 urządzenie | {count} urządzenia",
    devicesOnlyWebsite: "HyDry",
    error: "Błąd",
    finished: "ukończony",
    inUsage: "w użyciu",
    iotClientPortal: "HyDry Portal klienta",
    manageDevices: "Zarządzanie urządzeniami",
    manageProjects: "Zarządzanie projektami",
    office: "Office",
    overall: "łącznie",
    overdue: "zaległy",
    projectManagement: "Zarządzanie projektami",
    projectOption: "HyDry Opcja projektu",
    recentlyFinished: "zakończono",
    warning: "Ostrzeżenie",
    website: "Portal projektu HyDry",
    withDevice: "w tym z urządzeniami HyDry",
  },
  pages: {
    allDevices: "Wszystkie urządzenia",
    archivedProjects: "Stare projekty",
    cockpit: "Kokpit",
    createProject: "Projekt utworzyć",
    devices: "Urządzenia HyDry",
    help: "Informacje",
    maps: "Mapy",
    mira: "Mira",
    messages: "Wiadomości",
    notFound: "Nie znaleziono strony",
    overview: "Przegląd",
    panelDetails: "Panel szczegóły",
    projectDetails: "Szczegóły projektu",
    projects: "Projekty",
    scheduling: "Planowanie operacyjne",
    aiPredictions: "RENO",
    settings: "Ustawienia",
    users: "Użytkownik",
    vehicles: "Fahrzeugbeladung",
    timeTrackingHistory: "Rejestracja czasu",
  },
  panel: {
    events: {
      event: "Event {0}",
      event0: "Próbka danych co minutę",
      event1: "Włączony",
      event10: "Zakończenie programu (ostatni etap)",
      event11: "Koniec programu (maksymalny czas działania)",
      event12: "Koniec programu (część grzewcza)",
      event13: "Zakończenie programu (ręczne)",
      event13Log: "Osuszanie zakończone ręcznie",
      event14: "Faza chłodzenia przerwana",
      event15: "Osuszanie jest kontynuowane",
      event16: "Maks. Osiągnięty czas osuszania",
      event18: "Krok zakończony",
      event19: "Ręczny restart",
      event1Log: "Panel włączony",
      event2: "Wyciągnięta wtyczka",
      event20: "Maks. czas nagrzewania przekroczony",
      event20Warning: "Ostrzeżenie: Przekroczono maksymalny czas nagrzewania",
      event21: "Ostrzeżenie: Zadziałał czujnik położenia",
      event22: "Osiągnięta maksymalna temperatura podłogi",
      event24: "Przekroczona temperatura (85 °C)",
      event24Log: "Przekroczona temperatura na ścianie i / lub podłodze",
      event25: "Zbyt wysoka temperatura obudowy",
      event255: "Nieznany",
      event25Log: "Przekroczona temperatura w obudowie panelu",
      event26: "Osiągnięta maks. temperatura czujnika",
      event27: "Osiągnięta max. temperatura chipa czujnika Edge",
      event28: "Panel grzewczy włączony",
      event28Log: "Panel grzewczy (ścienny) ponownie aktywny po przegrzaniu",
      event29: "Panel grzewczy (podłogowy) włączony.",
      event29Log: "Panel grzewczy (podłogowy) ponownie aktywny po przegrzaniu",
      event2Log: "Odłączony od zasilania, brak osuszania",
      event3: "Restart po przerwie w zasilaniu / reset",
      event30: "NB1 połączenie z siecią nie powiodło się",
      event31: "NB1 połączenie z siecią nawiązane",
      event32: "NB1 połączenie z serwerem nie powiodło się",
      event33: "NB1 połączenie z serwerem nawiązane",
      event34: "NB1 limit czasu połączenia",
      event35: "NB1 połączenie zakończone (0) (wylogowanie)",
      event36: "NB1 połączenie zakończone (1) (ponowne nawiązanie)",
      event37: "NB1 połączenie zakończone (timeout)",
      event39: "NB1 niedostępny",
      event39Log: "NB1 modem został wyłączony",
      event4: "Automatyczny start",
      event48: "DATALOG_EVT_MIN_MALFUNCTION",
      event49: "DATALOG_EVT_POSITION",
      event5: "Ręczne uruchamianie",
      event50: "Błąd: Nie można zainicjować pamięci EEPROM.",
      event51: "Błąd: Konfiguracja urządzenia jest błędna.",
      event52: "Błąd: Nie można zainicjować pamięci flash SPI.",
      event53: "Błąd: Datalog nie jest spójny (uszkodzony system plików?)",
      event54: "Błąd: Nie można zainicjować RTCC.",
      event55:
        "Błąd: Czas w urządzeniu jest nieprawidłowy lub zegar nie jest ustawiony.",
      event56:
        "Błąd: Konwerter ADC MCU jest uszkodzony lub dostarcza nieprawidłowe wartości.",
      event57: "Błąd: Jeden z czujników podczerwieni jest uszkodzony.",
      event59:
        "Błąd: Licznik energii jest uszkodzony lub podaje nieprawidłowe wartości.",
      event5Log: "Ręczne rozpoczęcie osuszania",
      event6: "Start po opóźnieniu włączenia",
      event60: "Błąd: Pobór prądu nie odpowiada statusowi pracy.",
      event61: "Błąd: Tabela programu jest nieprawidłowa.",
      event62:
        "Zadziałało wyłączenie bezpieczeństwa (alarm temperatury sprzętu).",
      event63:
        "Błąd: Czujnik przyspieszenia do wykrywania stanu jest uszkodzony.",
      event64: "Błąd: moduł BLE",
      event65: "Błąd: moduł NB1",
      event66: "DATALOG_OUT_OF_TIME",
      event68: "Aktualizacja oprogramowania (firmware) rozpoczęta",
      event69: "Aktualizacja oprogramowania (firmware) powiodła się",
      event6Log: "Rozpoczęcie programu po CZEKAJ",
      event7: "Start po osiągnięciu temperatury bazowej",
      event70: "Pomiar akumulator",
      event71: "Ogrzewanie wyłączone",
      event71Log: "Monitorowanie mocy aktywne: Sprawdź zasilanie!",
      event72: "Ogrzewanie włączone",
      event72Log: "Monitorowanie mocy aktywne: Zasilanie ok.",
      event73: "Redukcja mocy spowodowana wahaniami napięcia zasilania.",
      event74: "Wahania napięcia zasilania",
      event75: "Stabilne napięcie zasilania",
      event76: "NB1 stan z awarią zasilania",
      event8: "Krok Event",
      event80: "Restart dla aktualizacji konfiguracji",
      event81: "Restart dla aktualizacji firmware",
      event82: "Ustawiony czas",
      event9: "Rozpoczęcie kolejnego programu",
      event90: "Start depasywacji",
      event91: "Koniec depasywacji",
    },
  },
  panelControl: {
    command: "Command",
    commandFlag: "Command Flagge",
    confirmCancelQueuedRequestMessage:
      "Czy na pewno nie chcesz wykonać oznaczonej akcji?",
    confirmCancelQueuedRequestTitle: "Zatrzymanie oznaczonej akcji",
    executingCommandImmediatly:
      "Komunikacja odbywa się za pośrednictwem IoT. To chwilę potrwa.",
    executingCommandNextIotConnection:
      "Instrukcja jest wykonywana przy następnym połączeniu IoT.",
    loadRunsQueued: "Przebieg ładowania ustalony",
    programSelection: "Wybór programu",
    queuedRequestFactoryReset: "Reset przez IoT odnotowany",
    queuedRequestLoadRuns: "Przebieg ładowania przez IoT odnotowany",
    queuedRequestPause: "Pauza przez IoT odnotowana",
    queuedRequestPowerChangeDryRun: "Zmiana przez IoT odnotowana",
    queuedRequestPowerOffComBox: "Wyłączanie przez IoT odnotowane",
    queuedRequestPowerOnComBox: "Włączanie przez IoT zlecone",
    queuedRequestPowerStartDryRun:
      "Uruchomienie za pośrednictwem IoT odnotowane",
    queuedRequestRelayTest: "Test przekaźnika przez IoT odnotowany",
    queuedRequestRestartPanel: "Ponowne uruchomienie przez IoT odnotowano",
    queuedRequestResume: "Kontynuowanie przez IoT zlecone",
    queuedRequestSelectProgram: "Start P {0} za pośrednictwem IoT odnotowany",
    queuedRequestStartPanel: "Uruchomienie za pośrednictwem IoT odnotowane",
    queuedRequestStopPanel: "Stop przez IoT odnotowany",
    queuedRequestTerminate: "Zakończenie osuszania za poprzez IoT odnotowane",
    queuedRequestUpdateIotConfig:
      "Aktualizacja konfiguracji IoT przez IoT odnotowana",
    runId: "ID przebiegu",
    runIdError: "Proszę wprowadzić liczbę z zakresu od 0 do 255.",
    start: "Włączyć",
    startPanelTitle: "Panel {0} od P {1} {2} rozpocząć",
    startQueued: "Początek odnotowany",
    stopPanelTitle: "Panel {0} zatrzymać",
    stopQueued: "Stop odnotowany",
  },
  panelDetail: {
    actions: {
      closeProgramChainText: "Osuszanie od {0} do",
      endDrying: "KONIEC OSUSZANIA",
      history: "Historia",
      loadRuns: "Przebiegi załadować",
      notes: "Uwagi",
      programChooser: "Wybór programu",
      progress: "Przebieg",
      restart: "Restart",
      graph: "Wykres",
      runs: "Runs",
      setComBoxOffline: "Box wylogować",
      setHyDryDeviceOffline: "Urządzenie HyDry wyrejestrowanie",
      setPanelOffline: "Panel wylogować",
      setPanelOfflineMessage: "Proszę wprowadzić datę wyłączenia panelu",
      startPanel: "Start",
      stopPanel: "Stop",
    },
    connectReason: "Connect Reason",
    connectReasonDescriptions: {
      0: "NIEZNANY",
      1: "Prąd wyłączony",
      2: "okresowo",
      3: "Nowa przebieg",
      4: "Krok zakończony",
      5: "Prąd włączony",
      6: "Ostrzeżenie",
      7: "Błąd",
      8: "Oddzielone BLE",
      9: "Ponowna próba sesji",
      10: "Reconnect",
    },
    coooling: "Chłodzenie",
    disconnected: "Oddzielnie",
    drying: "Osuszanie",
    dryingPhaseInfo: {
      error: "Błąd",
      program0: "Przebieg końcowy",
      program1ToProgram7: "Osuszanie aktywne",
      warning: "Ostrzeżenie",
    },
    dryingProgram: "Program osuszania",
    dryingProgressGraph: {
      formatTemperature: "{0} °C",
      temperature: "Temperatura",
    },
    dryingProgressGraphControl: {
      formatDrying: "Osuszanie {0}",
      groundTemp: "Temperatura podłogi",
      log: "Dziennik",
      new: "Nowy",
      next: "Osuszanie >",
      nextShort: ">",
      overview: "Łącznie",
      previous: "< Osuszanie",
      previousShort: "<",
      rateDrying: "jakość",
      single: "Pojedynczy",
      wallTemp: "Temperatura ściany",
    },
    event: "Event",
    externalCountingMeter: "Rozliczenia za energię elektryczną: {0}",
    formatChainAndProgram: "Osuszanie {0} / Program {1}",
    formatDryingProgram: "P{0}",
    formatDryingProgramWithName: "P{0}: {1}",
    formatHeatRatio: "{0}%",
    formatHeatRatioAll: "{0}% / {1}hPa",
    formatHeatRatioAndRelativeHumidityAndPressure: "{0}% / {1}% / {2}hPa",
    formatHeatRatioWithLabel: "Intensywność: {0}%",
    formatTemperatureGround: "Podłoga: {0} °C",
    formatTemperatureWall: "Ściana: {0} °C",
    formatTemperatureWallAndGround: "Ściana: {0} °C / Podłoga: {1} °C",
    formatTemperatureWallAndGroundMax:
      "Ściana maks {0} °C / Podłoga maks {1} °C",
    formatTemperatureWallMax: "Ściana maks {0} °C",
    heatRatio: "Intensywność",
    heating: "Rozgrzewka",
    heatingInfo: "FirstTime/FHR/HR/CR/HRatio",
    idle: "Kontrola temperatury",
    lastEvent: "Ostatnie wydarzenie",
    lastInfo: {
      current: "aktualny",
      days: "1 dzień temu | {count} dni temu",
      hours: "{0} h temu",
      lastPing: "PING {0}",
      lastPingCurrent: "PING na bieżąco",
      minutes: "1 min temu",
    },
    lastInformation: "Ostatnia informacje",
    lastMeterReading: "ostatnie odczytanie {0}",
    loadRunsOptions: {
      startFromBeginning: "Od początku",
      startFromRunId: "Od przebiegu ID",
    },
    malfunction: "Błąd",
    maxTemperature: "maks temperatura",
    meterReading: "Stan licznika",
    meterReadingByUser: "Odczytane zużycie energii elektrycznej (kWh)",
    metereReadingStartEnd: "Początek {0} Koniec {1}",
    noActiveProgramChainWarning: "Brak aktywnego osuszania",
    noData: "brak danych",
    noInfoAvailable: "brak dostępnych informacji",
    noProgramChainFound:
      "Nie znaleziono osuszania w oknie czasowym tego przydziału.",
    numDryings: "1 osuszanie | {count} osuszań",
    numRuns: "Przebiegi",
    operatingStatus: "Status działania",
    powerConsumption: "Zużycie energii",
    powerFail: "Wyciągnięta wtyczka",
    powerUp: "Zasilany",
    progStepCycle: "Prog/Krok/Cykl",
    runInfo: {
      duration: "Czas trwania: {0}",
      durationActiveRun: "Dane: {0} z {1}",
      formatRunProgramInfo: "T {0} / Przebieg {1} / {2}",
      heatingPercentageAndPowerConsumption: "{0}% ogrzewania, {1} kWh",
      programDescription: "O {0} / P {1}",
      programDescriptionIdle: "T {0} / P 0 Kontrola temperatury",
      programMonitor: "MONITOR",
      programP0: "Kontrola temperatury",
      programPX: "P{0}",
      runAssigned: "{0} od {1} do {2}",
      runAssignedOpenEnded: "{0} od {1}",
      runDescription: "Przebieg {0} z {1} do {2}",
      runDescriptionActive: "Przebieg {0} od {1} {2}",
      runDescriptionAdjusted: "Przebieg {0} z {1} do {2}*",
      runDescriptionSingleDay: "Przebieg {0} na {1} do {2}",
      runDescriptionSingleDayAdjusted: "Przebieg {0} na {1} do {2}*",
      runNoProject: "Brak projektu",
      runNotAssigned: "Nie przypisano",
      stepsAndCycles: "Kroki/Cykle: {0}/{1}",
      t0: "T0: {0}m",
      temperatureGroundAndWall: "Ściana: {0}-{1} °C / Podłoga: {2}-{3} °C",
      temperatureWall: "Ściana: {0}-{1} °C",
    },
    runTime: "Czas działania",
    runningSince: "Osuszanie w toku",
    source: {
      ble: "BLE",
      iot: "IoT",
    },
    step: "Kroki",
    temperature: "Temperatura",
    title: "Szczegóły panel {0}",
    waiting: "Oczekiwanie",
    warning: "Ostrzeżenie",
  },
  panelList: {
    activeFilters: "--- Aktywne filtry: {0} ---",
    description:
      "Zarządzanie urządzeniem HyDry: 1 urządzenie | Zarządzanie urządzeniami HyDry: {count}",
    descriptionAlt:
      "Wybór urządzeń HyDry: 1 urządzenie | Wybór urządzeń HyDry: {count} urządzeń",
    devicesOfProject: "'Gerätestatus Projekt \"{0}\"'",
    filterActiveDevices: "Aktywne urządzenia",
    filterAllDevices: "Wszystkie urządzenia",
    filterDevicesOverdueDevices: "Zaległe urządzenia",
    filterDevicesWithWarningOrError: "Urządzenia z ostrzeżeniem / błędem",
    filterFinishedDevices: "gotowe urządzenia",
    filterInUsage: "Urządzenia używane",
    filterNotAssignedToProject: "Urządzenia bez projektu",
    hint: "Wybierz urządzenie za pomocą kliknięcia",
    hyDryDevicesOverview: "Urządzenia przegląd",
    manageHyDryDevices: "Wybór urządzeń",
    noDevicesFound: "--- nie znaleziono żadnych urządzeń ---",
    ownComBoxes: "Wyświetlanie własnych urządzeń",
    sortByDryingStart: "Początek osuszania",
    sortByInventoryNumber: "Numer inwentarzowy",
    sortByProject: "Projekt",
    sortBySerialnumber: "Numer seryjny",
    sortByStatus: "Status",
    testBoxes: "Box wyświetlić test",
  },
  panelSettings: {
    configName: "Konfiguracja",
    firmwareIPU: "Firmware IPU",
    restartConfirmMessage: "Ponowne uruchomienie zostanie odnotowane przez IoT.",
    restartConfirmTitle: "Uruchomić ponownie panel {0}?",
    title: "Ustawienia Panel {0}",
  },
  pdfReport: {
    device: "Urządzenie",
    deviceNumber: "Nr",
    end: "Koniec",
    finalReport: "Osuszanie techniczne: raport końcowy",
    formatPowerConsumption: "Zużycie energii {0}",
    formatProjectName: "Projekt {0}",
    from: "von",
    hyDryDevicesUsgae: "HyDry zastosowanie urządzenia",
    hyDryDryingInfo: "HyDry Dane osuszania",
    intermediateReport: "Osuszanie techniczne: raport okresowy",
    meterNumber: "Nr. licznika energii..",
    noHyDryDevicesUsed:
      "Do tego projektu nie zostały przypisane żadne urządzenia HyDry.",
    powerConsumption: "Zużycie",
    start: "Początek",
    sumPowerConsumption: "Całkowite zużycie energii",
    until: "bis",
  },
  pickerDialog: {
    noSelection: "Brak wyboru",
  },
  programChainNote: {
    createNoteTitle: "Komentarz utwórz",
    deleteNoteConfirmationDialogMessage:
      "Naprawdę chcesz usunąć ten komentarz?",
    deleteNoteConfirmationDialogTitle: "Komentarz usuń ",
    note: "Komentarz +",
    notePlus: "Komentarz +",
    noteSaved: "Komentarz zapisany",
  },
  projectConclusion: {
    concludeProject: "Projekt zakończyć",
    concludeProjectDialogMessage:
      "Czy chcesz ukończyć Projekt {0}?",
    concludeProjectMessage:
      "Czy chcesz ukończyć Projekt {0} i stworzyć raport końcowy?",
    createFinalReport: "Tworzenie raportu okresowego",
    createFinalReportButton: "Tworzenie raportu końcowego",
    createInterimReport: "Tworzenie raportu okresowego",
    createReport: "Tworzenie raportu",
    description: "Zakończenie projektu i wyrejestrowanie urządzeń HyDry",
    formatProjectFinished: "Zakończono od {0} do {1}",
    projectConcluded: "Projekt zakończony",
    projectDuration: "Czas trwania projektu",
    releaseFinalReport: "Zatwierdzenie raportu końcowego",
    reopenProjectButtonText: "Projekt ponowne otwarcie",
    sendFinalReport: "Zatwierdzenie raportu końcowego",
    signOffAllDevices: "Wszystkie urządzenia wylogowane",
    signOffAllHyDryDevices: "Wyloguj wszystkie urządzenia HyDry",
    signOffAllDevicesMessage:
      "Czy chcesz wyrejestrować wszystkie urządzenia HyDry z tego projektu?",
    signOffAllDevicesSuccess: "Wszystkie urządzenia HyDry wyrejestrowane",
    withReport: "Z raportem",
    withoutReport: "Bez raportu",
  },
  projectDetails: {
    createNote: "Notatkę utwórz",
    documents: "Dokumenty",
    erp: "ERP",
    logBook: "Dziennik logwania",
    meterReadingStart: "Licznik energii elektrycznej początek: {0}",
    noDevicesAssigned: "--- brak przypisanych urządzeń ---",
    notAvailable: "--- Projekt niedostępny ---",
    note: "Notatka",
    notes: "Uwagi",
    powerConsumption: "Zużycie energii: {0}",
    project: "Projekt",
    projectConclusion: "Zakończenie projektu",
    projectConclusionShort: "Zakończenie",
    projectNameAlreadyExistsMessage:
      "Istnieje już projekt o wybranej nazwie. Zapisać go mimo to?",
    projectNameAlreadyExistsTitle: "Nazwa projektu już istnieje",
    projectNumberAlreadyExists: "Numer projektu już istnieje",
    projectScope: {
      damageAssessment: "Obsługa szkody",
      deviceAssignment: "Gerätezuordnung",
      drying: "Osuszanie",
      leakDetection: "Wykrywanie nieszczelności",
      devicesRental: "Leihgeräte",
      restoration: "Przywrócenie",
    },
    projectTypeCodes: {
      1: "LO",
      2: "TR",
      3: "TW",
      4: "LT",
      5: "LW",
      6: "WH",
      7: "BR",
      8: "GZ",
      9: "GL",
    },
    projectTypeDefault: "Projekt Typ {0}",
    reports: "Raporty",
    timeLine: "Oś czasu",
    updateNote: "Notatkę edytuj",
  },
  projectList: {
    activeFilters: "--- Aktywne filtry: {0} ---",
    description:
      "Zarządzanie projektem suszenia: 1 projekt | Zarządzanie projektem suszenia: {count} Projekty",
    filterAllProjects: "wszystkie projekty",
    filterOverdue: "zaległy",
    filterProjectsWithOngoingDrying: "OSUSZANIE AKTYWNE",
    filterRecentlyFinished: "zakończono",
    filterRestoredProjects: "przywrócony",
    filterWithDevices: "z urządzeniami HyDry",
    finishedProjects: "Ukończone projekty",
    filterProjectsMovedToFinished: "przesunięte",
    hint: "Wybierz projekt za pomocą kliknięcia, nowy projekt za pomocą +",
    hintWithoutOptionToCreate: "Wybierz projekt za pomocą kliknięcia",
    newestProjets: "Najnowsze projekty",
    noProjectsFound: "--- nie znaleziono żadnych projektów ---",
    numAllDevices: "{0}/{1} aktywnych urządzeń",
    numAllDevicesAllActive: "1 urządzenie aktywne | {count} urządzeń aktywnych",
    numAllDevicesNoneActive: "1 urządzenie | {count} urządzenia",
    numApartments: "1 mieszkanie | {count} mieszkań",
    numRooms: "1 pomieszczenie | {count} pomieszczenia",
    oldestProjects: "Najstarsze projekty",
    overdueProjects: "Zaległe projekty",
    projectFinished: "Projekt zakończony",
    projectNumber: "Numer projektu",
    projectProgress: "Postęp projektu",
    recentProjects: "Aktualne projekty",
    relevantProjectsTitle: "Odpowiednie projekty",
    showFinishedProjects: "Pokaż ukończone projekty",
    showFinishedProjectsShort: "Ukończone",
    showRecentProjects: "Pokaż aktualne projekty",
    showRecentProjectsShort: "Aktualny",
    title: "Wszystkie projekty",
    types: {
      archived: "Stary",
      deleted: "Usunięto",
      finished: "Ukończone",
      running: "Aktualny",
    },
    urgency: "Pilność",
  },
  projectLogs: {
    activeFilters: "--- Aktywne filtry: {0} ---",
    eventLogs: {
      appointmentDamageAssessment: "Termin rejestracja szkody",
      appointmentDryingConclusion: "Termin deinstalacji osuszania",
      appointmentDryingConclusionPortalProject: "Początek demontażu osuszania",
      appointmentDryingPreparation: "Termin instalacji osuszania ",
      appointmentDryingPreparationPortalProject:
        "Początek instalacji osuszania",
      appointmentFollowUpInspection: "Ponowne przesłanie",
      appointmentIntermediate: "Termin pomiary",
      appointmentLeakDetection: "Termin lokalizacja nieszczelności",
      appointmentRepair: "Przywrócenie terminu",
      autoTimeTracking: "",
      clientDataCompleted: "K1: Dane projektu są kompletne",
      damageAssessmentCompleteFinished: "K3: Pełna obsługa szkody zakończona",
      damageAssessmentEasyFinished: "K3: Prosta obsługa szkody zakończona",
      damageAssessmentFinished: "K3: Obsługa szkody zakończona",
      damageAssessmentPlanned: "K1: Obsługa szkody zaplanowana {0}",
      damageAssessmentRoomAdded: "{0}: {1}, {2} dodane",
      damageAssessmentRoomDeleted: "{0}: {1}, {2} usunięte",
      contactPersonAdded: "Mieszkanie {0} dodane",
      contactPersonDeleted: "Mieszkanie {0} usunięte",
      damageAssessmentStarted: "K3: Obsługa szkody rozpoczęta",
      damagePatternConclusion: "K4: Obraz szkody gotowy",
      damagePatternFinished: "K3: Obsługa szkody zakończona",
      damagePatternReopened: "K4: Obraz szkody ponownie otwarty",
      damagePatternStarted: "K4: Opis szkody rozpoczęty",
      damageReportSent: "K4: Raport uszkodzeń wysłany",
      devicesSetupCompleted: "K7: Urządzenia przydział zakończony",
      documentationAndLeakDetectionFinished:
        "K2: Wykrywanie nieszczelności przeprowadzono",
      documentationAndLeakDetectionSectionFinished:
        "K2: Zarejestrowane dane projektu",
      dryingCompleted: "K8: Osuszanie zakończone",
      dryingFinished: "K7: Koniec suszenia, urządzenia zdemontowane",
      dryingNecessary: "Wymagane osuszanie",
      dryingNotNecessary: "Osuszanie nie jest wymagane",
      dryingNotSuccessful: "Osuszanie nie powiodło się",
      dryingProgressCompletedFollowUp:
        "K6: Ponowne złożenie wniosku zakończone",
      dryingProgressCompletedMeasurement: "K6: Pomiar zakończony",
      dryingProgressStarted: "K6: Pomiar rozpoczęty",
      dryingProjectFinished: "K4: Projekt zakończony",
      dryingRunning: "Osuszanie aktywne",
      dryingSetupFinished: "K5: Rozpoczęcie osuszania zakończone",
      dryingSetupStarted: "K5: Rozpoczęcie osuszania",
      dryingSuccessful: "Osuszanie skuteczne",
      finished: "Ukończony",
      followUpInspectionDate: "Ponowne przesłanie {0}",
      interimReportSent: "K8: Raport okresowy wysłany",
      leakDetectionExecutionCompleted:
        "K2: Wykrywanie nieszczelności zakończone",
      leakDetectionExecutionStarted: "K2: Wykrywanie nieszczelności rozpoczęto",
      leakDetectionPreparationCompleted:
        "K2: Przygotowanie do wykrywania nieszczelności zakończone",
      leakDetectionPreparationFinished: "K2: Przygotowanie zakończone",
      leakDetectionPreparationStarted: "K2: Przygotowania rozpoczęte",
      leakDetectionProjectConclusionStarted:
        "K4: Zakończenie projektu rozpoczęte",
      leakDetectionProjectFinished: "K4: Projekt zakończony",
      leakDetectionProjectReopened: "K4: Projekt wznowiony",
      leakDetectionReportSent: "K4: Wysłano raport z wykrywania nieszczelności",
      leakDetectionStarted: "K2: Wykrywanie nieszczelności rozpoczęto",
      measurementCreated: "K6: Pomiar wykonany (seria pomiarowa {0})",
      measurementSeriesChangedK2WithDescription:
        "K6: Zmieniono serię pomiarową {0}",
      measurementSeriesChangedK2WithDescriptionWithoutTile:
        "Serię pomiarową {0} zmieniono",
      measurementSeriesCreatedK2WithDescription:
        "K6: Seria pomiarowa {0} utworzona",
      measurementSeriesCreatedK2WithDescriptionWithoutTile:
        "Serię pomiarową {0} utworzono",
      mergedDevicesSetup: "K7: Urządzenia przydział rozpoczęty",
      note: "",
      packupDevicesFinished: "K7: Urządzenia zdemontowane",
      packupDevicesStarted: "K7: Urządzenia demontaż rozpoczęty",
      portalProjectCreation: "Nowy projekt",
      projectAssigned: "Przydzielony projekt",
      projectAssignedWithUserInfo: "Projekt przypisany do użytkownika {0}",
      projectCompletedFinalTile: "K8: Projekt zakończony",
      projectConclusionCompleted: "K8: Finalizacja",
      projectConclusionStarted: "K8: Rozpoczęto zakończenie projektu",
      projectCreation: "K1: Nowy projekt",
      projectCreationWithDamageDay: "K1: Nowy projekt, dzień szkody {0}",
      projectDeleted: "Projekt usunięty",
      projectDeletedInApp: "Projekt in Project App gelöscht",
      projectFinished: "K8: Projekt zakończony",
      projectMovedToArchived: "Projekt zarchiwizowany",
      projectMovedToFinished: "Projekt przełożony",
      projectReactivated: "Projekt został ponownie aktywowany",
      projectReopened: "K8: Projekt wznowiony",
      projectReopenedFromPortal: "Projekt został ponownie otwarty",
      projectReportSent: "K8: Raport z projektu wysłany",
      projectRestored: "Projekt przywrócony ",
      projectResult: "",
      projectWorkStarted: "K2: Rozpoczęto przetwarzanie projektu",
      startedCachedProjectEdit: "",
      stepDamageAssessmentAppointment: "",
      stepDamageAssessmentComplete: "K4: Obsługa szkody zakończona",
      stepDamageAssessmentResult: "",
      stepDryingConclusionAppointments: "",
      stepDryingConclusionResults: "K7: Osuszanie zakończone",
      stepDryingSetUpAppointments: "",
      stepDryingSetUpCompletions: "Osuszanie w toku",
      stepFirstContact: "K1: Nawiązano kontakt",
      stepIntermediateMeasurementAppointments: "",
      stepIntermediateMeasurementCompletions: "K6: Pomiar zakończony",
      stepLeakDetectionAppointment: "",
      stepLeakDetectionResult: "K4: Wykrywanie nieszczelności gotowe",
      stepOfferResultDryingApproved: "K4: Osuszanie zwolnione",
      stepOfferResultDryingNotApproved: "K4: Projekt zakończony",
      stepOfferSendToInsurance: "K4: Oferta wysłana do firmy ubezpieczeniowej",
      stepProjectAccepted: "K1: Zamówienie zarejestrowane",
      stepProjectApprovedProjectFinished: "K8: Projekt zakończony",
      stepProjectApprovedProjectSaved: "K1: Projekt potwierdzony",
      stepProjectResult: "K8: Projekt zakończony",
      stepRepairAppointments: "",
      stepRepairStart: "",
      tile1: "K1",
      tile2: "K2",
      tile3: "K3",
      tile4: "K4",
      tile5: "K5",
      tile6: "K6",
      tile7: "K7",
      tile8: "K8",
      timeTracking: "",
      timeTrackingReportSent: "Wysłany wpis czasu",
    },
    eventLogFilter: {
      allLogs: "wszystkie wpisy",
      autoTimeTracking: "Automatyczne wpisy",
      notes: "Uwagi",
      noteAndStatus: "Status + notatki",
      timeTracking: "Ręczne wpisy",
    },
    eventLogSortOrder: {
      newestFirst: "Najnowszy",
      oldestFirst: "Starsi",
    },
    noLogs: "--- nie znaleziono dzienników ---",
    noteLogs: {
      apartment: "Mieszkanie",
      defaultApartmentName: "Mieszkanie",
      dialog: {
        createErrorMessage: "Błąd podczas dodawania notatki",
        createSuccessMessage: "Notatka została pomyślnie dodana",
        deletionConfirmationMessage: "Czy na pewno chcesz usunąć notatkę?",
        deletionConfirmationTitle: "Notatkę usuń",
        deletionErrorMessage: "Błąd podczas usuwania notatki",
        deletionSuccessMessage: "Notatka została pomyślnie usunięta",
        editErrorMessage: "Błąd podczas edycji notatki",
        editSuccessMessage: "Notatka została pomyślnie edytowana",
        titleCreate: "Notatkę wprowadź",
        titleEdit: "Notatkę edytuj",
        useForReport: "w raporcie zewnętrznym",
      },
      note: "Notatka",
      noteTitle: "Notatka:",
      noteIn: "Notatka w {0}",
      room: "Pomieszczenie",
      roomName: "Pokój {0}",
    },
    numberOfLogsDisplayed: "1 Dziennik | {count} Dzienniki",
    projectState: {
      allApartments: " (Alle Wohnungen)",
      apartmentNumber: " (W{0})",
      approveProject: "Potwierdź projekt",
      damageAssessmentBegun: "Schadenaufnahme begonnen",
      damageAssessmentCompletedWithoutTile: "Obsługa szkody zakończona",
      dryingConcluded: "Osuszanie zakończone",
      dryingDuration: "Osuszanie: 1 dzień | Osuszanie: {count} dni",
      dryingPackupBegun: "Rozpoczącie demontażu osuszania",
      dryingRunning: "Osuszanie aktywne",
      dryingSetupBegun: "Rozpoczęto instalację osuszania",
      establishFirstContact: "Kontakt wprowadzanie",
      firstContactEstablished: "Kontakt ustalony",
      interimReportCreated: "Przygotowano raport okresowy",
      intermediateMeasurementBegun: "Messung begonnen",
      leakDetectionBegun: "Leckortung begonnen",
      leakDetectionFinished: "Wykrywanie nieszczelności gotowe",
      makeAppointment: "Uzgadnianie terminów",
      noDrying: "Brak  osuszania",
      noReport: "Brak raportu",
      offerSendToInsurance: "Oferta wysłana do firmy ubezpieczeniowej",
      orderRecorded: "Przyjęte zamówienie",
      orderRejected: "Zamówienie odrzucone",
      projectApproved: "Projekt potwierdzony",
      projectItemFinished: "Projekt zakończony",
      projectOnHold: "Projekt wstrzymany",
      repairStarted: "Przywrócenie w toku",
      reportCreated: "Utworzono raport",
    },
  },
  projectOperationSource: {
    api: "API",
    cloudFunction: "Chmura",
    deviceManagerApp: "IRES Work",
    portal: "IRES Office",
    projectManagerApp: "IRES Project",
    pythonScript: "Skrypt",
  },
  projectOverview: {
    recordedByItem: "{0} {1} ({2})",
  },
  projectStateFilter: {
    allProjects: "Projekt | Projekty",
    assignDevices: "Urządzenia przydzielanie",
    concludeProjekt: "Projekt zakończyć",
    damageAssessment: "Obsługa szkody",
    drying: "Osuszanie",
    dryingConclusion: "Demontaż osuszania",
    dryingSetup: "Osuszanie rozpoczęcie",
    followUpInspection: "Ponowne przesłanie",
    insuranceOffer: "Oferta dla firmy ubezpieczeniowej",
    intermediateMeasurement: "Pomiar pośredni",
    leakDetection: "Wykrywanie nieszczelności",
    missingDryingApproval: "Osuszanie zatwierdzić | Osuszania zatwierdzić",
    missingFirstContact: "Kontakt wprowadzanie | Kontakty wprowadzania",
    missingProjectApproval: "Potwierdź projekt | Potwierdź projekty",
    missingProjectConclusion: "Zakończenie projektu | Zakończenie projektów",
    missingProjectOwner: "bez przydzielonego pracownika",
    missingProjectSupervisor: "bez kierownika projektu",
    missingReport: "bez raportu",
    new: "Nowy",
    overall: "Łącznie",
    overdue: "Zaległy",
    ownProjects: "własny projekt | własne projekty",
    projectSupervisor: "Odpowiedzialny projekt | Odpowiedzialne projekty",
    recentlyFinished: "niedawno sfinalizowany",
    repair: "Przywrócenie",
    withHyDryDevices: "z urządzeniami HyDry",
  },
  projectStatus: {
    acceptOrder: "Potwierdzić projekt?",
    actionAcceptOrder: "Potwierdź projekt",
    actionRejectOrder: "Projekt odrzucić",
    allApartments: "Wszystkie mieszkania",
    appointmentStep4: "Termin lokalizacja nieszczelności",
    appointmentStep6: "Termin rejestracja szkody",
    appointmentStep10: "Termin instalacji osuszania ",
    appointmentStep12: "Termin pomiary",
    appointmentStep14: "Termin deinstalacji osuszania",
    appointmentStep16: "Przywrócenie terminu",
    approvalStatus: "Status zatwierdzenia: {0}",
    approvalStatuses: {
      noDryingNecessary: "nie wymaga osuszania",
      yesExecute: "Tak, wykonać",
      yesOffer: "Tak, oferta",
    },
    controlMeasurement: "Zakończenie pomiarów kontrolnych",
    csvTrades: "Handel",
    damageDescription: "Opis szkody: {0}",
    dateTime: "Data / godzina",
    documentsFilename: "ALLE_DOKUMENTE",
    downloadAll: "Alle Dokumente",
    downloadExternalReport: "Zewnętrzny raport",
    downloadInternalReport: "Raport wewnętrzny",
    downloadReport: "Raport",
    dryingAreaFloor: "Powierzchnia podłogi (m²)",
    dryingAreaWallCeiling: "Powierzchnia ściany / sufitu (m²)",
    dryingDuration: "Czas osuszania (dni)",
    dryingPackupStarted: "Rozpoczącie demontażu osuszania",
    dryingSetupStarted: "Rozpoczęto instalację osuszania",
    formatAppointment: "Termin: {0}",
    formatDryingDuration: "Osuszanie: 1 dzień | Osuszanie: {count} dni",
    formatEstimatedDryingDuration: "Czas osuszania 1 dzień | Czas osuszania {count} dni",
    formatDryingAreaFloor: "Podłoga {0} m²",
    formatDryingAreaWallCeiling: "Ściana / sufit {0} m²",
    hyDryCertificate: "HyDry Zertifikat",
    note: "Notatka: {0}",
    orderAccepted: "Projekt potwierdzony",
    orderRejected: "Projekt odrzucony",
    parameters: "Informacja",
    phaseInfo4: "Leckortung begonnen",
    phaseInfo6: "Schadenaufnahme begonnen",
    phaseInfo10: "Rozpoczęto instalację osuszania",
    phaseInfo12: "Messung begonnen",
    phaseInfo14: "Rozpoczącie demontażu osuszania",
    phaseInfo16: "Wiederherstellung begonnen",
    projectEndDesc: "Koniec projektu: {0}",
    projectState: {
      archived: "Projekt został zarchiwizowany",
      deleted: "Projekt został usunięty",
      finished: "Projekt został ukończony",
      movedToFinished: "Projekt został przełożony",
    },
    projectStepDescription: "Opis",
    releaseDrying: "Zatwierdzić osuszanie?",
    servicesCSV: "Tabela wydajności CSV",
    step: "Krok",
    step1: "Zarejestrowane zamówienie",
    step10: "Początek instalacji osuszania",
    step11: "Zakończenie instalacji osuszania",
    step12: "Początek pomiarów",
    step13: "Zakończenie pomiaru",
    step14: "Początek demontażu osuszania",
    step15: "Zakończenie osuszania",
    step16: "Początek odtwarzania",
    step17: "Zakończenie odtworzenia",
    step18: "Projekt zakończony",
    step2: "Projekt potwierdzony?",
    step3: "Nawiązanie kontaktu",
    step4: "Początek lokalizacji przecieku",
    step5: "Zakończenie wykrywania nieszczelności",
    step6: "Początek obsługi szkody",
    step7: "Zakończenie obsługi szkody",
    step8: "Oferta dla firmy ubezpieczeniowej",
    step9: "Zatwierdzenie osuszania",
    stepDoneBy: "Przeprowadzone przez",
    appointmentAlreadyCompleted: "Termin został już zakończony i nie można go usunąć.",
    appointmentDeleteError: "Wystąpił błąd podczas usuwania terminu.",
    appointmentDeleteSuccess: "Termin został pomyślnie usunięty.",
    appointmentSaveSuccess: "Termin został pomyślnie zapisany.",
    user: "Użytkownik",
  },
  projectStep: {
    acceptOrder: "Przyjąć zamówienie?",
    appointmentDamageAssessment: "Obsługa szkody",
    appointmentDryingConclusion: "Demontaż osuszania",
    appointmentDryingSetup: "Osuszanie rozpoczęcie",
    appointmentIntermediateMeasurement: "Pomiar",
    appointmentLeakDetection: "Wykrywanie nieszczelności",
    appointmentMissingDate: "Kiedy???",
    appointmentMissingResponsibleUser: "Kto???",
    appointmentNow: "natychmiast",
    appointmentOpenResposibleUser: "Operator: otwarty",
    appointmentRestoration: "Przywrócenie",
    approveDrying: "Zatwierdzić osuszanie?",
    approveProject: "Potwierdź projekt",
    assignDevices: "Urządzenia przydzielanie",
    concludeProject: "Projekt zakończyć",
    damageAssessmentResumed: "Obsługa szkody wznowiona",
    damageAssessmentSuspended: "Obsługa szkody przerwana",
    damageAssessmentFinished: "Obsługa szkody zakończona",
    damageAssessmentRunning: "Obsługa szkody w toku",
    damageDescription: "Rozmówca / opis szkody",
    dryingApproved: "Osuszanie zwolnione",
    dryingCompleted: "Osuszanie zdemontowane",
    dryingConcluded: "Osuszanie zakończone",
    dryingFinished: "Osuszanie zakończone",
    dryingPackupResumed: "Demontaż osuszania wznowiony",
    dryingPackupSuspended: "Demontaż osuszania przerwany",
    dryingNecessary: "Wymagane osuszanie?",
    dryingRunning: "Osuszanie aktywne",
    dryingSetupFinished: "Osuszanie zainstalowane",
    dryingSetupResumed: "Montaż osuszania wznowiony",
    dryingSetupSuspended: "Montaż osuszania przerwany",
    dryingSuccessful: "Osuszanie zakończone sukcesem?",
    establishFirstContact: "Kontakt wprowadzanie",
    firstContactEstablished: "Kontakt ustalony",
    followUpInspectionShorthand: "WV",
    formatDryingFinished: "{0}: Osuszanie zdemontowane",
    formatDryingRunningSince: "Osuszanie aktywne od {0}",
    formatDryingSetupFinished: "{0}: Osuszanie zamontowane",
    formatIntermediateMeasurementFinished: "{0}: Messung durchgeführt",
    formatRepairFinished: "{0}: Wiederherstellung abgeschlossen",
    intermediateMeasurementFinished: "Messung durchgeführt",
    intermediateMeasurementResumed: "Pomiar wznowiony",
    intermediateMeasurementSuspended: "Pomiar przerwany",
    interimReportCreated: "Przygotowano raport okresowy",
    leakDetectionFinished: "Wykrywanie nieszczelności gotowe",
    leakDetectionResumed: "Wykrywanie nieszczelności wznowione",
    leakDetectionSuspended: "Wykrywanie nieszczelności przerwane",
    leakDetectionRunning: "Wykrywanie nieszczelności w toku",
    makeAppointment: "Uzgadnianie terminów",
    noContract: "Brak zamówienia",
    noDrying: "Brak  osuszania",
    noReport: "Brak raportu",
    note: "Uwaga",
    offerSend: "Oferta wysłana do firmy ubezpieczeniowej",
    orderRecorded: "Zarejestrowane zamówienie",
    orderRejected: "Zamówienie odrzucone",
    projectApproved: "Projekt potwierdzony",
    projectEnd: "Koniec projektu",
    projectFinished: "Projekt zakończony",
    projectOnHold: "Projekt wstrzymany",
    projectStepRepairFinished: "Przywrócenie zakończone",
    projectStepRepairStarted: "Przywrócenie w toku",
    projectStepSetupDrying: "Instalacja osuszania w toku",
    repairResumed: "Przywrócenie wznowione",
    repairSuspended: "Przywrócenie przerwane",
    repairFinished: "Przywrócenie zakończone",
    reportCreated: "Utworzono raport",
    setProjectSupervisor: "Ustaw kierownika projektu",
  },
  rateDrying: {
    dryingDuration: {
      formatShouldHaveStoppedAt: "J. dokonałby demontażu osuszania na {0}.",
      shouldHaveRunLonger:
        "J. pozwoliłby na jeszcze dłuższy przebieg osuszania.",
      shouldHaveStoppedAt: "Kiedy J. miałby zostać zdemontowany?",
      title: "Czas osuszania",
    },
    formatPhase: "Faza {0}",
    formatPhases: {
      boost: "Boost",
      comfort: "Comfort",
      eco: "Eco",
      smart: "Smart",
    },
    formatPhaseNew: "Faza",
    formatPhaseShort: "P{0}",
    formatPhaseShortNew: "P",
    formatRateHistoryBox: "Jakość Box {0} osuszanie {1}",
    formatRateHistoryPanel: "Panel jakości {0} osuszanie {1}",
    postDryingRun: "Przebieg końcowy",
    quality: "jakość",
    qualityDrying: {
      bad: "Zadowalający",
      dryingSpeed: "prędkość",
      flow: "Przepływ",
      good: "dobry",
      long: "Raczej długi",
      ok: "ok",
      roomHumidity: "Wilgotność w pomieszczeniu",
      roomTemperature: "Temperatura w pomieszczeniu",
      short: "Raczej krótki",
      title: "Jakość osuszania",
      tooLong: "zbyt długo",
      tooShort: "za krótki",
      veryBad: "zły",
      veryGood: "bardzo dobry",
    },
    qualityNotes: {
      EDTGeneral: "OP ogólne",
      EDTPauses: "OP pauza",
      EDTPhase4: "OP faza 4",
      anomalies: "Anomalie",
      dryingWithPreDriedAir: "ciepłe, wstępnie osuszone powietrze",
      general: "Ogólne",
      gkgConstant: "g/kg stałe",
      gkgConstantInPause: "g/kg stałe poczas pauzy",
      gkgDecreasedInPause: "g/kg wzrasta podczas pauzy",
      gkgIncreasedAfterPause: "g/kg wzrasta po pauzie",
      gkgIncreasedInPause: "g/kg spada podczas pauzy",
      gkgOfProcessAirTooHigh: "g/kg powietrza procesowego zbyt wysokie",
      gkgRoomTooHigh: "g/kg w pomieszczeniu zbyt wysokie",
      humidityOfProcessAirTooHigh: "rF powietrza procesowego zbyt wysokie",
      insufficientAirFlow: "Zbyt niski przepływ",
      interruptionByCustomers: "Przerwane przez klientów",
      moistureNearDrillHoles: "Wilgotność na obwodzie wokół otworów",
      newMoistureAppeared: "Nowy wpis wilgotności",
      noPlasticSheetingOnRawFloor: "bez folii na niewykończonej podłodze",
      powerConsumptionTooLow: "Zbyt niskie zużycie energii",
      relayMalfunction: "Przekaźnik uszkodzony",
      roomConditions: "Warunki w pomieszczeniu",
      roomHumidityTooHigh: "Pomieszczenie o zbyt wysokiej wilg. rel.",
      roomTemperature: "Temperatura w pomieszczeniu",
      stableAfterXDays: "stabilny po x dniach",
      title: "Wskazowki",
      tooHigh: "zbyt wysoki",
      tooLow: "zbyt niski",
      underfloorHeating: "Ogrzewanie podłogowe",
    },
    qualityOverall: {
      dryingDuration: "Czas osuszania",
      dryingProcess: "Przebieg osuszania",
      exemplaryFor: "Przykładowe dla",
      knowledgeGain: "Dane wejściowe do nauki",
      labels: {
        dryingWithPreDriedAir:
          "Osuszanie wstępnie osuszonym ciepłym powietrzem",
        insufficientAirFlow: "Zbyt niski przepływ",
        moistureNearDrillHoles: "Wilgotność na obwodzie wokół otworów",
        newMoistureAppeared: "Nowy wpis wilgotności",
        nightlyInterruptionByClient: "Nocne przerwy w pracy przez klientów",
        noPlasticSheetingOnRawFloor: "bez folii na niewykończonej podłodze",
        relayMalfunction: "Przekaźnik uszkodzony",
        underfloorHeating: "Ogrzewanie podłogowe",
      },
      title: "Ogólna ocena",
    },
    qualityPhase: {
      days: "Dni",
      delta: "Delta",
      duration: "Czas trwania",
      maximumPowerConsumption: "maks moc",
      minimumPowerConsumption: "min moc",
      mixingRatio: "prop. miesz..",
      overall: "Łącznie",
      progress: "Postęp",
      progressMixingRatio: "PM/d",
      progressRelativeHumidity: "% RH/d",
      relativeHumidity: "% RH",
      title: "Fazy jakości",
      watt: "Watt",
    },
    qualityProgram: {
      activity: "Aktywność",
      ok: "ok",
      pauses: "Pauza",
      phaseChange: "Zmiana fazy",
      title: "Program jakości",
      toFast: "zbyt szybko",
      toLong: "zbyt długo",
      toShort: "za krótki",
      toSlow: "zbyt wolno",
    },
    ratingSaved: "Zapisana ocena",
    title: "Ocena jakości",
  },
  regulatorTypes: {
    agent: "Broker",
    externalRegulator: "Zewnętrzny regulator",
    vuAgency: "Agencja TU",
    vuFieldSales: "Zespół zewnętrzny TU",
    vuInternalSales: "Zespół wewnętrzny TU",
  },
  report: {
    completedPhaseReport: "Raport",
    damageReport: "Raport obsługa szkody",
    deleteReportMessage: "Czy naprawdę chcesz usunąć raport?",
    deleteReportTitle: "Usuń raport",
    finalReportDrying: "Raport końcowy osuszania",
    footer: {
      dryingReport: "HyDry Raport z osuszania",
      finalReport: "HyDry raport końcowy",
      interimReport: "HyDry Raport okresowy",
      formatPageOfPages: "{0} z {1}",
    },
    formatReportDate: "stworzony {0}",
    formatReportDateAndSendDate: "erstellt und versandt {0}",
    formatReportDateWithSendDate: "z {0}, wysłane {1}",
    interimPhaseReport: "Raport okresowy",
    interimReportDrying: "Raport okresowy dotyczący osuszania",
    interimReportRepair: "Raport okresowy dotyczący naprawy",
    leakDetectionReport: "Raport z wykrywania nieszczelności",
    reportName: {
      dryingReportFileNamePrefix: "HYDRY_TROCKNUNG",
      finalReportFileNamePrefix: "HYDRY_ABSCHLUSS",
      hyDryCertificateFileNamePostfix: "HYDRY_ZERTIFIKAT",
      interimReport: "HyDry Raport okresowy",
      interimReportFileNamePrefix: "HYDRY_ZWISCHEN",
    },
    reportType: {
      damageReport: "ZDJĘCIE SZKODY",
      finalReport: "ZAKOŃCZENIE",
      interim: "MIĘDZY",
      leakDetection: "WYKRYWANIE NIESZCZELNOŚCI",
    },
    reportUsage: {
      damageAssessment: "Obsługa szkody",
      documentDescription: "",
      drying: "Osuszanie",
      external: "EXT",
      externalDescription: "zewnętrzny",
      externalImagesDescription: "Zdjęcia",
      externalShortDescription: "Bericht",
      externalSingleTimeTrackingDescription: "raport czasu",
      externalTimeTrackingDescription: "zeitbericht",
      hyDryCertificate: "HyDry Zertifikat",
      internal: "INT",
      internalDescription: "wewnętrzny",
      leakDetection: "Wykrywanie nieszczelności",
      measurementProtocol: "Protokół pomiarowy",
      restoration: "Naprawa",
      serviceDescription: "Handel",
      serviceJsonDescription: "PDE",
      svImage: "SV Bild Erstbericht",
    },
    subject: {
      damageAssessment: "Obsługa szkody",
      drying: "Osuszanie",
      leakDetection: "Wykrywanie nieszczelności",
      repair: "Naprawa",
    },
    timeTracking: "Bericht Zeiterfassung",
  },
  reportList: {
    hint: "Raporty dotyczące przydziału urządzeń i zużycia energii",
    noReportsFound: "--- nie znaleziono żadnych raportów ---",
  },
  resetPassword: {
    errorEmailSharingPasswordNoMatch: "Hasło nie jest zgodne",
    errorMinEmailSharingPasswordLength:
      "Hasło musi składać się z co najmniej 8 znaków.",
    errorMinPasswordLength: "Hasło musi składać się z co najmniej 8 znaków.",
    errorPasswordNoMatch: "Hasła nie są zgodne",
    errorWrongEmailSharingPassword: "Hasło jest nieprawidłowe",
    errorWrongPassword: "Hasło jest nieprawidłowe",
    newEmailSharingPassword: "Nowe hasło",
    newEmailSharingPasswordRepeated: "Powtórzenie nowego hasła",
    newPassword: "Nowe hasło",
    newPasswordRepeated: "Powtórz nowe hasło",
    oldPassword: "Dotychczasowe hasło",
    passwordResetFailed:
      "Wystąpił błąd podczas resetowania hasła. Spróbuj ponownie.",
    passwordResetSuccess: "Hasło zostało pomyślnie zresetowane.",
    setNewEmailSharingPassword: "Ustaw nowe hasło",
    setNewPassword: "Ustaw nowe hasło",
    tokenInvalid: "Link do resetowania hasła jest nieprawidłowy lub wygasł.",
  },
  sampleList: {
    dryingPauseTypes: {
      humidityThresholdReached: "Osiągnięty próg wilgotności",
      inactive: "Nieaktywny",
      infinite: "Nieskończony",
      manual: "Ręcznie",
      nightMode: "tryb nocny",
      powerOverload: "Przeciążenie prądowe",
      program: "Program",
      suspend: "Pauza",
      temperatureTooHigh: "Temperatura zbyt wysoka ",
    },
    filterAll: "Wszystkie",
    filterBatteryEvent: "Zdarzenia związane z akumulatorem",
    filterDryingEvent: "Wydarzenia osuszania",
    filterEndOfStep: "Koniec kroku",
    filterEvent: "Events",
    filterMonitor: "MONITOR",
    filterPowerReduction: "Redukcja mocy",
    formatDryingPauseState: "Pauza przed: {0}, pauza po: {1}",
    formatTitle: "Próbki z {0} / T{1} / Przebieg {2} / P{3} z {4}",
    formatVoltage: "{0} V",
    heatRatio: "Heat Ratio",
    samplesPerPage: "Próbki na stronę:",
    sortAscending: "Sortuj rosnąco",
    sortDescending: "Sortuj malejąco",
    titleChipTemp1: "Chip1",
    titleChipTemp2: "Chip2",
    titleCycle: "Cykl",
    titleEvent: "Event",
    titleIndex: "Indeks",
    titlePower: "Moc",
    titleStatus: "Status",
    titleStep: "Krok",
    titleTime: "Czas",
    titleWallChip1Max: "Chip1Max",
    titleWallTemp1: "Wall1",
    titleWallTemp1Max: "Wall1Max",
    titleWallTemp2: "Wall2",
    titleWallTemp2Max: "Wall2Max",
  },
  scheduling: {
    durationInMinutes: "Czas trwania (min)",
    taskDetails: {
      addAppointment: "Termin+",
      addNote: "Notatka+",
      appointmentConfirmed: "Termin potwierdzony",
      dateSuggestions: "Możliwe terminy",
      delete: {
        message: "Naprawdę usunąć potwierdzone spotkanie?",
        title: "Usunąć termin?",
      },
      deleteNote: "Notatka-",
      fromDate: "od daty",
      noSuggestionsFound: "Nie znaleziono prawidłowego terminu, zmień cel",
      note: "Notatka",
      parameterFixed: "stały",
      parametersForPlanning: "Cele dla planowania spotkań",
      title: "Planowanie terminów",
      undoConfirmation: {
        message: "Czy potwierdzone spotkanie powinno zostać zatwierdzone?",
        title: "Usunięto potwierdzenie",
      },
      unsavedChagnes: {
        message: "Dane planowania zostały zmienione. Czy mimo to anulować?",
        title: "Zmiana danych planowania",
      },
    },
    taskType: {
      damageAssessment: "Obsługa szkody",
      dryingConclusion: "Demontaż osuszania",
      dryingSetup: "Osuszanie rozpoczęcie",
      intermediateMeasurement: "Pomiar pośredni",
      leakDetection: "Wykrywanie nieszczelności",
      repair: "Przywrócenie",
    },
    tasks: {
      confirmedTasks: "Potwierdzone zadania",
      filter: {
        all: "Wszystkie",
        filterOff: "Filtr wyłączony",
        lastFourWeek: "Ostatnie 4 tygodnie",
        lastWeek: "Ostatni tydzień",
        startingFromLastWeek: "Od zeszłego tygodnia",
        startingFromToday: "Od dzisiaj",
      },
      formatStartingAt: "od {0}",
      openTasks: "Terminy",
      sortOrder: {
        appointmentDate: "Czas rozpoczęcia",
        earliestStartDate: "Pilność",
        projectNumber: "Numer projektu",
        taskType: "Etap pracy",
        user: "Operator",
      },
    },
    timeline: {
      formatMinutes: "{0} min",
    },
    timelineControl: {
      formatCalendarWeek: "KW {0}",
      moveBackward: "<",
      moveForward: ">",
    },
    timelineSettings: {
      date: "od daty",
      hideWeekends: "Ukryć sob. i nd.",
      onlyShowWorkingHours: "Tylko czas pracy",
      today: "Dzisiaj",
      visibleArea: {
        fourWeeks: "4 Wo",
        label: "Wyświetlanie",
        oneDay: "Dzień",
        oneWeek: "1 tyd",
        twoWeeks: "2 tyd",
      },
    },
    urgend: "Pilne",
  },
  searchIresDevice: {
    message: "Prosimy o podanie numeru seryjnego urządzenia",
    title: "Urządzenie HyDry wyszukiwanie",
  },
  selectProjectType: {
    drying: "Osuszanie",
    dryingDirectOrder: "Osuszanie - zlecenie bezpośrednie",
    dryingInsuranceCase: "Osuszanie - zdarzenie objęte ubezpieczeniem",
    flexProject: "FlexAuftrag",
    formatProjectTypes: "Typ projektu: {0} | Typ projektu: {0}",
    leakDetection: "Wykrywanie nieszczelności",
    leakDetectionDirectOrder:
      "Wykrywanie nieszczelności / bezpośrednie zlecenie",
    leakDetectionInsuranceCase:
      "Wykrywanie nieszczelności / zlecenie od ubezpieczyciela",
    websiteOnly: "Portal",
  },
  settings: {
    administration: {
      allDevicesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych USTAWIEŃ URZĄDZENIA?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla WSZYSTKIE URZĄDZENIA",
      },
      companySettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych USTAWIENIA ODDZIAŁU?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla ODDZIAŁY",
      },
      deviceSettings: {
        title: "Urządzenia zarządzanie",
      },
      hyDryDeviceSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych USTAWIEŃ URZĄDZENIA HyDry?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla URZĄDZENIA HYDRY",
      },
      hyDryMessagesSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych USTAWIEŃ WIADOMOŚCI?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla WIADOMOŚCI",
      },
      projectManagementSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych ustawień dla PROJEKTÓW?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla PROJEKTY",
      },
      reportSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych USTAWIEŃ RAPORTÓW?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla RAPORTY",
      },
      roleSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych USTAWIEŃ ROLI?",
        clients: "Który/e oddział/y?",
        enforcedMessage: "Ustawienia ról klienta głównego są automatycznie stosowane we wszystkich oddziałach. Poszczególne oddziały nie mogą definiować własnych ustawień ról.",
        title: "Przypisanie ustawień dla ROLE",
      },
      userSettings: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnych USTAWIEŃ UŻYTKOWNIKA?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla UŻYTKOWNICY",
      },
      sectionTitle: "Zarządzanie",
      systemConfiguration: {
        allowMemberClientsToDefineOwnSettings:
          "Czy członkowie (oddziały) mogą używać własnej KONFIGURACJI SYSTEMU?",
        clients: "Który/e oddział/y?",
        title: "Przypisanie ustawień dla KONFIGURACJA SYSTEMU",
      },
    },
    administrator: {
      memberClientDialog: {
        clientShorthand: "Skrót klienta",
        createClientErrorMessage:
          "Błąd podczas tworzenia klienta członkowskiego",
        createClientSuccessMessage:
          "Klient członkowski został pomyślnie utworzony",
        editClientErrorMessage: "Błąd podczas edycji klienta członkowskiego",
        editClientSuccessMessage: "Klient członkowski pomyślnie przetworzony",
        errors: {
          duplicateClientName: "",
          duplicateEmail: "Adres e-mail jest już w użyciu",
          duplicateIresProjectNumberPrefix:
            "Ten skrót klienta jest już używany",
          emptyClientName: "Proszę wprowadzić nazwę klienta",
          emptyEmail: "Proszę wprowadzić prawidłowy adres e-mail",
          emptyIresProjectNumberPrefix:
            "Wprowadź skrót klienta składający się z 4 znaków",
          emptyPassword: "Proszę wprowadzić hasło",
          invalidEmail: "Proszę wprowadzić prawidłowy adres e-mail",
          invalidIresProjectNumberPrefix:
            "Wprowadź skrót klienta składający się z 4 znaków",
          invalidPassword: "Hasło musi mieć co najmniej {0} znaków",
        },
        titleCreate: "Utwórz klienta członkowskiego",
        titleEdit: "Edytuj klienta członkowskiego",
      },
      memberClientsManagement: {
        title: "Zarządzanie klientami",
      },
      title: "Mistrz",
    },
    allDevices: {
      projectDevicesSettings: {
        enforceMeterReading: "Zawsze wprowadzać i sprawdzać odczyt licznika?",
        standardIdentification: "Standard identyfikacji",
        title: "Ustawienia urządzenia",
      },
      title: "Wszystkie urządzenia",
    },
    allDevicesManagement: {
      title: "Wszystkie urządzenia zarządzanie",
    },
    branches: {
      branchNumber: "ID lokalizacji",
      branchSortValue: "Numer sortowania",
      confirmDeleteBranchMessage:
        "Czy na pewno chcesz trwale usunąć ten oddział?",
      confirmDeleteBranchMessageAlt:
        "Do tej lokalizacji jest nadal przypisane 1 urządzenie. Urządzenia utracą przypisanie do lokalizacji. Czy chcesz kontynuować? | Do tej lokalizacji są nadal przypisane {count} urządzenia. Te urządzenia utracą przypisanie do lokalizacji. Czy chcesz kontynuować?",
      confirmDeleteBranchTitle: "Lokalizację usuń",
      editTitle: "Edytuj lokalizację",
      viewTitle: "Lokalizacja",
      errorDuplicateBranchNumber:
        "Numer ten jest już przypisany do lokalizacji {0}.",
      errorMissingBranchNumber: "Proszę wprowadzić liczbę > 0",
      fullName: "Nazwa długa",
      location: "Miejsce",
      name: "Nazwa skrócona",
      rejectDeleteBranchMessage:
        "Do tej lokalizacji jest nadal przypisane 1 urządzenie. Urządzenia muszą najpierw zostać przypisane do lokalizacji. | Do tej lokalizacji są nadal przypisane {count} urządzenia. Urządzenia muszą najpierw zostać przypisane do innego lokalizacji.",
      title: "Lokalizacje",
      useInReport: "W raporcie",
    },
    buttons: {
      change: "ZMIANA",
    },
    changeLogo: "Logo zmiana",
    comBoxHumidityUnit: {
      absoluteHumidity: "Wilgotność bezwzględna (g/m3)",
      mixingRatio: "Proporcja mieszania (g/kg)",
      relativeHumidity: "Wilgotność względna (%)",
      title: "Jednostka wilgotności",
    },
    comBoxes: "HyDry Boxy",
    company: "Który/e oddział/y?",
    companySettings: {
      absoluteHumidity: "Wilgotność abs. (g/m3)",
      addressFormat: {
        availableFields: "Dostępne pola",
        commaNotAllowedAtEdge: "Przecinek nie może być na początku ani na końcu",
        defaultUsed: "Bez pól używany jest format domyślny.",
        hint: "Określa kolejność, w jakiej zapisywane są części adresu.",
        preview: "Podgląd",
        templateFields: {
          CITY: "Miasto",
          COMMA: "Przecinek",
          COUNTRY: "Kraj",
          HOUSE_NUMBER: "Numer domu",
          STREET: "Ulica",
          ZIP_CODE: "Kod pocztowy",
        },
        title: "Format adresu",
      },
      addressGeocoding: "Geokodowanie adresów",
      companyData: "Dane oddziału",
      companyEmailAddress: "Adres e-mail",
      companyIdentifier: "Identyfikacja oddziału",
      companyName: "Nazwa firmy",
      companySettingsTitle: "Ustawienia oddziału",
      errorCompanyIdentifier:
        "Nieprawidłowe dane wejściowe. Używaj tylko znaków alfanumerycznych.",
      errorEmailAddress: "Proszę wprowadzić prawidłowy adres e-mail",
      mixingRatio: "Obciążenie (g/kg)",
      preferredHumidityUnit: "Preferowana specyfikacja WILGOTNOŚĆ",
      primaryLanguage: "Język podstawowy",
      shortName: "Nazwa skrócona",
      timezone: "Strefa czasowa",
      usePrimaryLanguageForReports: "Używać języka podstawowego w raportach?",
    },
    currentUser: {
      formatCurrentUser: "Aktualny użytkownik: {0}, rola: {1},",
      formatCurrentUserValidationLevel: "Sprawdzenie: {0}",
      setPassword: "Zmiana hasła użytkownika",
      showCurrentUserSettings: "Pokaż moje dane użytkownika",
      title: "Bieżący użytkownik",
    },
    aiPredictions: {
      title: "ASSIST",
      mode: {
        OFF: "Nie",
        ALL_DRYINGS: "Tak, ze wszystkimi osuszaniami",
        ACTIVE_AND_NEW_ONLY: "Tak, tylko aktywne i nowe osuszania",
      },
      activationBackfill: {
        started: "Aktywacja ASSIST została zapisana. Rozpoczęto obliczenia historyczne.",
        alreadyRunning: "Aktywacja ASSIST została zapisana. Obliczenia historyczne już trwają.",
        noOp: "Aktywacja ASSIST została zapisana, ale backend nie uruchomił obliczeń historycznych.",
        triggerFailed: "Aktywacja ASSIST została zapisana, ale nie udało się uruchomić obliczeń historycznych.",
      },
    },
    billingCatalogs: {
      title: "Zarządzaj katalogami rozliczeniowymi",
      sectionTitle: "Katalogi rozliczeniowe",
      listTitle: "Katalogi rozliczeniowe",
      noCatalogs: "Brak dostępnych katalogów rozliczeniowych.",
      syncFromApi: "Synchronizuj z API",
      syncSuccess: "{0} pozycji zaimportowano w {1} katalogach.",
      syncError: "Nie udało się zsynchronizować katalogów rozliczeniowych.",
      updateError: "Nie udało się zapisać zmiany.",
      noPriceClassName: "Bez klasy cenowej",
      columns: {
        catalogName: "Wydawca",
        tenant: "Źródło cen",
        version: "Wersja",
        fileName: "Nazwa pliku",
        numberOfEntries: "Wpisy",
        branchNumber: "Oddział",
        validFrom: "Ważny od",
        validUntil: "Ważny do",
        importedAt: "Zaimportowano",
      },
      detail: {
        title: "Katalog rozliczeniowy",
        validityOpenEnded: "bezterminowo",
        loading: "Ładowanie katalogu rozliczeniowego...",
        loadError: "Nie udało się załadować katalogu rozliczeniowego",
        uncategorized: "Bez kategorii",
        columns: {
          articleId: "Pozycja",
          headline: "Nagłówek",
          text: "Opis",
          unit: "Jednostka",
          price: "Cena",
          limit: "Limit",
          qualifier: "Kwalifikator",
        },
        download: "Pobierz",
      },
    },
    deviceCheckManagement: {
      title: "Geräte-Check verwalten",
    },
    devices: {
      allowCategoryTemplateCreate:
        "Zezwalać na tworzenie nowych kategorii/typów urządzeń podczas importu CSV?",
      allowCategoryTemplateUpdate:
        "Zezwolić na aktualizację kategorie/typy urządzeń podczas importu CSV?",
      allowNewCategory:
        "Zezwolić na dodawanie nowych kategorii urządzeń podczas importu CSV?",
      allowNewTemplate:
        "Zezwolić na dodawanie nowych typów urządzeń podczas importu CSV?",
    },
    dryRuns: "Osuszania",
    errorInvalidNumber: "Proszę wprowadzić liczbę całkowitą",
    errorNumberRange: "Proszę wprowadzić liczbę całkowitą od {0} do {1}",
    exportSettings: {
      allDevices: "Wszystkie urządzenia",
      deviceFilter: "Wybór stanu urządzenia",
      devicesSelection: "Wybór urządzeń",
      exportDialog: {
        message: "1 urządzenie przetworzono| {count} urządzeń przetworzono",
        title: "Informacje eksportować",
      },
      hyDryDevices: "Urządzenia HyDry",
      otherDevices: "Wszystkie urządzenia",
    },
    hyDryBox: "HyDry Box",
    hyDryDevice: {
      cancel: "ANULUJ",
      configurations: "Ustawienia urządzenia HyDry",
      configurationsImportExport: "Konfiguracja importu",
      date: "data",
      deviceError:
        "1 urządzenie zawiera błędy | {count} urządzeń zawiera błędy",
      deviceImportHistory: "Importu pzrebiegu",
      devicesCategorySettings: "Kategorie i typy urządzeń",
      devicesDetected: "1 urządzenie wykryto| {count} urządzeń wykryto",
      devicesDuplicated:
        "Znaleziono 1 duplikat | Znaleziono {count} duplikatów",
      devicesExport: "Urządzenia eksportuj",
      devicesImport: "Urządzeń usuwanie",
      devicesNew: "Dodano 1 nowe urządzenie | Dodano {count} nowych urządzeń",
      devicesProcessed:
        "1 urządzenie przetworzono| {count} urządzeń przetworzono",
      devicesUpdated:
        "1 istniejące urządzenie zaktualizowane| {count} istniejące urządzenia zaktualizowane",
      devicesUpload: "Wgrywanie urządzeń ...",
      editComBoxClientConfig: "HyDry Box edycja konfiguracji",
      errorMessageCategoryNotFound: "Kategoria nie została znaleziona",
      errorMessageCategoryUpdateNotAllowed: "Kategoria nie może być zmieniona",
      errorMessageDeviceAssignedToProject:
        "Urządzenie jest przypisane do projektu",
      errorMessageDeviceDoesNotExist: "Urządzenie nie istnieje",
      errorMessageBranchNotFound: "Lokalizacja nie istnieje",
      errorMessageInvalidDevicePowerUsageType: "Licznik jest nieprawidłowy",
      errorMessageInvalidElectricityMeterManufacturer:
        "Producent licznika jest nieprawidłowy",
      errorMessageInvalidInventoryNumber: "Numer inwentarza jest nieprawidłowy",
      errorMessageInvalidManufacturer: "Producent jest nieważny",
      errorMessageInvalidPowerConsumptionPerHour:
        "Typowa moc jest nieprawidłowa",
      errorMessageInvalidQrCode: "Kod QR jest nieprawidłowy",
      errorMessageInventoryNumberAlreadyExists: "Numer inwentarza już istnieje (konflikt: {conflictId})",
      errorMessageInventoryNumberNotUnique:
        "Znaleziono kilka urządzeń o tym samym numerze inwentarzowym.",
      errorMessageIresDevice: "Nie można zaimportować nowego urządzenia IRES",
      errorMessageMissingCategory: "Brakuje kategorii",
      errorMessageMissingCategoryColumn:
        "Plik importu nie zawiera kolumny dla kategorii urządzenia",
      errorMessageMissingInventoryNumber: "Brak numeru inwentarzowego",
      errorMessageMissingInventoryNumberColumn:
        "Plik importu nie zawiera kolumny dla numeru inwentarza",
      errorMessageMissingSerialNumberColumn:
        "Plik importu nie zawiera kolumny dla numeru seryjnego",
      errorMessageMissingTemplate: "Brakuje typu",
      errorMessageMissingTemplateColumn:
        "Plik importu nie zawiera kolumny dla typu urządzenia",
      errorMessageQrCodeAlreadyExists: "Kod QR już istnieje (konflikt: {conflictId})",
      errorMessageSerialNumberNotUnique:
        "Znaleziono kilka urządzeń o tym samym numerze seryjnym.",
      errorMessageTemplateNotFound: "Nie znaleziono typu",
      errorMessageTemplateUpdateNotAllowed: "Nie można zmienić typu urządzenia",
      errorMessageTryAgain: "Wystąpił błąd. Spróbuj ponownie z innym plikiem.",
      errorMessageWrongCsvSeparator:
        "Format pliku jest nieprawidłowy. Postępuj zgodnie z instrukcjami.",
      errorMessageWrongFormat: "Plik musi mieć rozszerzenie .CSV",
      errorMessageFileTooLarge: "Plik jest za duży. Maksymalny rozmiar pliku: 5 MB.",
      exportDevice: "Urządzenia eksportuj",
      csvHeaders: {
        category: "KATEGORIA",
        type: "TYP",
        inventoryNumber: "NUMER INWENTARZOWY",
        serialNumber: "NUMER SERYJNY",
        manufacturer: "PRODUCENT",
        code: "KOD",
        power: "MOC",
        meter: "LICZNIK",
        electricityMeterManufacturer: "PRODUCENT LICZNIKA ENERGII",
        electricityMeterNumber: "NUMER LICZNIKA ENERGII",
        acquisitionDate: "DATA NABYCIA",
        availability: "DOSTĘPNOŚĆ",
        location: "LOKALIZACJA",
        comment: "KOMENTARZ",
        meterReading: "ODCZYT LICZNIKA",
        locationName: "NAZWA LOKALIZACJI",
        error: "BŁĄD",
      },
      fileName: "Nazwa pliku",
      genericError: "Błąd",
      guide: {
        acquisitionDate: "DATA NABYCIA",
        availability: "DOSTĘPNOŚĆ",
        category: "KATEGORIA",
        code: "KOD",
        comment: "KOMENTARZ +",
        counter: "LICZNIK",
        counterReading: "STAN LICZNIKA",
        electricityMeterManufacturer: "PRODUCENT LICZNIKA ENERGII ELEKTRYCZNEJ",
        electricityMeterNumber: "NUMER LICZNIKA ENERGII ELEKTRYCZNEJ",
        inventoryNumber: "NUMER INWENTARZOWY",
        location: "LOKALIZACJA",
        manufacturer: "PRODUCENT",
        power: "MOC",
        serialNumber: "NUMER SERYJNY",
        step1:
          "Import odbywa się za pośrednictwem pliku CSV o następujących właściwościach:",
        step2: "Kolejność pól",
        step3: "Kategorie urzadzeń/Typy urządzeń",
        step4:
          "Urządzeń HyDry nie można tworzyć ani zmieniać za pomocą importu.",
        step5:
          "Każde urządzenie musi mieć unikalny numer inwentarzowy lub unikalny numer seryjny, w przeciwnym razie nie można go utworzyć.",
        step6: "Puste pola nie są aktualizowane.",
        step7: "Formaty / Wybór",
        subStep1a: "Linia nagłówka (nie jest analizowana)",
        subStep1b:
          "Dane urządzenia z polami odpowiadającymi wierszowi nagłówka.",
        subStep1c: "Separator pól średnik (;)",
        subStep1d: "Format znaków UTF-8",
        subStep3a:
          "Typy urządzeń i kategorie urządzeń są tworzone lub aktualizowane automatycznie tylko wtedy, gdy zostało to określone w opcji KONFIGURACJA IMPORTU.",
        subStep7a:
          "LICZNIK: Określenie typu licznika jako 0=Brak licznika, 1=Godziny pracy, 2=Bieżący, 3=Inny bieżący",
        subStep7b:
          "KOD: Wprowadź kod kreskowy, kod QR lub NFC. Musi być unikalny.",
        subStep7c: "DATA NABYCIA: Podać w formacie DD.MM.RRRR",
        subStep7d: "DOSTĘPNOŚĆ: 0=dostępny, 1-9=niedostępny",
        title: "Import urządzeń",
        type: "TYP",
      },
      confirmImport: "Potwierdź import",
      import: "importować",
      importCancelled: "Import pliku został przerwany",
      importDevices: "Importowanie nowych urządzeń",
      importSuccess: "Plik został pomyślnie zaimportowany",
      importPreview: "Podgląd importu",
      previewComplete: "Podgląd zakończony",
      newDevices: "Nowe urządzenia",
      newImport: "Import nowego pliku",
      noHistoryData: "--- nie znaleziono danych historycznych ---",
      readingFile: "Plik jest odczytywany ...",
      reportDownload: "Raport",
      title: "Urządzenia HyDry",
      updatedDevices: "Zaktualizowane urządzenia",
      uploadBoxTest1: 'Import pliku metodą "przeciągnij i upuść',
      uploadBoxTest2: "lub",
      uploadBoxTest3: "Wyszukaj plik",
      user: "Użytkownik",
    },
    hyDryDevices: "Urządzenia HyDry",
    hyDryDeviceSettings: {
      alwaysShowSerialNumber:
        "Dla urządzeń HyDry zawsze wyświetlaj numer seryjny?",
      minRunDurationForAnalysis: "Minimalna długość przebiegu dla analiz",
    },
    ires: {
      enableSpecialRightsForIresClientOrAdmin:
        "Aktywować specjalne uprawnienia dla użytkownika IRES?",
      ignoreIresAdminOrIresClientCheck:
        "Ignorować sprawdzanie dla administratora IRES czy klienta IRES?",
      ignoreIresAdminOrIresClientCheckShort:
        "Ignorować sprawdzanie dla administratora IRES czy klienta IRES?",
      iresConfiguration: "IRES Ustawienia",
      memberClients: "Klienci będący członkami",
      title: "IRES",
    },
    logo: "Logo",
    mailbox: {
      confirmDeleteMailboxMessage:
        "Czy na pewno chcesz nieodwracalnie usunąć tę skrzynkę pocztową?",
      confirmDeleteMailboxTitle: "Usuń skrzynkę pocztową",
      errorNameAlreadyTaken: "Ta nazwa jest już używana",
      mailbox: "Skrzynka pocztowa",
      memberUsers: "Użytkownik wychodzący",
      name: "Nazwa",
      sortValue: "Numer sortowania",
      targetUsers: "Wprowadzanie użytkownika",
    },
    mailboxes: "Zarządzanie skrzynkami pocztowymi",
    messageSelection: "Konfiguracja wiadomości",
    messages: "Wiadomości",
    minProgramChainDurationInMinLabel: "Minimalna długość osuszania",
    minProgramChainDurationInMinMessage:
      "Limit wyświetlania czasów osuszania dla urządzeń HyDry (osuszania krótsze są ukryte):",
    minProgramChainDurationInMinTitle:
      "Minimalna długość osuszania dla urządzeń HyDry",
    minGeneralGapDurationInMinLabel: "Maksymalna przerwa do scalania",
    minGeneralGapDurationInMinMessage:
      "Kolejne wpisy tego samego projektu i tej samej fazy są scalane w jeden, gdy przerwa między nimi wynosi najwyżej tę wartość (w minutach):",
    minGeneralGapDurationInMinTitle:
      "Próg scalania identycznych wpisów",
    travelArrivalRadiusLabel: "Promień przyjazdu (m)",
    travelArrivalRadiusTitle: "Promień przyjazdu dla przejazdów",
    travelArrivalRadiusMessage:
      "Od jakiej odległości od celu przejazd liczy się jako przerwany, a nie jako zakończony " +
      "przyjazdem. Odległość w linii prostej, w metrach. Dotyczy wszystkich twoich pracowników.",
    permissions: {
      assignProjectToOthers: "D2 Przydzielanie projektów innym osobom",
      basicLicence: "B1 Podstawowa licencja Projekty",
      cancel: "ANULUJ",
      clientAdministration: "M1 Zarządzanie członkami",
      createProject: "C2 Utwórz nowy projekt",
      damageAssessmentLarge: "F2 Rejesrowanie obsługi szkody",
      defineDeviceCategories: "E1 Definiowanie kategorii urządzeń",
      deleteProject: "C3 Usuń projekty",
      deviceAdministration: "M2 Zarządzanie urządzeniami",
      drying: "F3 Power osuszanie",
      dryingAndRecording: "B3 Licencja Osuszanie",
      editAdmin: "A1 admin zarządzaj",
      editDevices: "E3 Zarządzanie urządzeniami",
      editProjects: "C5 Edycja projektów",
      editUser: "A2 zarządzanie użytkownikiem",
      editValidation: "A3 Zmiana własnego poziomu testu",
      haveVehicle: "F5 Posiada pojazd",
      importDevicesCategories: "E2 Import urządzeń",
      leakDetection: "F1 Wykrywanie nieszczelności",
      manageProduction: "P2 Zarządzanie produkcją",
      manageClients: "P3 Zarządzanie klientami",
      office: "B4 Licencja Biuro",
      permissions: "Uprawnienia",
      projectManagement: "B5 Licencja Zarządzania projektami",
      projectsSuperVision: "D3 Zarządzanie projektem",
      rateDryings: "P1 Ocena suszenia",
      recording: "B2 Licencja Wpisywanie",
      reopenCompletedPhases: "C4 Ponowne otwarcie projektów",
      repair: "F4 Przywracanie zasilania",
      return: "WSTECZ",
      save: "Zapisz",
      saveEdit: "ZAPISZ ZMIANY",
      saveEditsSuccessfull: "Zmiany zostały pomyślnie zapisane",
      seeAllProjects: "C1 Zobacz wszystkie projekty",
      seeAllSettings: "A4 zarządzanie konfiguracją",
      selfAssignProjects: "D1 Samodzielne przydzielanie projektów",
      settingsAdministration: "M3 Ustawienia ogólne",
    },
    permissiontManagement: {
      title: "Role zarządzanie",
    },
    projectManagement: {
      archivedProjects: {
        title: "Zobacz stare projekty",
      },
      deviceManagerSettings: {
        canUserAddContactPersons: "Użytkownik może dodać mieszkania",
        canUserAddDevices: "Użytkownik może dodawać urządzenia",
        canUserAddProjects: "Użytkownik może dodawać projekty",
        canUserAddRooms: "Użytkownik może dodawć pomieszczenia",
        title: "Einstellungen IRES Work",
      },
      projectEditingSettings: {
        defaultDryingDuration:
          "Wstępne wypełnienie ustawiony czas suszenia (dni)",
        defaultFollowUpInspectionInterval:
          "Ponowne przesłanie zawsze po 1 dniu | Ponowne przesłanie zawsze po {count} dniach",
        projectDuration:
          "Wstępne wypełnienie alokacja czasu wykonywania projektu",
        title: "Ustawienia przetwarzania projektu",
        automaticProjectNames: "Automatyczne nazwy projektów",
        deviceAssignment: "Przypisanie urządzeń",
        roomLevelDeviceAssignment: "Przypisanie urządzeń na poziomie pomieszczenia",
        projectOverviewTilesForOfficeProjects: "Kafelki do przypisywania urządzeń",
        templateFields: {
          PROJECT_NUMBER: "Numer projektu",
          ZIP_CODE: "Kod pocztowy",
          CITY: "Miasto",
          STREET: "Ulica",
          HOUSE_NUMBER: "Numer domu",
          NAME: "Nazwa",
          COMMA: "Przecinek",
        },
        resetToAuto: "Resetuj do automatycznego",
        availableFields: "Dostępne pola",
        commaNotAllowedAtEdge: "Przecinek nie może być na początku ani na końcu.",
        preview: "Podgląd",
      },
      projectManagerSettings: {
        actionButtons: {
          apartmentAttendees: "K3 Mieszkanie: OBECNI",
          options: {
            hide: "Ukryj",
            hideAlt: "Nie proponuj",
            red: "Czerwony",
            yellow: "Żółty",
          },
          leakDetectionSketchAndMeasurementPoints:
            "K2 Wykrywanie nieszczelności: szkice + punkty pomiarowe",
          pipeSystem: "K2 Wykrywanie nieszczelności: INSTALACJA",
          projectAttendees: "K2 Project: OBECNI",
          projectCause: "K2 Project: PRZYCZYNA",
          title: "Przyciski akcji",
        },
        damageAssessment: {
          enforceFullDamageAssessment: "Zawsze PEŁNA OBSŁUGA SZKODY?",
          title: "Obsługa szkody",
        },
        measurementPoints: {
          canAddMeasurementPointsInApartment:
            "Dopuszczalne punkty pomiarowe w MIESZKANIU?",
          preferAbsHumidity:
            "Preferowane wprowadzanie wilgotności jako WILGOTNOŚĆ BZWL.?",
          roomClimateMeasuringPoints: "KLIMAT POMIESZCZENIA punkt pomiarowy ",
          measurementPointPresetPhase: "Wstępne wypełnienie w WYKRYWANIE NIESZCZELNOŚCI",
          measurementPointPresetPhaseOptions: {
            leakDetection: "Wykrywanie nieszczelności",
            drying: "Suszenie",
          },
          title: "Punkty pomiarowe",
        },
        photo: {
          hintPhotoQuality: "Uwaga dotycząca jakości zdjęć",
          title: "Zdjęcia",
        },
        projectPhases: {
          dryingSetupEnquiry: "Pytanie dotyczące instalacji osuszania?",
          enforceFullDamageAssessment: "Zawsze PEŁNA OBSŁUGA SZKODY?",
          title: "Fazy projektu",
        },
        sketch: {
          errorPresetRoomHeight:
            "Wartości muszą zawierać się w przedziale od 0 do 500.",
          errorPresetWallThickness: "Wartości muszą wynosić od 0 do 99.",
          presetInnerWallThickness: "Ściana wewnętrzna",
          presetOuterWallThickness: "Ściana zewnętrzna",
          presetPartyWallThickness: "Ściana graniczna",
          presetRoomHeight:
            "Wstępne wypełnienie wysokość pomieszczenie (cm) (0 = keine)",
          presetWallThickness:
            "Wstępne wypełnienie grubość ściany (cm) (0 = brak)",
          sketchInRooms: "K3 Szkice w pomieszczeniach",
          title: "Szkic",
        },
        title: "Ustawienia aplikacji IRES PROJECT",
        trades: {
          quantitySurveyInReport: "Aufmaß im Bericht",
          tableAutomaticallyInReport: "Tabelle automatisch im Bericht",
          tableSorting: {
            options: {
              apartmentPhase: "Wohnung, Phase",
              apartmentTrade: "Wohnung, Gewerk",
              phaseTrade: "Phase, Gewerk",
              roomPhase: "Raum, Phase",
              roomTrade: "Raum, Gewerk",
              tradePhase: "Gewerk, Phase",
            },
            title: "Sortierung Tabelle",
          },
          title: "Leistungserbringer Gewerke",
        },
        serviceList: {
          title: "Lista usług",
          presetFlexibleServiceList: "Wstępne wypełnienie elastycznej listy usług",
        },
      },
      projectSettings: {
        editProjectsIn: "Wykonywać ZMIANĘ DANYCH PROJEKTU?",
        finaliseProjectsIn: "Wykonywać ZAKOŃCZENIE PROJEKTU?",
        newAppointmentsIn: "Wykonywać NOWE TERMINY?",
        newProjectsIn: "Wykonywać NOWE PROJEKTY?",
        projectTypesConfiguration: {
          active: "Aktywny",
          label: "Label",
          phases: "Fazy",
          platforms: "Platformen",
          title: "Mögliche Projekttypen",
          type: "TYP",
        },
        title: "Ustawienia projekty",
      },
      title: "Projekty",
    },
    report: {
      dataProtection: {
        contactDataInExternalReports: "Dane kontaktowe w raportach zewnętrznych",
        title: "Ochrona danych",
      },
      emailInboxes: {
        damageReportEmailAddress: "E-mail do raportów obsługi szkody",
        dryingReportEmailAddress: "E-mail do raportów osuszania",
        leakDetectionReportEmailAddress:
          "E-mail dla raportów z wykrywania wycieków",
        title: "Skrytki pocztowe e-mail",
      },
      errorEmailAddress: "Proszę wprowadzić prawidłowy adres e-mail",
      equipmentUsage: {
        includeGenericDeviceAssignments: "Uwzględnij urządzenia w raporcie",
        createCertificate: "Utwórz certyfikat",
        title: "Wykorzystanie sprzętu",
      },
      images: {
        contentOrder: "Kolejność bloków w raportach",
        contentOrderOptions: {
          sketchImagesText: "Szkice / Zdjęcia / Tekst",
          sketchTextImages: "Szkice / Tekst / Zdjęcia",
          textSketchImages: "Tekst / Szkice / Zdjęcia",
        },
        imageForMeasurementPoints: "Zdjęcia punktów pomiarowych",
        imageQuality: "Wstępnie ustawiona jakość obrazu",
        imageQualityHigh: "Wysoki",
        imageQualityLow: "Niski",
        imageQualityNormal: "Średni",
        imageReportAfterDamageAssessmentOptions: {
          no: "Brak raportów ze zdjęciami",
          selectionAsExternalReport: "Wybór jak w raporcie zewnętrznym",
          selectionAsInternalReport: "Wybór jak w raporcie wewnętrznym",
        },
        imagesPerRow: "Zdjęć na linię",
        showReportConfigInProject: "Zapytaj o konfigurację zdjęć",
        title: "Zdjęcia w raportach",
      },
      json: {
        title: "Raporty w formacie JSON",
        sendReportAsJson: "Generowanie i dystrybucja raportów w formacie JSON",
      },
      logo: {
        dropHint: "Przeciągnij logo tutaj lub kliknij",
        expandPreview: "Powiększ podgląd",
        hint: "Akceptowane formaty: JPEG i PNG",
        noLogo: "Brak logo",
        removeLogo: "Usuń logo",
        uploadLogo: "Prześlij logo",
        scalingFactor: "Skalowanie logo (%)",
        selectFile: "Wybierz plik",
        title: "Logo",
      },
      outgoingReports: {
        reportsList: "Berichte als Liste",
        reportsListOptions: {
          individualPdfDocuments: "PDF-Dokumente einzeln",
          separatePdfAndTimeEntries: "PDF und Zeiteinträge einzeln",
          summarizedReportsOnly: "Nur zusammengefasste Berichte",
        },
        saveReport: "w katalogu",
        sendAsEmail: "Wyślij jako e-mail",
        sendOutgoingReportsAsOptions: {
          iresCloud: "Ja, über IRES Cloud",
          localEmail: "Ja, über lokale E-Mail",
        },
        title: "Wychodzące raporty",
      },
      reportEmailAddress: "Adres e-mail dla raportów",
      reportSettings: "Ustawienia raportów",
      timeEntriesOnNewPage: "Wpisy czasu na nowej stronie?",
      timeTracking: {
        companyAddressInTimeRecord: "Adres firmy w rejestracji czasu pracy?",
        phaseInTimeRecord: "Projektphase",
      },
      individualReports: {
        title: "Raporty indywidualne",
        documentsInReports: "Dokumenty PDF",
        timeEntriesInReports: "Wpisy czasu",
        reportInclusionOptions: {
          internalReport: "w raporcie wewnętrznym",
          externalReport: "w raporcie zewnętrznym",
          separateReport: "jako raport pojedynczy",
          separateReportTotal: "jako jeden raport pojedynczy (łącznie)",
          separateReportIndividual: "jako raport pojedynczy dla każdego",
        },
        measurementProtocolAsSeparateReport: "Protokół pomiarowy jako osobny raport",
        measurementProtocolAsSeparateReportOptions: {
          no: "Nie",
          yes: "Tak",
        },
        imageReportAfterDamageAssessment: "Raporty ze zdjęciami i wybór zdjęć",
      },
      footer: {
        title: "Stopka",
        footerText: "Tekst w stopce",
        footerTextOptions: {
          appVersion: "Wersja aplikacji",
          company: "Firma",
          location: "Lokalizacja",
        },
        projectInfo: "Informacje o projekcie w stopce",
        projectInfoOptions: {
          projectId: "Numer projektu",
          collectionNumber: "Numer zbiorczy",
          projectIdAndCollectionNumber: "Numer projektu / Numer zbiorczy",
        },
        showTotalPageCount: "Pokaż łączną liczbę stron (7 z 13)",
      },
      title: "Raporty",
    },
    roleManagement: {
      cancelMessage:
        "Zmiany zostały już wprowadzone. Czy chcesz odrzucić te zmiany?",
      cancelTitle: "Odrzucić zmiany?",
      capabilityOption: {
        conditional: "Możliwe",
        no: "Nie",
        yes: "Tak",
      },
      edit: "Role konfigurowanie",
      editRole: "Rola edytuj",
      error: {
        activeUserForRole: "Istnieją jeszcze aktywni użytkownicy z tą rolą",
        wrongLabel: "Proszę wprowadzić prawidłową nazwę roli",
      },
      roles: {
        description: "Opis",
        label: "Nazwa",
        roleActive: "Status",
        roleId: "lfd Nr.",
        users: "# Nutzer",
      },
      memberClientHint: "Uwaga: Konfigurację ról można zmienić w MASTER.",
      title: "Role zarządzanie",
      titleAlt: "Role pokaż",
      viewRolesConfiguration: "Pokaż konfigurację ról",
    },
    scheduling: {
      control: {
        acceptableDelayInMin: "Opóźnienie",
        title: "Sterowanie",
      },
      defaultBreakDurations: {
        lunchBreak: "Przerwa na lunch",
        maxTimeWithoutBreak: "Czas do pauzy",
        title: "Pauzy",
      },
      defaultTaskDurations: "Wstępne wypełnienie przydział czasu pracy",
      objectiveFunctionParameters: {
        title: "Funkcja docelowa",
        weights: {
          dailyWorkTimeExceedance: "Waga przekroczenie czasu pracy/dzień",
          targetDate: "Waga termin realizacji celu",
          targetDateFixed: "Waga termin realizacji celu stały",
          targetQualification: "Waga kwalifikacja celu",
          targetTime: "Waga czas docelowy ",
          targetTimeFixed: "Waga czas docelowy stały",
          targetUser: "Waga osoba odpowiedzialna za realizację celu",
          timeGap: "Waga luka czasowa",
          total: "Całkowite skalowanie",
          travelTime: "Waga czas jazdy",
          weeklyWorkTimeExceedance: "Waga przekroczenie czasu pracy/tydzień",
        },
      },
      occupiedTimeUsage: {
        breakUsage: "Pauza",
        none: "od",
        plan: "zaplanować",
        show: "wyświetlać",
        travelTimeUsage: "Czasy podróży",
      },
      planningBoard: {
        formatColor: "Kolor {0}",
        taskColors: "Kolory",
        title: "Prezentacja planowania operacyjnego",
        visibleArea: {
          fourWeeks: "4 tygodnie",
          from: "Wyświetlanie od",
          oneDay: "1 dzień",
          oneWeek: "1 tydzień",
          title: "Widoczny obszar",
          twoWeeks: "2 tygodnie",
          until: "Wyświetlanie do",
        },
        visibleRange: {
          title: "Okres wyświetlania",
        },
      },
      section: {
        geocodingAndTravelTimes: "Geokodowanie i czasy podróży",
        planningBoard: "Prezentacja planowania operacyjnego",
        planningControl: "Konfiguracja planowania",
      },
      title: "Planowanie operacyjne",
      travelTimeAndPauses: "Czas podróży i pauzy",
      travelTimeSettings: {
        betweenTaskAndDepot: "Wstępne wypełnienie dojazd",
        betweenTasks: "Wstępne wypełnienie przypisanie trasy łączonej",
        title: "Geokodowanie i czasy podróży",
        travelTimeBuffer: "Dopłata za czas",
        travelTimeCalculationViaMap: "Czas podróży na mapie",
      },
      workingHours: {
        defaultWorkDayEnd: "Koniec czasu pracy",
        defaultWorkDayStart: "Czas pracy początek",
        defaultWorkingHoursPerDay: "Czas pracy/dzień",
        defaultWorkingHoursPerWeek: "Godziny pracy/tydzień",
        earliestWorkDayStart: "Najwcześniejszy start",
        latestWorkDayEnd: "Najpóźniejszy koniec",
        lunchBreakAfter: "Planuj przerwę po",
        longBreakDuration: "Czas wydłużonej przerwy",
        longBreakThresholdHours: "Godziny pracy powyżej",
        maxWorkingHoursPerDay: "Maks. czas pracy/dzień",
        maxWorkingHoursPerWeek: "Maks. godzin pracy tygodniowo",
        minBreakDuration: "Min. długość przerwy",
        shortBreakDuration: "Czas normalnej przerwy",
        shortBreakThresholdHours: "Godziny pracy powyżej",
        title: "Godziny pracy i pauzy",
      },
    },
    sharedEmailAddress: {
      changePasswordHint:
        "Proszę wprowadzić nowe hasło, aby udostępnić swój adres e-mail",
      changePasswordHintOld:
        "Wprowadź nowe hasło, aby udostępnić swój adres e-mail",
      title: "Hasło do udostępniania adresu e-mail",
      titleOld: "Udostępnianie adresu e-mail",
    },
    sharedEmailAddressOptions: {
      title: "Edytuj udostępniony adres e-mail",
    },
    showDeviceManagementInCockpit: {
      title: "Zarządzanie urządzeniami pokazać w kokpicie",
    },
    system: {
      clientEmailAndPassword: "Adres e-mail i hasło do bazy danych",
      dataStorage: "Konfiguracja zapisywania danych",
      dataStorageDatabase: "Zapisywanie danych Baza danych",
      dataStorageTablet: "Tablet do przechowywania danych",
      finishedProjects: {
        title: "Projekty zarchiwizować",
        currentProjectsNotTouched:
          "Przesunąć projekty, które nie są już realizowane?",
        deleteProjectsNotProcessed:
          "Projekt w K1, brak akcji:\nUsunąć projekt?",
        moveFinishedProjects: "Przenieść UKOŃCZONE PROJEKTY do STARE PROJEKTY?",
        moveProjectsClosed:
          "Projekt w K8 ukończony, nieukończony:\nPrzesunąć projekt?",
        moveProjectsDamagePatternClosed:
          "Projekt w K4 ukończony, nieukończony:\nprzesunąć projekt?",
        moveProjectsOnHold:
          "Projekt w K4 czeka na ubezpieczenie. Przełożyć projekt?",
        numberOfDays: {
          never: "Nigdy",
          one: "1 dzień",
          two: "2 dni",
          three: "3 dni",
          four: "4 dni",
        },
        numberOfMonths: {
          never: "Nigdy",
          three: "3 miesiące",
          six: "6 miesięcy",
          nine: "9 miesięcy",
          twelve: "12 miesięcy",
          twentyFour: "24 miesiące",
        },
        numberOfWeeks: {
          never: "Nigdy",
          one: "1 tydzień",
          two: "2 tygodnie",
          four: "4 tygodnie",
          eight: "8 tygodni",
          twelve: "12 tygodni",
        },
        recentlyFinishedProjects:
          "Pokazać ostatnio ukończone projekty w sekcji AKTUALNE PROJEKTY?",
      },
      geoEncoding: "Mapa",
      tracking: "Śledzenie",
      moveDevicesDialog: {
        message:
          "Wszystkie urządzenia zostaną przywrócone do magazynu, z którego zostały pierwotnie załadowane. Czy chcesz kontynuować?",
        title: "Przywrócić urządzenia do magazynu?",
      },
      operationalPlaning: "Planowanie operacyjne",
      mira: {
        title: "Mira",
        mode: {
          OFF: "Nie",
          IRES_ONLY: "Tylko IRES",
          ON: "Tak",
        },
      },
      systemConfiguration: "Konfiguracja systemu",
      chat: {
        title: "Włączyć czat / komunikator?",
        mode: {
          NONE: "Nie",
          PERSONAL_ONLY: "Tylko czat osobisty",
          PROJECT_ONLY: "Tylko czat projektowy",
          BOTH: "Oba czaty",
        },
      },
      title: "System",
    },
    timeTracking: {
      configuration: "Konfiguracja rejestracji czasu",
      createDailyTracking: "Tworzenie dziennego zamknięcia dnia",
      dailyTracking: "Zamknięcie dnia",
      isStartEndMandatory: "Obowiązkowy początek i koniec",
      sectionTitle: "Rejestrowanie czasu pracy",
      sendDailyTracking: "Wysyłanie dziennego zamknięcia",
      specifyStartEnd: "Określ początek i koniec",
      title: "Rejestrowanie czasu",
      workingHours: "Godziny pracy i pauzy",
    },
    upload: "Przesyłanie",
    userManagement: "Użytkownik",
    userSettings: {
      alwaysUseManagerAsSupervisor:
        "Menedżer zawsze przejmuje rolę kierownika projektu",
      cockpitActiveForAllUsers:
        "Wyświetlanie kokpitu dla wszystkich użytkowników?",
      keepProjectOwner: "Zachować operatora",
      strictBranchFilters: "Łączenie lokalizacji",
      title: "Ustawienia użytkownika",
    },
    users: "Zarządzanie użytkownikami",
    vehicleManagement: {
      createVehicle: "Utworzenie pojazdu",
      deleteVehicle: "Usuń pojazd",
      deleteVehicleMessage: "Czy na pewno chcesz usunąć pojazd {0}?",
      editVehicle: "Fahrzeug bearbeiten",
      errorDuplicateLicencePlate: "Kennzeichen bereits vergeben",
      errorDuplicateVehicleId: "Fahrzeug-ID bereits vorhanden",
      errorMissingLicencePlate: "Kennzeichen darf nicht leer sein",
      errorMissingVehicleId: "Fahrzeug-ID darf nicht leer sein",
      licencePlate: "Tablica rejestracyjna",
      location: "Lokalizacja",
      size: "Rozmiar",
      sortNumber: "SortNo.",
      title: "Zarządzanie pojazdami",
      user: "Użytkownik",
      vehicleId: "Identyfikator pojazdu",
    },
  },
  sharedEmailAddressForm: {
    changeHomeClientButton: "Ustaw nowego klienta oddziału",
    changeHomeClientTitle: "Ustaw nowego klienta oddziału",
    changePasswordButton:
      "Przypisywanie nowego hasła do udostępnionego adresu e-mail",
    changePasswordTitle: "Hasło do udostępniania adresu e-mail",
    confirmChangeHomeClient: "Zmienić wybranego klienta na {0}?",
    confirmChangeHomeClientTitle: "Jesteś pewien?",
    quitSharingButton:
      "Zaprzestanie udostępniania adresu e-mail dla tego klienta",
    quitSharingTitle: "Proszę wprowadzić nowy adres e-mail",
  },
  sharedEmailAddressOptionsDialog: {
    message:
      "Wielokrotna rejestracja w portalu HyDry. Wybierz żądanego klienta.",
    title: "Wielokrotna rejestracja w portalu HyDry",
    titleForSwitchingSharedUser: "Wybór współdzielonego użytkownika",
  },
  sharedUserOfGroup: {
    clientOptionsDialog: {
      message:
        "Wielokrotna rejestracja w portalu HyDry. Wybierz żądanego klienta.",
      title: "Wielokrotna rejestracja w portalu HyDry",
      titleForSwitchingClient: "Wybór klient",
    },
  },
  userPicker: {
    noMatchingUsers: "Nie znaleziono pasujących użytkowników.",
    noUsers: "Brak innych dostępnych użytkowników.",
    selectUser: "Wybierz użytkownika",
  },
  users: {
    activateCockpit: "Aktywacja kokpitu w aplikacji",
    activeFilters: "--- Aktywne filtry: {0} ---",
    allRoles: "Wszystkie role",
    admin: "Admin",
    createUser: "Utwórz użytkownika",
    deleteSharedEmailAddressDialog: {
      message:
        "Współdzielony dostęp do poczty e-mail zostanie usunięty. Czy na pewno?",
      title: "Usunięcie współdzielonego dostępu do poczty e-mail",
    },
    deleteUser: "Usuń",
    deleteUserMessage: "Czy na pewno chcesz usunąć użytkownika {0}?",
    editUser: "Edytuj użytkownika",
    emailAddress: "Adres e-mail",
    error: {
      notAllowedToChangeRole: "Tylko SysAdmin tego klienta może zmieniać role lub tworzyć użytkowników.",
      saveFailed: "Nie udało się zapisać użytkownika. Spróbuj ponownie.",
      emailAlreadyUsed: "Adres e-mail jest już używany",
      missingEmailAddress: "Proszę wprowadzić swój adres e-mail",
      missingNickname: "Proszę wprowadzić krótkie nazwy",
      missingRole: "Proszę wprowadzić określić rolę",
      missingValidationLevel:
        "Proszę wprowadzić wartość dla sprawdzenia formalności",
      missingStaffNumber: "Proszę wprowadzić swój numer personalny",
      invalidSupervisor:
        "Wybrany menedżer musi mieć uprawnienie nadzoru projektu",
      nicknameAlreadyTaken: "Krótka nazwa jest już zajęta",
      passwordToShort: "Hasło musi składać się z co najmniej 8 znaków.",
      invalidField: {
        nickname: "Nieprawidłowa krótka nazwa (1–100 znaków)",
        email: "Nieprawidłowy adres e-mail",
        role: "Nieprawidłowa rola",
        staffNumber: "Nieprawidłowy numer personalny (maks. 50 znaków)",
        generic: "Nieprawidłowe dane — proszę sprawdzić pola",
      },
    },
    firstName: "Imię",
    homeClient: "Klient domowy",
    language: "Język",
    lastEdit: "Ostatnia aktualizacja: {0} {1}",
    lastName: "Nazwisko",
    licences: "Licencje",
    lock: "blokada",
    lockUser: "Blokowanie użytkownika",
    lockUserMessage: "Czy na pewno chcesz zablokować użytkowników {0} {1}?",
    mobilePhone: "Komórka",
    nickname: "Nazwa skrócona",
    noUsersFound: "--- nie znaleziono użytkowników ---",
    passwordHint:
      "Wskazówka/Przy pierwszym logowaniu jako hasło wymagany jest numer personalny.",
    postalCode: "Kod pocztowy",
    resetUserPassword: "Resetowanie hasła",
    resetUserPasswordMsg:
      "Proszę wprowadzić tymczasowe hasło dla tego użytkownika {0} {1}",
    role: {
      admin: "Admin",
      customRole1: "Zdefiniowana rola użytkownika 1",
      customRole2: "Rola zdefiniowana użytkownika 2",
      customRole3: "Rola zdefiniowana użytkownika 3",
      customRole4: "Rola zdefiniowana użytkownika 4",
      customRole5: "Menedżer urządzeń",
      editRole: "Rola edytuj",
      isActive: "Rola aktywna",
      label: "Role oznaczenie",
      leakDetection: "Wykrywanie nieszczelności",
      na: "",
      notSpecified: "",
      office: "Biuro",
      projectManager: "Kierownik projektu",
      sysAdmin: "SysAdmin",
      technicanAndLeakDetection: "Technik + wykrywanie nieszczelności",
      technician1: "Technik 1",
      technician2: "Technik 2",
    },
    staffNumber: "Numer osobisty",
    stationaryPhone: "Telefon stacjonarny",
    supervisor: "Kierownik",
    temporaryPassword: "Hasło tymczasowe",
    unlock: "odblokowanie",
    unlockUser: "Odblokowanie użytkownika",
    unlockUserMessage: "Czy na pewno chcesz odblokować użytkownika {0} {1}?",
    userAddressHousenumber: "Numer domu",
    userAddressStreet: "Ulica",
    userCountry: "Kraj",
    userData: "Dane użytkownika",
    userLocation: "Miejsce",
    userRole: "Rola",
    userValidationLevel: "Sprawdzenie",
    usesTablet: "Korzystanie z tabletu",
    validationLevel: {
      low: "niski",
      normal: "normalny",
      strict: "mocny",
    },
    vehicle: "Pojazd",
    vehicleAtHome: "Pojazd w firmie",
  },
  vehicles: {
    allocatedUser: "Użytkownik",
    branch: "Lokalizacja",
    devices: {
      concludeLoading: "ins Fahrzeug Laden",
      concludeUnloading: "in Lager {0} Entladen",
      currentWarehouse: "Aktuelles Lager:",
      deviceMoveInfo: "{0} z {1}",
      load: "Fahrzeug Beladen",
      loadFailureMessage:
        "Es gab einen Fehler beim Laden von Geräten in das Fahrzeug {0}",
      loadSuccessMessage:
        "1 Gerät erfolgreich in das Fahrzeug geladen {0} | {count} Geräte erfolgreich in das Fahrzeug geladen {0}",
      locationUpdateFailureMessage:
        "Aktualisierung des Standorts von 1 Gerät fehlgeschlagen | Aktualisierung des Standorts von {count} Geräte fehlgeschlagen",
      locationUpdateSuccessMessage:
        "Standort von 1 Gerät erfolgreich aktualisiert | Standort von {count} Geräte erfolgreich aktualisiert",
      emptyDevicesHint: "Keine Geräte gefunden.",
      noMatchingDevicesFound: "Nie znaleziono odpowiednich urządzeń",
      numberOfAvailableDevices: "1 Gerät verfügbar | {count} Geräte verfügbar",
      numberOfSelectedDevices: "Auswahl Gerät: 1 | Auswahl Geräte: {count}",
      overview: "Geräte in Fahrzeug",
      title: "Geräte in Fahrzeug {0}",
      unload: "Fahrzeug Entladen",
      unloadFailureMessage:
        "Es gab einen Fehler beim Entladen von Geräten in das Lager {0}",
      unloadSuccessMessage:
        "1 Gerät erfolgreich ins Lager entladen {0} | {count} Geräte erfolgreich ins Lager entladen {0}",
      crossWarehouseUnloadTitle: "Anderer Heimatstandort",
      crossWarehouseUnloadMessage: "Einige Geräte gehören nicht zu diesem Lager. Möchten Sie sie trotzdem hier entladen?",
    },
    licencePlate: "Tablica rejestracyjna",
    numberOfDevices: "Geräte im Fahrzeug",
    vehicleId: "Identyfikator pojazdu",
  },
  quality: {
    title: "RENO Ocena dzienna",
    chainTitle: "RENO Ocena dzienna: Łańcuch {0}",
    tabs: {
      daily: "Wynik dzienny",
      manual: "Wynik ręczny",
    },
    windows: {
      all: "Wszystkie",
      days: "{0} Dni",
      selectWindows: "Wybierz okna",
    },
    modelVersion: {
      label: "Wersja modelu",
    },
    trafficLight: {
      title: "Ocena",
      good: "Dobry",
      needsReview: "Do sprawdzenia",
      critical: "Krytyczny",
      unknown: "Nieznany",
    },
    status: {
      probablyDry: "Prawdopodobnie suchy",
      probablyStationary: "Prawdopodobnie stacjonarny",
    },
    binary: {
      title: "Wybór binarny",
      abnormal: "Nieprawidłowy",
      normal: "Normalny",
    },
    groupA: {
      title: "Główne etykiety",
      normal: "Normalny",
      powerOutages: "Przerwy w zasilaniu",
      newMoistureIngress: "Nowe wnikanie wilgoci",
      slowDrying: "Wolne suszenie",
      unfavorableAmbientConditions: "Niekorzystne warunki otoczenia",
    },
    groupD: {
      title: "Przyczyna wolnego suszenia",
      peripheralMoisture: "Wilgoć obwodowa",
      withoutFoil: "Bez folii",
      ambientConditions: "Warunki otoczenia",
      lowAirflow: "Niski przepływ powietrza",
    },
    labels: {
      title: "Etykiety wielokrotnego wyboru",
      subGroupA: "Problemy z suszeniem",
      subGroupB: "Urządzenie / Meta",
      powerFailure: "Przerwy w zasilaniu wpływające na suszenie",
      newMoisture: "Nowe wnikanie wilgoci",
      slowDrying: "Wolne suszenie",
      unfavorableConditions: "Niekorzystna temperatura otoczenia",
      ambientHumidityBad: "Niekorzystna wilgotność otoczenia",
      lowInitialMoisture: "Niska początkowa wilgotność",
      relayDefect: "Defekt przekaźnika",
      notForTraining: "Nie używaj do trenowania",
      clearClass: "Jasna klasa",
    },
    actions: {
      saveCorrections: "Zapisz korekty",
      manualCalculation: "Obliczenie ręczne",
      calculate: "Oblicz",
      cancel: "Anuluj",
      rerun: "Oblicz ponownie",
    },
    messages: {
      correctionSaved: "Korekta zapisana pomyślnie",
      correctionError: "Błąd zapisywania korekty",
      predictionLoading: "Trwa obliczanie oceny RENO...",
      predictionComplete: "Predykcja zakończona",
      predictionError: "Błąd predykcji",
      featureNotActivated: "Predykcje nie są aktywowane dla tego klienta.",
      latestModelOnlyRecalculation: "Ponowne obliczenie jest dostępne tylko dla najnowszej wersji modelu.",
      noData: "Brak danych RENO",
      noDailyData: "Brak oceny dziennej",
      noManualData: "Brak oceny ręcznej",
      programNotSupported: "RENO nie jest obsługiwane dla tego numeru programu.",
      newerModelAvailable: "Dostępny nowszy model ({0}). Wyniki można ponownie obliczyć z nową wersją.",
      correctedBadge: "Skorygowano",
      correctedAt: "Skorygowano dnia {0}",
      correctedBy: "Skorygowano przez {0}",
    },
    trend: {
      title: "Trend",
      days: "Ostatnie {0} dni",
    },
    timeSeries: {
      title: "RENO Seria czasowa",
      qualityLabel: "Jakość",
      noData: "Brak danych serii czasowej",
      generateHistory: "Generuj historię",
      backfillProgress: "{0} z {1} dni obliczonych",
      targets: {
        dry: "Suchy",
        stationary: "Stacjonarny",
        newMoistureIngress: "Nowa wilgoć",
        slowDrying: "Wolne",
        powerOutage: "Prąd",
        relayDefect: "Przekaźnik",
        unfavorableAmbient: "Klimat",
        lowAirflow: "Przepływ",
        peripheralMoisture: "Wilgoć obwodowa",
        roomTemperature: "Temperatura",
        roomHumidity: "Wilg. wzgl.",
        moistureLoad: "Wilg. bezwzgl.",
        deviceOutput: "Moc",
        favorableWeather: "Wietrzyć",
      },
    },
    noAiModel: "Brak modelu AI",
  },
  mira: {
    exceptions: {
      leftOut: "pominięte jako wyjątki: {0}",
    },
    landing: {
      comingSoon: "Widok szczegółowy wkrótce",
      available: "Dostępne wskaźniki: {n}",
      waiting: "Czekające na dane: {n}",
      settings: {
        open: "Ustawienia",
        title: "{0}: wskaźniki",
        editTitle: "Edytuj wskaźniki: {0}",
        availableHeading: "Dostępne wskaźniki",
        waitingHeading: "Co odblokowuje kolejne wskaźniki",
        defaultChoice: "Kafelek pokazuje pierwsze {0} wskaźników tej sekcji.",
        ownChoice: "Kafelek pokazuje tylko wybrane wskaźniki.",
        hint: "Kliknij wskaźniki w kolejności, w jakiej mają się pojawić na kafelku (maksymalnie {0}). Drugie kliknięcie usuwa wskaźnik.",
        reset: "Domyślne",
        saved: "Wybór zapisany",
        saveError: "Nie udało się zapisać wyboru.",
      },
      descriptions: {
        businessDevelopment: "Projekty, czas trwania projektów, rodzaje zakończenia i czas reakcji",
        processFlow: "Jak długo trwają etapy zlecenia i gdzie występują przestoje",
        hydry: "Czas osuszania, przerwy, częstotliwość pomiarów i powierzchnia osuszania",
        devices: "Dni urządzeń, godziny pracy, zużycie prądu i wykorzystanie floty",
        insurance: "Czas zatwierdzenia, wskaźnik akceptacji i zatwierdzony czas osuszania",
        dataQuality: "Jak kompletnie zapisane są twoje projekty i urządzenia",
      },
    },
    unlock: {
      title: "Odblokuj więcej wskaźników",
      waiting: "Wskaźniki czekające na dane: {n}",
      allUnlocked: "Wszystkie wskaźniki są odblokowane",
      showAll: "Pokaż wszystko",
      parts: {
        RECORD: {
          title: "Co możesz uzupełnić",
          subtitle: "Im pełniejsze te dane, tym więcej wskaźników widzisz.",
        },
        CASES: {
          title: "Pojawi się przy większej liczbie przypadków",
          subtitle: "Nic nie musisz robić: wskaźnik pojawi się, gdy zbierze się wystarczająco przypadków.",
        },
      },
      shareProgress: "{0} zarejestrowano · widoczne od {1}",
      countProgress: "{0} z {1} potrzebnych przypadków",
      casesInstruction: "Pojawi się, gdy w okresie zbierze się co najmniej {0} przypadków.",
    },
    periods: {
      rolling12: "Ostatnie 12 miesięcy",
      "rolling12-previous": "Poprzednie 12 miesięcy",
      "rolling12-month-earlier": "12 miesięcy miesiąc wcześniej",
      ytd: "Ten rok",
    },
    sections: {
      businessDevelopment: "Rozwój działalności",
      processFlow: "Proces",
      hydry: "Osuszanie",
      devices: "Urządzenia",
      insurance: "Ubezpieczyciele",
      dataQuality: "Jakość danych",
    },
    format: {
      hours: "{0} godz.",
      percent: "{0}%",
      percentBelow: "< {0}%",
      percentAbove: "> {0}%",
      deltaPoints: "{0} p.p.",
      others: "Pozostałe ({0})",
      spread: "P15 {0} · P85 {1}",
      median: "Mediana {0}",
    },
    allClients: {
      label: "Wszyscy klienci",
    },
    periodTooltip: "Okres",
    edition: "{0} · Z warsztatu · {1}",
    comparison: {
      tooltip: "Porównanie",
      choice: "Porównanie: {0}",
      cardTitle: "{0} wg klienta",
      referenceGroup: "Grupa łącznie",
      markers: "P15 {0} · mediana {1} · P85 {2}",
      markersLegend: "Linie: {0}, w projektach pierwszego wiersza",
      withoutValue: "Bez wartości: {0}",
      membersSuffix: "z {0} z {1} firm",
      membershipAssumed: "Grupa w składzie z dnia {0}: wcześniejsze zmiany nie są uwzględnione.",
      showAll: "Pokaż wszystkie",
      showLess: "Pokaż mniej",
      empty: "Żaden klient grupy nie ma wartości dla tego wskaźnika w tym okresie.",
      cardTitleBranches: "{0} wg oddziału",
      cardTitleGroupView: "{0} w grupie",
      emptyBranches: "Żaden oddział nie ma wartości dla tego wskaźnika w tym okresie.",
      groupView: {
        withheld: "Za mało firm lub przypadków: {0}",
        empty: "Dla tego wskaźnika nie ma wartości grupy.",
      },
      noMetricForBranches: "Dla tego wskaźnika nie ma porównania wg oddziałów.",
      referenceClient: "Łącznie",
      branchNone: "Bez oddziału",
      branchOther: "Pozostałe oddziały",
      branchUnknown: "Nieznany oddział",
      headline: "{0}: {1}",
      modes: {
        NONE: "Brak porównania",
        MEMBERS: "Klienci grupy",
        BRANCHES: "Oddziały klienta",
        MARKET: "Rynek",
        GROUP: "Grupa",
      },
    },
    market: {
      cardTitle: "{0} na rynku",
      tileCaption: "Rynek {0}",
      tooFewCompanies: "Za mało firm z wystarczającą liczbą przypadków: {0}",
      empty: "Dla tego wskaźnika nie ma wartości rynkowej.",
      entities: {
        projects: "Rynek",
      },
    },
    trend: {
      title: "Przebieg: {0}",
      grains: {
        month: "Miesiąc",
        quarter: "Kwartał",
        year: "Rok",
      },
      gapNote: "Luki: za mało przypadków w okresie, aby pokazać wartość.",
      partialNote: "Pusty punkt: bieżący rok, jeszcze niepełny.",
      bandNote: "Pasmo: P15 do P85, środkowe 70% przypadków.",
      rangeNote: "{0} do {1}, niezależnie od wybranego okresu",
      periodNote: "Na szaro: wybrany okres.",
      medianLineNote: "Linia: średnia · cienka linia: mediana",
      partialYear: "{0} (do dziś)",
      tooFew: "za mało",
      tooltipBasis: "{0}",
      tooltipMedian: "Mediana {0}",
      noData: "Brak danych dla tego wskaźnika w wybranym przebiegu.",
    },
    units: {
      projects: "projekty: {0}",
      projectsOne: "1 projekt",
      dryings: "osuszania: {0}",
      dryingsOne: "1 osuszanie",
      assignments: "przypisania: {0}",
      assignmentsOne: "1 przypisanie",
      assignmentsWithReading: "przypisania ze stanem licznika: {0}",
      assignmentsWithReadingOne: "1 przypisanie ze stanem licznika",
      readings: "odczyty licznika: {0}",
      readingsOne: "1 odczyt licznika",
      offers: "oferty: {0}",
      offersOne: "1 oferta",
      answers: "odpowiedzi: {0}",
      answersOne: "1 odpowiedź",
      deviceDays: "dni urządzeń: {0}",
      deviceDaysOne: "1 dzień urządzenia",
      devices: "urządzenia: {0}",
      devicesOne: "1 urządzenie",
    },
    stacked: {
      tooltipTotal: "Łącznie {0}",
      restNote: "{0} dalszych w rankingu poniżej",
      barFloorNote: "Słupki oparte na mniej niż {0} przypadkach są ukryte.",
    },
    levels: {
      best: "Najlepszy",
      worst: "Najgorszy",
      highest: "Najwyższy",
      lowest: "Najniższy",
      note: "W każdym okresie, spośród wszystkich z wartością: dwie skrajne wartości i progi 25%, 50% i 75% między nimi. Progi dzielą porównywane pozycje, nie wartość; każdy słupek to wartość jednej pozycji. Każda pozycja jest w rankingu poniżej.",
      namesFor: "W nawiasach: kto zajmuje to miejsce w okresie {0}.",
    },
    caveat: {
      weakestFieldWithGaps: "Wartość to najsłabiej wypełnione pole. Ubezpieczyciel, powierzchnia osuszania i kierownik projektu nie są tu jeszcze sprawdzane.",
      routeRecordedSince2025: "Źródło zapisu jest zapisywane dopiero od 2025 roku.",
    },
    dataQuality: {
      title: "Jakość danych",
      noData: "Dla twojej firmy nie ma jeszcze analiz Mira.",
      loadError: "Nie udało się wczytać analiz Mira.",
      noValue: "Brak danych w tym okresie",
      periodRange: "{0}: od {1} do {2}",
      generatedAt: "Stan: {0}",
      comparedWith: "W porównaniu z: {0}",
      weakestField: "Najsłabiej wypełnione: {0}",
      energyCaption: "spośród {0} zakończonych przypisań urządzeń z własnym licznikiem",
      insurerCaptureCaption: "spośród {0} projektów bez zlecenia bezpośredniego",
      fieldsTitle: "Wypełnienie według pola",
      fieldsSubtitle: "w {0} projektach, najsłabiej wypełnione pole najpierw",
      energyTitle: "Stany liczników",
      energyRingCaption: "ze stanami",
      energySubtitle: "jak zapisane są zakończone przypisania urządzeń z własnym licznikiem",
      status: {
        good: "Dobrze wypełnione",
        warning: "Niekompletne",
        critical: "Za mało wypełnione",
      },
      legend: {
        good: "od 80%",
        warning: "od 40 do 79%",
        critical: "poniżej 40%: zależne od tego wskaźniki pozostają ukryte",
      },
      fields: {
        branch: "Oddział",
        projectTypeId: "Typ projektu",
        damageDay: "Dzień szkody",
        outcomeState: "Wynik oceny szkody",
        rooms: "Pomieszczenia w ocenie szkody",
        timeline: "Początek i koniec",
        timeEntries: "Wpisy czasu w projekcie",
      },
      energy: {
        withReading: "Ze stanami liczników",
        unknownReading: "Bez stanu licznika",
        invalidReading: "Nieprawidłowy stan licznika",
        implausibleReading: "Nieprawdopodobnie wysokie zużycie",
        onImplausibleProject: "{0} z nich dotyczy projektów z nieprawdopodobnie wysokim zużyciem; są uwzględnione powyżej.",
      },
      unlocks: {
        title: "Co odblokowuje kolejne wskaźniki",
        description: "Te wskaźniki pozostają ukryte w wybranym okresie, dopóki nie zostanie zapisane wystarczająco dużo danych.",
        none: "W wybranym okresie żadnemu wskaźnikowi nie brakuje zapisanych danych.",
        fallback: "Za mało zapisanych danych w tym okresie.",
      },
    },
    drying: {
      title: "Osuszanie",
      families: {
        box: "Box",
        mini: "Mini",
        panel: "Panel",
      },
      units: {
        day: "{0} dzień",
        days: "{0} dni",
        squareMetres: "{0} m²",
        perWeek: "{0} na tydzień",
        perProject: "{0} na projekt",
      },
      captions: {
        dryingTime: "{0} · z {1} osuszań ({2})",
        pauseShare: "{0} · z {1} osuszań ({2})",
        dryingsWithoutFamily: "{0} · z {1} osuszań",
        projectDryingTime: "{0} · z {1} projektów",
        projectPauseShare: "{0} · z {1} projektów",
        measurementFrequency: "z {1} osuszań, w tym {0} bez pomiaru pośredniego",
        measurementsPerProject: "z {1} projektów, w tym {0} bez pomiaru pośredniego",
        dryingArea: "{0} · z {1} projektów",
        forecast: "średnio ponad prognozę · z {1} osuszań, w tym {0} dłużej niż planowano",
      },
      cards: {
        dryingTime: "Czas osuszania HyDry według typu urządzenia",
        dryingTimeSubtitle: "Łańcuchy programów bez projektu od 4 godzin, średnia i mediana",
        pauseShare: "Udział przerw według typu urządzenia",
        pauseShareSubtitle: "Przerwy jako udział czasu osuszania, osuszania bez projektu",
        measurementFrequency: "Częstotliwość pomiarów",
        measurementFrequencySubtitle: "Serie pomiarowe na tydzień osuszania, bez serii przy ustawieniu i demontażu",
        measurementsPerProject: "Pomiary pośrednie na projekt",
        measurementsPerProjectSubtitle: "Pomiary pośrednie na osuszany projekt z pomiarem przy ustawieniu osuszania",
        dryingArea: "Powierzchnia osuszania",
        dryingAreaSubtitle: "średnia powierzchnia na osuszany projekt",
        forecast: "Prognoza i rzeczywisty czas osuszania",
        forecastSubtitle: "jak często i jak bardzo osuszania przekraczają prognozę",
      },
      dotPlot: {
        mean: "Średnia",
        median: "Mediana",
        count: "Osuszania",
      },
      shortChains: "{0} łańcuchów programów poniżej 4 godzin nie jest liczonych.",
      shareWithPause: "{0} z przerwą",
      pause: {
        dryingPause: "Przerwa w osuszaniu",
        powerCut: "Przerwa w zasilaniu",
      },
      measurementGroups: {
        hydry: "Z urządzeniami HyDry ({0})",
        conventional: "Tylko urządzenia konwencjonalne ({0})",
        noDevices: "Bez przypisanych urządzeń ({0})",
      },
      area: {
        floor: "Podłoga",
        wallCeiling: "Ściana / sufit",
      },
      forecast: {
        overForecast: "Dłużej niż planowano",
      },
      facts: {
        median: "Mediana",
        withoutArea: "Projekty bez powierzchni",
        meanOverrun: "Średnio ponad prognozę",
        fromDefault: "Prognoza pozostawiona domyślna",
        noForecast: "Bez prognozy",
        noActual: "Bez rzeczywistego czasu",
      },
      inPreparation: "W przygotowaniu: {0}",
    },
    devices: {
      title: "Urządzenia",
      controlParts: {
        box: "Box",
        mini: "Mini",
        both: "oba",
        none: "żadne",
      },
      fleets: {
        own: "Własne urządzenia",
      },
      units: {
        kWh: "{0} kWh",
        kWhPerDay: "{0} kWh/dzień",
        kWhPerSquareMetre: "{0} kWh/m²",
        MWh: "{0} MWh",
        hours: "{0} h",
      },
      captions: {
        fleet: "{0} · największa flota",
        energy: "z {0} przypisań ze stanem licznika",
        energyLeftOut: "z {0} przypisań ze stanem licznika · {1} projektów nieliczonych",
        energyPerProject: "{0} · z {1} projektów",
        energyPerDryingDay: "{0} · z {1} projektów",
        energyPerArea: "{0} · z {1} projektów",
        partialReadings: "{0} z niepełnymi stanami liczników",
        deviceDays: "z {0} przypisań",
        devicesPerProject: "{0} · z {1} projektów z urządzeniami osuszającymi",
        controlDevicesPerProject: "{0} · z {1} projektów z Box lub Mini",
        controlProjectShare: "{0} z {1} zakończonych projektów",
        hydryControlLine: "HyDry Control: {0} na projekt z Box lub Mini ({1})",
        operatingHours: "z {0} odczytów licznika",
        operatingHoursDerivedOnly: "tylko z czasu przypisania: {0}",
      },
      cards: {
        categoryMix: "Dni urządzeń według kategorii",
        categoryMixSubtitle: "Udział we wszystkich dniach twoich własnych urządzeń",
        energy: "Zużycie prądu",
        energySubtitle: "Urządzenia z własnym licznikiem prądu, w kWh",
        operatingHours: "Godziny pracy",
        operatingHoursSubtitle: "odczytane liczniki i godziny z czasu przypisania, nigdy nie sumowane",
      },
      facts: {
        daysInUse: "{0} z {1} dni",
        total: "Łącznie",
        perProject: "Średnio na projekt",
        leftOutOfTotal: "Projekty poza sumą (niewiarygodne zużycie)",
        leftOutOfAverage: "Projekty poza średnią (ponad 120 kWh dziennie)",
        counterHours: "Godziny odczytane z licznika",
        derivedConfirmed: "Z czasu przypisania, potwierdzone",
        derivedUnconfirmed: "Z czasu przypisania, niepotwierdzone",
        implausibleReadings: "Niewiarygodne odczyty, nieliczone",
      },
      unknownCategory: "Nieznana kategoria",
    },
    businessDevelopment: {
      title: "Rozwój działalności",
      captions: {
        projects: "zakończone w tym okresie",
        duration: "{0} · z {1} zakończonych projektów",
        rooms: "{0} · z {1} projektów",
        reactionTime: "{0} · z {1} projektów z dniem szkody",
        rejections: "{0} z {1} projektów z decyzją",
      },
      cards: {
        outcomes: "Rodzaje zakończenia",
        outcomesSubtitle: "Wynik oceny szkody na projekt",
        outcomesRingCaption: "z wynikiem",
        branches: "Projekty według oddziału",
        branchesSubtitle: "Udział we wszystkich projektach z oddziałem",
        projectTypes: "Rozkład typów projektów",
        projectTypesSubtitle: "Udział we wszystkich projektach z typem projektu",
        damageCauses: "Przyczyny szkód",
        damageCausesSubtitle: "{0} z {1} projektów zakończonych w IRES Project z przyczyną szkody; projekt z kilkoma przyczynami liczy się przy każdej",
        damageCausesMarketSubtitle: "Udział projektów z przyczyną szkody ({0} u ciebie); projekt z kilkoma przyczynami liczy się przy każdej, więc łącznie ponad 100 %",
        damageCausesMore: "Inne przyczyny: {0}",
      },
      facts: {
        rejections: "Odrzucenia",
        rejectedOf: "{0} z {1} ({2})",
        noRejections: "brak w tym okresie",
      },
      unknownBranch: "Nieznany oddział",
      unknownProjectType: "Nieznany typ projektu",
      unknownDamageCause: "Nieznana przyczyna",
      services: {
        title: "Usługi",
        caption: "Projekt liczy się w każdej usłudze zakończonej w tym okresie.",
        leakDetection: "Lokalizacja wycieku",
        damageAssessment: "Oględziny szkody",
        drying: "Osuszanie",
        repair: "Przywrócenie stanu",
      },
    },
    insurance: {
      title: "Ubezpieczyciele",
      captions: {
        approval: "{0} · z {1} ofert",
        acceptance: "{0} z {1} odpowiedzi zaakceptowanych",
        overrun: "{0} · z {1} osuszań z zaakceptowaną ofertą",
        directOrders: "{0} z {1} projektów z informacją",
      },
      cards: {
        answers: "Odpowiedzi ubezpieczyciela",
        answersSubtitle: "na oferty z IRES Project, według miesiąca odpowiedzi",
        approval: "Zatwierdzenie i osuszanie",
        approvalSubtitle: "osuszania z zaakceptowaną ofertą, według miesiąca zakończenia projektu",
      },
      parts: {
        accepted: "Zaakceptowane",
        rejected: "Odrzucone",
      },
      bars: {
        overApproved: "Osuszano dłużej niż zatwierdzono",
        cut: "Zatwierdzono mniej dni niż wnioskowano",
      },
      facts: {
        recordedTogether: "Zapisane razem z ofertą (bez czasu zatwierdzenia)",
        implausibleDates: "Niemożliwe daty",
        meanOverrun: "Średnio ponad zatwierdzenie",
        medianOverrun: "Mediana ponad zatwierdzenie",
        noApprovedDays: "Bez zatwierdzonego czasu osuszania",
        noActual: "Bez rzeczywistego czasu osuszania",
      },
      insurer: {
        card: "Ubezpieczyciele",
        cardSubtitle: "Udział projektów zakończonych w okresie",
        insurersHeading: "Według ubezpieczyciela: udział {0} projektów z ubezpieczeniem",
        others: "Pozostali ubezpieczyciele",
        unidentified: "niezidentyfikowany",
        cases: {
          insured: "Z ubezpieczeniem",
          noInfo: "Brak danych",
          direct: "Zlecenie bezpośrednie",
        },
      },
    },
    processFlow: {
      title: "Proces",
      captions: {
        transition: "{0} · z {1} projektów",
      },
      groups: {
        order: "Zlecenie i ocena",
        drying: "Zatwierdzenie i osuszanie",
        restoration: "Odtworzenie i zakończenie",
      },
      cards: {
        order: "Kolejność etapów projektu",
        routes: "Źródło zapisu",
        routesSubtitle: "czym zapisano etapy projektu",
      },
      routes: {
        viaApp: "IRES Project",
        viaErp: "System ERP",
        viaPortal: "IRES Office",
      },
      facts: {
        noRoute: "Etapy bez źródła",
      },
      stack: {
        title: "Przebieg projektu",
        caption: "Na {0} projektów ze wszystkimi krokami · {1} poza kolejnością, nie liczone",
        insuranceHeader: "Z akceptacją ubezpieczyciela ({0} projektów)",
        damageToApproval: "Od oględzin szkody do akceptacji",
        approvalToSetup: "Od akceptacji do montażu osuszania",
        stages: {
          toDamageAssessment: "Do oględzin szkody",
          toDryingSetup: "Do montażu osuszania",
          drying: "Osuszanie",
          toProjectEnd: "Do końca projektu",
        },
      },
    },
    metrics: {
      "MIRA-PRJ-003": {
        title: "Rozkład rodzajów zakończenia",
        unlock: "Zakończ ocenę szkody, podając jej wynik.",
      },
      "MIRA-PRJ-006": {
        title: "Projekty według oddziału",
        unlock: "Przypisz oddział do każdego projektu.",
      },
      "MIRA-PRJ-007": {
        title: "Rozkład typów projektów",
        unlock: "Wybierz typ projektu dla każdego projektu.",
      },
      "MIRA-PRJ-008": {
        title: "Czas reakcji (od szkody do rozpoczęcia projektu)",
        unlock: "Wpisz dzień szkody w każdym projekcie.",
      },
      "MIRA-PRJ-011": {
        title: "Liczba pomieszczeń (wielkość projektu)",
        unlock: "Dodaj dotknięte pomieszczenia w ocenie szkody.",
      },
      "MIRA-PRJ-012": {
        title: "Rozkład typów budynków",
        unlock: "Podaj obiekt / budynek w opisie.",
      },
      "MIRA-PRJ-013": {
        title: "Przyczyny szkód",
        unlock: "Podaj przyczynę szkody w opisie szkody.",
      },
      "MIRA-PRJ-015": {
        title: "Cechy obiektu",
        unlock: "Uzupełnij cechy obiektu w opisie.",
      },
      "MIRA-PRJ-016": {
        title: "Rozkład likwidatorów",
        unlock: "Podaj rodzaj likwidatora w każdym projekcie.",
      },
      "MIRA-PHA-001": {
        title: "Czas trwania faz",
        unlock: "Rozpoczynaj i kończ każdą fazę w przebiegu projektu.",
      },
      "MIRA-PHA-002": {
        title: "Czas oczekiwania między fazami",
        unlock: "Zakończ każdą fazę i rozpocznij następną w przebiegu projektu.",
      },
      "MIRA-PHA-003": {
        title: "Czas do oceny szkody",
        unlock: "Zarejestruj nawiązanie kontaktu (K1) w każdym projekcie.",
      },
      "MIRA-PHA-004": {
        title: "Czas do przydziału urządzeń",
        unlock: "Przypisz ustawione urządzenia do projektu.",
      },
      "MIRA-PHA-006": {
        title: "Czas do odtworzenia",
        unlock: "Za mało projektów z odtworzeniem w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-010": {
        title: "Źródło zapisu według fazy",
        unlock: "Źródło zapisu jest zapisywane dopiero od 2025 roku, dla starszych okresów go brak.",
      },
      "MIRA-PHA-011": {
        title: "Przebieg projektu",
        unlock: "W każdym projekcie zakończ po kolei oględziny szkody, montaż osuszania, koniec osuszania i koniec projektu.",
      },
      "MIRA-PHA-012": {
        title: "Od rozpoczęcia projektu do zlecenia",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-013": {
        title: "Od zlecenia do wykrywania nieszczelności / oceny szkody",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-014": {
        title: "Od wykrywania nieszczelności do oceny szkody",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-015": {
        title: "Od oceny szkody do rozpoczęcia osuszania",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-016": {
        title: "Od oceny szkody do zatwierdzenia",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-017": {
        title: "Od zatwierdzenia do rozpoczęcia osuszania / odtworzenia",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-018": {
        title: "Czas osuszania",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-019": {
        title: "Od zakończenia osuszania do zakończenia odtworzenia",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-020": {
        title: "Czas odtworzenia",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-021": {
        title: "Do zakończenia projektu",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PHA-022": {
        title: "Od zlecenia do rozpoczęcia osuszania",
        unlock: "Za mało zakończonych projektów z oboma krokami w tym okresie. Wskaźnik pojawi się, gdy będzie ich wystarczająco dużo.",
      },
      "MIRA-PRJ-017": {
        title: "Usługi",
        unlock: "W każdym projekcie zakończ wykonane usługi.",
      },
      "MIRA-DRY-001": {
        title: "Średni czas osuszania bez projektu (HyDry)",
        unlock: "Za mało osuszań HyDry bez projektu ze znanym początkiem i końcem w tym okresie.",
      },
      "MIRA-DRY-002": {
        title: "Udział przerw bez projektu (HyDry)",
        unlock: "Za mało osuszań HyDry bez projektu z w pełni znanymi przerwami w tym okresie.",
      },
      "MIRA-DRY-003": {
        title: "Średni czas osuszania konwencjonalnego",
        unlock: "Za mało zakończonych projektów osuszanych wyłącznie własnymi urządzeniami. Przypisuj urządzenia na rzeczywisty czas osuszania.",
      },
      "MIRA-DRY-009": {
        title: "Średni czas osuszania na projekt (HyDry)",
        unlock: "Za mało zakończonych projektów osuszanych urządzeniami HyDry. Przypisuj urządzenia do projektu z początkiem i końcem.",
      },
      "MIRA-DRY-010": {
        title: "Średni czas osuszania na projekt (konwencjonalnie)",
        unlock: "Za mało zakończonych projektów osuszanych wyłącznie urządzeniami konwencjonalnymi. Przypisuj urządzenia do projektu z początkiem i końcem.",
      },
      "MIRA-DRY-011": {
        title: "Udział przerw na projekt (HyDry)",
        unlock: "Za mało zakończonych projektów HyDry z w pełni znanymi przerwami w tym okresie.",
      },
      "MIRA-DRY-005": {
        title: "Częstotliwość pomiarów",
        unlock: "Zapisz w protokole pomiarów pomiar przy ustawieniu i przy demontażu osuszania.",
      },
      "MIRA-DRY-012": {
        title: "Pomiary pośrednie na projekt",
        unlock: "Zapisz w protokole pomiarów pomiar przy ustawieniu osuszania.",
      },
      "MIRA-DRY-007": {
        title: "Średnia powierzchnia osuszania",
        unlock: "Zapisz w ocenie szkody dotknięte elementy budynku wraz z ich powierzchnią.",
      },
      "MIRA-DRY-008": {
        title: "Prognoza i rzeczywisty czas osuszania",
        unlock: "Wpisz prognozę czasu osuszania i przypisz urządzenia do projektu.",
      },
      "MIRA-DEV-001": {
        title: "Dni urządzeń",
        unlock: "Przypisz urządzenia do projektu z datą początku i końca.",
      },
      "MIRA-DEV-002": {
        title: "Godziny pracy",
        unlock: "Zapisz godziny pracy przy demontażu innych urządzeń.",
      },
      "MIRA-DEV-003": {
        title: "Urządzenia na projekt",
        unlock: "Przypisz użyte urządzenia do projektów.",
      },
      "MIRA-DEV-015": {
        title: "HyDry Control na projekt",
        unlock: "Za mało zakończonych projektów z Box lub Mini w okresie.",
      },
      "MIRA-DEV-016": {
        title: "Projekty z HyDry Control",
        unlock: "Przypisz użyte urządzenia do projektów.",
      },
      "MIRA-DEV-017": {
        title: "Urządzenia na projekt (firmy z własnymi urządzeniami)",
      },
      "MIRA-DEV-018": {
        title: "Urządzenia na projekt (tylko HyDry)",
      },
      "MIRA-DEV-004": {
        title: "Zużycie prądu",
        unlock: "Zapisz stany liczników urządzeń przy ustawieniu i demontażu.",
      },
      "MIRA-DEV-005": {
        title: "Średnie zużycie prądu na projekt",
        unlock: "Za mało projektów z kompletnymi stanami liczników w tym okresie.",
      },
      "MIRA-DEV-006": {
        title: "Wykorzystanie floty",
        unlock: "Za mało danych o twoim stanie urządzeń w tym okresie.",
      },
      "MIRA-DEV-011": {
        title: "Wykorzystanie floty Box",
        unlock: "Za mało danych o twoich urządzeniach Box w tym okresie.",
      },
      "MIRA-DEV-012": {
        title: "Wykorzystanie floty Mini",
        unlock: "Za mało danych o twoich urządzeniach Mini w tym okresie.",
      },
      "MIRA-DEV-013": {
        title: "Wykorzystanie floty Panel",
        unlock: "Za mało danych o twoich urządzeniach Panel w tym okresie.",
      },
      "MIRA-DEV-014": {
        title: "Wykorzystanie własnych urządzeń",
        unlock: "Za mało danych o twoich własnych urządzeniach w tym okresie.",
      },
      "MIRA-DEV-009": {
        title: "Śr. zużycie energii na dzień osuszania",
        unlock: "Za mało projektów z kompletnymi stanami liczników w tym okresie.",
      },
      "MIRA-DEV-010": {
        title: "Zużycie energii na m² powierzchni osuszania",
        unlock: "Za mało zakończonych projektów z powierzchnią osuszania i stanami liczników w tym okresie.",
      },
      "MIRA-DEV-008": {
        title: "Rozkład kategorii / szablonów",
        unlock: "Nadaj swoim urządzeniom prawidłową kategorię i prawidłowy szablon.",
      },
      "MIRA-INS-001": {
        title: "Projekty według ubezpieczyciela",
      },
      "MIRA-INS-002": {
        title: "Średni czas trwania projektu według ubezpieczyciela",
      },
      "MIRA-INS-003": {
        title: "Wskaźnik przypisania ubezpieczycieli",
        unlock: "Podaj ubezpieczyciela w każdym projekcie.",
      },
      "MIRA-INS-004": {
        title: "Czas zatwierdzenia",
        unlock: "Za mało ofert z odpowiedzią ubezpieczyciela w tym okresie.",
      },
      "MIRA-INS-005": {
        title: "Wskaźnik akceptacji ofert",
        unlock: "Za mało ofert z odpowiedzią ubezpieczyciela w tym okresie.",
      },
      "MIRA-INS-006": {
        title: "Zatwierdzony i rzeczywisty czas osuszania",
        unlock: "Za mało zaakceptowanych ofert z zatwierdzonym czasem osuszania w tym okresie.",
      },
      "MIRA-INS-008": {
        title: "Zlecenia bezpośrednie",
        unlock: "Zarejestruj zlecenie bezpośrednie przy projekcie.",
      },
      "MIRA-DQ-001": {
        title: "Wypełnienie pól",
      },
      "MIRA-DQ-002": {
        title: "Pokrycie odczytów liczników",
      },
      "MIRA-PRJ-001": {
        title: "Projekty",
      },
      "MIRA-PRJ-002": {
        title: "Średni czas trwania projektu",
      },
      "MIRA-PRJ-004": {
        title: "Wskaźnik odrzuceń",
      },
      "MIRA-PHA-005": {
        title: "Czas do demontażu osuszania",
      },
      "MIRA-PHA-007": {
        title: "Czas do zakończenia projektu",
      },
      "MIRA-DRY-004": {
        title: "Przewaga HyDry nad osuszaniem konwencjonalnym",
      },
      "MIRA-DRY-006": {
        title: "Skuteczność osuszania",
      },
    },
  },
  maps: {
    city: "Miejscowość",
    postalCode: "Kod pocztowy",
    street: "Ulica",
    houseNumber: "Numer domu",
    result: "Wynik",
    start: "Start",
    destination: "Cel",
    deleteMarkers: "Usuń znaczniki",
    deleteRoutes: "Usuń trasy",
    geocode: "Szukaj adresu",
    showRoute: "Pokaż trasę",
    noAddress: "Proszę podać co najmniej miejscowość, ulicę lub kod pocztowy.",
    geocodingFailed: "Nie znaleziono adresu.",
    routeMissingAddresses: "Proszę podać start i cel.",
    routeFailed: "Nie można obliczyć trasy.",
    distance: "Odległość",
    duration: "Czas przejazdu",
  },
  timeTrackingHistory: {
    dayEntries: "Wpisy dnia",
    noEntries: "Brak wpisów na ten dzień.",
    selectDayHint: "Proszę wybrać dzień w kalendarzu.",
    daySummary: "Podsumowanie dnia",
    dayClosed: "Dzień zamknięty",
    dayOpen: "Dzień otwarty",
    today: "Dzisiaj",
    projectWork: "Praca projektowa",
    projectTime: "Czas projektu",
    activeProjectEntries: "Aktywny projekt – Wpisy",
    lastProjectEntries: "Ostatni projekt – Wpisy",
    projectEntries: "Projekt – Wpisy",
    backToActiveProject: "Wróć do aktywnego projektu",
    backToLastProject: "Wróć do ostatniego projektu",
    noProjectEntries: "Brak wpisów projektu.",
    loadingProjectEntries: "Ładowanie wpisów projektu…",
    projectArchived: "Zarchiwizowany",
    projectDeleted: "Usunięty",
    mergedEntriesTooltip: "Połączono z {count} wpisów",
    startOfDay: "Początek dnia",
    endOfDay: "Koniec dnia",
    columns: {
      time: "Godzina",
      duration: "Czas trwania",
      description: "Opis",
      timeRange: "Zakres czasu",
      date: "Data",
      phase: "Faza",
      project: "Projekt",
      user: "Użytkownik",
      source: "Źródło",
    },
    phases: {
      damageAssessment: "Ocena szkód",
      leakDetection: "Wykrywanie wycieków",
      drying: "Suszenie",
      dryingPreparation: "Montaż suszenia",
      repair: "Odbudowa",
    },
    tasks: {
      orderEntry: "Nawiąż kontakt",
      firstContact: "Pierwszy kontakt",
      leakDetection: "Wykrywanie wycieków",
      damageAssessment: "Ocena szkód",
      insuranceOffer: "Oferta ubezpieczeniowa",
      dryingApproval: "Zatwierdzenie suszenia",
      dryingPreparation: "Montaż suszenia",
      intermediateMeasurement: "Pomiar",
      dryingConclusion: "Demontaż suszenia",
      repair: "Odbudowa",
      projectConclusion: "Projekt zakończony",
    },
    travel: {
      toOffice: "Przejazd do biura",
      toHome: "Przejazd do domu",
      toProject: "Dojazd pod adres",
      approach: "Dojazd",
    },
    autoContext: {
      prepareDrying: "Przygotowanie suszenia",
      finalMeasurement: "Pomiar końcowy",
      finalResubmission: "Ponowne przedłożenie końcowe",
      finalDrying: "Suszenie końcowe",
    },
    categories: {
      pause: "Przerwa",
      travelingTime: "Czas przejazdu",
      internal: "Wewnętrzne",
      other: "Inne",
      general: "Ogólne",
      interruption: "Przerwa w pracy",
      silentInterruption: "Cicha przerwa",
    },
    summary: {
      totalTime: "Zarejestrowany czas",
      workingTime: "Obliczony czas pracy",
      travelTime: "Czas przejazdu",
      projectTime: "Czas projektu",
      internalWork: "Prace wewnętrzne",
      pause: "Przerwa",
      unexplained: "Niewyjaśnione",
    },
    markerReasons: {
      overlapStart: "Czas rozpoczęcia nakłada się na inny wpis.",
      overlapEnd: "Czas zakończenia jest nakładany przez inny wpis.",
      dayClamped: "Wartość została ograniczona do granicy wybranego dnia.",
      crossDay: "Wpis obejmuje wiele dni.",
      adjustedData: "Znacznik czasu został dostosowany z powodu niespójnych danych źródłowych.",
      mergedBoundary: "Wyświetlana granica pochodzi z połączonych sąsiednich wpisów (w ramach skonfigurowanej luki scalania).",
    },
  },
  staleEntryAutoClose: {
    title: "Wpis czasu zamknięty automatycznie",
    subtitle: "Automatycznie zamknęliśmy to zadanie, ponieważ nie zarejestrowano od Ciebie dalszej aktywności.\nCzy chcesz dostosować swój czas zakończenia?",
    projectEntryLabel: "Praca projektowa: {project}",
    projectEntryLabelFallback: "Praca projektowa",
    otherEntryLabel: "Wpis ogólny",
    proposedEndLabel: "Proponowany czas zakończenia",
    editHint: "Dostosuj czas zakończenia",
    accept: "Potwierdź",
    invalidTime: "Nieprawidłowy czas.",
    successMessage: "Wpis czasu został zamknięty.",
  },
};
